import 'intersection-observer';
import React, { createContext, PureComponent, useContext, Fragment, createRef, Children, cloneElement, useState } from 'react';
import styled, { keyframes, css as css$6, ThemeProvider } from 'styled-components';
import produce from 'immer';
import mobileCheck from 'is-mobile';
import withStorageContextManager, { withStorageContext } from 'react-storage-context';
import { bestfit, getSpecificRendition, getBestRenditionUrl, getAltText, getGifHeight, checkIfWebP } from '@giphy/js-util';
import { omit as omit$1, pull as pull$1, isEmpty as isEmpty$1 } from 'lodash';
import 'fullscreen-polyfill';
import Clipboard from 'clipboard';
import { InView, useInView } from 'react-intersection-observer';
import moat from '@giphy/moat';
import PropTypes from 'prop-types';
import Pikaday from 'pikaday';
import { format, differenceInMonths, distanceInWordsToNow } from 'date-fns';
import hexToRgba from 'hex-rgba';
import Truncate from 'react-truncate';

/* greys */
var giphyBlack = '#121212';
var giphyDarkestGrey = '#212121';
var giphyDarkGrey = '#2e2e2e';
var giphyDarkCharcoal = '#3e3e3e';
var giphyCharcoal = '#4a4a4a';
var giphyLightCharcoal = '#5c5c5c';
var giphyLightGrey = '#a6a6a6';
var giphyLightestGrey = '#d8d8d8';
var giphyWhite = '#ffffff';
/* primary */

var giphyBlue = '#00ccff';
var giphyGreen = '#00ff99';
var giphyPurple = '#9933ff';
var giphyRed = '#ff6666';
var giphyYellow = '#fff35c';
/* secondary */

var giphyAqua = '#00e6cc';
var giphyLightBlue = '#3191ff';
var giphyIndigo = '#6157ff';
var giphyPink = '#e646b6';
/* social */

var facebookColor = '#3894fc';
var twitterColor = '#00ccff';
var pinterestColor = '#e54cb5';
var tumblrColor = '#529ecc';
var instagramColor = '#c23c8d';
var redditColor = '#fc6669';
var smsColor = '#00ff99';
/* functional */

var errorColor = giphyRed;
var deleteColor = giphyRed;
var primaryCTA = giphyIndigo;
var primaryCTADisabled = '#241F74';
var secondaryCTA = giphyCharcoal;
var dimColor = "rgba(0, 0, 0, 0.8)";
var gifOverlayColor = "rgba(0, 0, 0, 0.4)";

var colorsForExp = /*#__PURE__*/Object.freeze({
    __proto__: null,
    giphyBlack: giphyBlack,
    giphyDarkestGrey: giphyDarkestGrey,
    giphyDarkGrey: giphyDarkGrey,
    giphyDarkCharcoal: giphyDarkCharcoal,
    giphyCharcoal: giphyCharcoal,
    giphyLightCharcoal: giphyLightCharcoal,
    giphyLightGrey: giphyLightGrey,
    giphyLightestGrey: giphyLightestGrey,
    giphyWhite: giphyWhite,
    giphyBlue: giphyBlue,
    giphyGreen: giphyGreen,
    giphyPurple: giphyPurple,
    giphyRed: giphyRed,
    giphyYellow: giphyYellow,
    giphyAqua: giphyAqua,
    giphyLightBlue: giphyLightBlue,
    giphyIndigo: giphyIndigo,
    giphyPink: giphyPink,
    facebookColor: facebookColor,
    twitterColor: twitterColor,
    pinterestColor: pinterestColor,
    tumblrColor: tumblrColor,
    instagramColor: instagramColor,
    redditColor: redditColor,
    smsColor: smsColor,
    errorColor: errorColor,
    deleteColor: deleteColor,
    primaryCTA: primaryCTA,
    primaryCTADisabled: primaryCTADisabled,
    secondaryCTA: secondaryCTA,
    dimColor: dimColor,
    gifOverlayColor: gifOverlayColor
});

/*! *****************************************************************************
Copyright (c) Microsoft Corporation. All rights reserved.
Licensed under the Apache License, Version 2.0 (the "License"); you may not use
this file except in compliance with the License. You may obtain a copy of the
License at http://www.apache.org/licenses/LICENSE-2.0

THIS CODE IS PROVIDED ON AN *AS IS* BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
KIND, EITHER EXPRESS OR IMPLIED, INCLUDING WITHOUT LIMITATION ANY IMPLIED
WARRANTIES OR CONDITIONS OF TITLE, FITNESS FOR A PARTICULAR PURPOSE,
MERCHANTABLITY OR NON-INFRINGEMENT.

See the Apache Version 2.0 License for specific language governing permissions
and limitations under the License.
***************************************************************************** */
/* global Reflect, Promise */

var extendStatics = function(d, b) {
    extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return extendStatics(d, b);
};

function __extends(d, b) {
    extendStatics(d, b);
    function __() { this.constructor = d; }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
}

var __assign = function() {
    __assign = Object.assign || function __assign(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};

function __awaiter(thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
}

function __generator(thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
}

function __makeTemplateObject(cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
}

var Container = styled.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n    display: flex;\n    position: relative;\n    width: ", "px;\n    height: ", "px;\n    overflow: hidden;\n"], ["\n    display: flex;\n    position: relative;\n    width: ", "px;\n    height: ", "px;\n    overflow: hidden;\n"])), function (props) { return props.width; }, function (props) { return props.height; });
var templateObject_1;

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

var classCallCheck = _classCallCheck;

var commonjsGlobal = typeof globalThis !== 'undefined' ? globalThis : typeof window !== 'undefined' ? window : typeof global !== 'undefined' ? global : typeof self !== 'undefined' ? self : {};

function createCommonjsModule(fn, module) {
	return module = { exports: {} }, fn(module, module.exports), module.exports;
}

var _typeof_1 = createCommonjsModule(function (module) {
function _typeof2(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof2 = function _typeof2(obj) { return typeof obj; }; } else { _typeof2 = function _typeof2(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof2(obj); }

function _typeof(obj) {
  if (typeof Symbol === "function" && _typeof2(Symbol.iterator) === "symbol") {
    module.exports = _typeof = function _typeof(obj) {
      return _typeof2(obj);
    };
  } else {
    module.exports = _typeof = function _typeof(obj) {
      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : _typeof2(obj);
    };
  }

  return _typeof(obj);
}

module.exports = _typeof;
});

function _assertThisInitialized(self) {
  if (self === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return self;
}

var assertThisInitialized = _assertThisInitialized;

function _possibleConstructorReturn(self, call) {
  if (call && (_typeof_1(call) === "object" || typeof call === "function")) {
    return call;
  }

  return assertThisInitialized(self);
}

var possibleConstructorReturn = _possibleConstructorReturn;

var getPrototypeOf = createCommonjsModule(function (module) {
function _getPrototypeOf(o) {
  module.exports = _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
    return o.__proto__ || Object.getPrototypeOf(o);
  };
  return _getPrototypeOf(o);
}

module.exports = _getPrototypeOf;
});

function _defineProperties(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor) descriptor.writable = true;
    Object.defineProperty(target, descriptor.key, descriptor);
  }
}

function _createClass(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties(Constructor.prototype, protoProps);
  if (staticProps) _defineProperties(Constructor, staticProps);
  return Constructor;
}

var createClass = _createClass;

var setPrototypeOf = createCommonjsModule(function (module) {
function _setPrototypeOf(o, p) {
  module.exports = _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
    o.__proto__ = p;
    return o;
  };

  return _setPrototypeOf(o, p);
}

module.exports = _setPrototypeOf;
});

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function");
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      writable: true,
      configurable: true
    }
  });
  if (superClass) setPrototypeOf(subClass, superClass);
}

var inherits = _inherits;

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

var defineProperty = _defineProperty;

var _extends_1 = createCommonjsModule(function (module) {
function _extends() {
  module.exports = _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
}

module.exports = _extends;
});

/**
 * A specialized version of `_.map` for arrays without support for iteratee
 * shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns the new mapped array.
 */
function arrayMap(array, iteratee) {
  var index = -1,
      length = array == null ? 0 : array.length,
      result = Array(length);

  while (++index < length) {
    result[index] = iteratee(array[index], index, array);
  }
  return result;
}

var _arrayMap = arrayMap;

/**
 * Removes all key-value entries from the list cache.
 *
 * @private
 * @name clear
 * @memberOf ListCache
 */
function listCacheClear() {
  this.__data__ = [];
  this.size = 0;
}

var _listCacheClear = listCacheClear;

/**
 * Performs a
 * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
 * comparison between two values to determine if they are equivalent.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
 * @example
 *
 * var object = { 'a': 1 };
 * var other = { 'a': 1 };
 *
 * _.eq(object, object);
 * // => true
 *
 * _.eq(object, other);
 * // => false
 *
 * _.eq('a', 'a');
 * // => true
 *
 * _.eq('a', Object('a'));
 * // => false
 *
 * _.eq(NaN, NaN);
 * // => true
 */
function eq(value, other) {
  return value === other || (value !== value && other !== other);
}

var eq_1 = eq;

/**
 * Gets the index at which the `key` is found in `array` of key-value pairs.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {*} key The key to search for.
 * @returns {number} Returns the index of the matched value, else `-1`.
 */
function assocIndexOf(array, key) {
  var length = array.length;
  while (length--) {
    if (eq_1(array[length][0], key)) {
      return length;
    }
  }
  return -1;
}

var _assocIndexOf = assocIndexOf;

/** Used for built-in method references. */
var arrayProto = Array.prototype;

/** Built-in value references. */
var splice = arrayProto.splice;

/**
 * Removes `key` and its value from the list cache.
 *
 * @private
 * @name delete
 * @memberOf ListCache
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */
function listCacheDelete(key) {
  var data = this.__data__,
      index = _assocIndexOf(data, key);

  if (index < 0) {
    return false;
  }
  var lastIndex = data.length - 1;
  if (index == lastIndex) {
    data.pop();
  } else {
    splice.call(data, index, 1);
  }
  --this.size;
  return true;
}

var _listCacheDelete = listCacheDelete;

/**
 * Gets the list cache value for `key`.
 *
 * @private
 * @name get
 * @memberOf ListCache
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */
function listCacheGet(key) {
  var data = this.__data__,
      index = _assocIndexOf(data, key);

  return index < 0 ? undefined : data[index][1];
}

var _listCacheGet = listCacheGet;

/**
 * Checks if a list cache value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf ListCache
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function listCacheHas(key) {
  return _assocIndexOf(this.__data__, key) > -1;
}

var _listCacheHas = listCacheHas;

/**
 * Sets the list cache `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf ListCache
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the list cache instance.
 */
function listCacheSet(key, value) {
  var data = this.__data__,
      index = _assocIndexOf(data, key);

  if (index < 0) {
    ++this.size;
    data.push([key, value]);
  } else {
    data[index][1] = value;
  }
  return this;
}

var _listCacheSet = listCacheSet;

/**
 * Creates an list cache object.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */
function ListCache(entries) {
  var index = -1,
      length = entries == null ? 0 : entries.length;

  this.clear();
  while (++index < length) {
    var entry = entries[index];
    this.set(entry[0], entry[1]);
  }
}

// Add methods to `ListCache`.
ListCache.prototype.clear = _listCacheClear;
ListCache.prototype['delete'] = _listCacheDelete;
ListCache.prototype.get = _listCacheGet;
ListCache.prototype.has = _listCacheHas;
ListCache.prototype.set = _listCacheSet;

var _ListCache = ListCache;

/**
 * Removes all key-value entries from the stack.
 *
 * @private
 * @name clear
 * @memberOf Stack
 */
function stackClear() {
  this.__data__ = new _ListCache;
  this.size = 0;
}

var _stackClear = stackClear;

/**
 * Removes `key` and its value from the stack.
 *
 * @private
 * @name delete
 * @memberOf Stack
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */
function stackDelete(key) {
  var data = this.__data__,
      result = data['delete'](key);

  this.size = data.size;
  return result;
}

var _stackDelete = stackDelete;

/**
 * Gets the stack value for `key`.
 *
 * @private
 * @name get
 * @memberOf Stack
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */
function stackGet(key) {
  return this.__data__.get(key);
}

var _stackGet = stackGet;

/**
 * Checks if a stack value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf Stack
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function stackHas(key) {
  return this.__data__.has(key);
}

var _stackHas = stackHas;

/** Detect free variable `global` from Node.js. */
var freeGlobal = typeof commonjsGlobal == 'object' && commonjsGlobal && commonjsGlobal.Object === Object && commonjsGlobal;

var _freeGlobal = freeGlobal;

/** Detect free variable `self`. */
var freeSelf = typeof self == 'object' && self && self.Object === Object && self;

/** Used as a reference to the global object. */
var root = _freeGlobal || freeSelf || Function('return this')();

var _root = root;

/** Built-in value references. */
var Symbol$1 = _root.Symbol;

var _Symbol = Symbol$1;

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */
var nativeObjectToString = objectProto.toString;

/** Built-in value references. */
var symToStringTag = _Symbol ? _Symbol.toStringTag : undefined;

/**
 * A specialized version of `baseGetTag` which ignores `Symbol.toStringTag` values.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the raw `toStringTag`.
 */
function getRawTag(value) {
  var isOwn = hasOwnProperty.call(value, symToStringTag),
      tag = value[symToStringTag];

  try {
    value[symToStringTag] = undefined;
    var unmasked = true;
  } catch (e) {}

  var result = nativeObjectToString.call(value);
  if (unmasked) {
    if (isOwn) {
      value[symToStringTag] = tag;
    } else {
      delete value[symToStringTag];
    }
  }
  return result;
}

var _getRawTag = getRawTag;

/** Used for built-in method references. */
var objectProto$1 = Object.prototype;

/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */
var nativeObjectToString$1 = objectProto$1.toString;

/**
 * Converts `value` to a string using `Object.prototype.toString`.
 *
 * @private
 * @param {*} value The value to convert.
 * @returns {string} Returns the converted string.
 */
function objectToString(value) {
  return nativeObjectToString$1.call(value);
}

var _objectToString = objectToString;

/** `Object#toString` result references. */
var nullTag = '[object Null]',
    undefinedTag = '[object Undefined]';

/** Built-in value references. */
var symToStringTag$1 = _Symbol ? _Symbol.toStringTag : undefined;

/**
 * The base implementation of `getTag` without fallbacks for buggy environments.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the `toStringTag`.
 */
function baseGetTag(value) {
  if (value == null) {
    return value === undefined ? undefinedTag : nullTag;
  }
  return (symToStringTag$1 && symToStringTag$1 in Object(value))
    ? _getRawTag(value)
    : _objectToString(value);
}

var _baseGetTag = baseGetTag;

/**
 * Checks if `value` is the
 * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
 * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
 * @example
 *
 * _.isObject({});
 * // => true
 *
 * _.isObject([1, 2, 3]);
 * // => true
 *
 * _.isObject(_.noop);
 * // => true
 *
 * _.isObject(null);
 * // => false
 */
function isObject(value) {
  var type = typeof value;
  return value != null && (type == 'object' || type == 'function');
}

var isObject_1 = isObject;

/** `Object#toString` result references. */
var asyncTag = '[object AsyncFunction]',
    funcTag = '[object Function]',
    genTag = '[object GeneratorFunction]',
    proxyTag = '[object Proxy]';

/**
 * Checks if `value` is classified as a `Function` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a function, else `false`.
 * @example
 *
 * _.isFunction(_);
 * // => true
 *
 * _.isFunction(/abc/);
 * // => false
 */
function isFunction(value) {
  if (!isObject_1(value)) {
    return false;
  }
  // The use of `Object#toString` avoids issues with the `typeof` operator
  // in Safari 9 which returns 'object' for typed arrays and other constructors.
  var tag = _baseGetTag(value);
  return tag == funcTag || tag == genTag || tag == asyncTag || tag == proxyTag;
}

var isFunction_1 = isFunction;

/** Used to detect overreaching core-js shims. */
var coreJsData = _root['__core-js_shared__'];

var _coreJsData = coreJsData;

/** Used to detect methods masquerading as native. */
var maskSrcKey = (function() {
  var uid = /[^.]+$/.exec(_coreJsData && _coreJsData.keys && _coreJsData.keys.IE_PROTO || '');
  return uid ? ('Symbol(src)_1.' + uid) : '';
}());

/**
 * Checks if `func` has its source masked.
 *
 * @private
 * @param {Function} func The function to check.
 * @returns {boolean} Returns `true` if `func` is masked, else `false`.
 */
function isMasked(func) {
  return !!maskSrcKey && (maskSrcKey in func);
}

var _isMasked = isMasked;

/** Used for built-in method references. */
var funcProto = Function.prototype;

/** Used to resolve the decompiled source of functions. */
var funcToString = funcProto.toString;

/**
 * Converts `func` to its source code.
 *
 * @private
 * @param {Function} func The function to convert.
 * @returns {string} Returns the source code.
 */
function toSource(func) {
  if (func != null) {
    try {
      return funcToString.call(func);
    } catch (e) {}
    try {
      return (func + '');
    } catch (e) {}
  }
  return '';
}

var _toSource = toSource;

/**
 * Used to match `RegExp`
 * [syntax characters](http://ecma-international.org/ecma-262/7.0/#sec-patterns).
 */
var reRegExpChar = /[\\^$.*+?()[\]{}|]/g;

/** Used to detect host constructors (Safari). */
var reIsHostCtor = /^\[object .+?Constructor\]$/;

/** Used for built-in method references. */
var funcProto$1 = Function.prototype,
    objectProto$2 = Object.prototype;

/** Used to resolve the decompiled source of functions. */
var funcToString$1 = funcProto$1.toString;

/** Used to check objects for own properties. */
var hasOwnProperty$1 = objectProto$2.hasOwnProperty;

/** Used to detect if a method is native. */
var reIsNative = RegExp('^' +
  funcToString$1.call(hasOwnProperty$1).replace(reRegExpChar, '\\$&')
  .replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, '$1.*?') + '$'
);

/**
 * The base implementation of `_.isNative` without bad shim checks.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a native function,
 *  else `false`.
 */
function baseIsNative(value) {
  if (!isObject_1(value) || _isMasked(value)) {
    return false;
  }
  var pattern = isFunction_1(value) ? reIsNative : reIsHostCtor;
  return pattern.test(_toSource(value));
}

var _baseIsNative = baseIsNative;

/**
 * Gets the value at `key` of `object`.
 *
 * @private
 * @param {Object} [object] The object to query.
 * @param {string} key The key of the property to get.
 * @returns {*} Returns the property value.
 */
function getValue(object, key) {
  return object == null ? undefined : object[key];
}

var _getValue = getValue;

/**
 * Gets the native function at `key` of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {string} key The key of the method to get.
 * @returns {*} Returns the function if it's native, else `undefined`.
 */
function getNative(object, key) {
  var value = _getValue(object, key);
  return _baseIsNative(value) ? value : undefined;
}

var _getNative = getNative;

/* Built-in method references that are verified to be native. */
var Map = _getNative(_root, 'Map');

var _Map = Map;

/* Built-in method references that are verified to be native. */
var nativeCreate = _getNative(Object, 'create');

var _nativeCreate = nativeCreate;

/**
 * Removes all key-value entries from the hash.
 *
 * @private
 * @name clear
 * @memberOf Hash
 */
function hashClear() {
  this.__data__ = _nativeCreate ? _nativeCreate(null) : {};
  this.size = 0;
}

var _hashClear = hashClear;

/**
 * Removes `key` and its value from the hash.
 *
 * @private
 * @name delete
 * @memberOf Hash
 * @param {Object} hash The hash to modify.
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */
function hashDelete(key) {
  var result = this.has(key) && delete this.__data__[key];
  this.size -= result ? 1 : 0;
  return result;
}

var _hashDelete = hashDelete;

/** Used to stand-in for `undefined` hash values. */
var HASH_UNDEFINED = '__lodash_hash_undefined__';

/** Used for built-in method references. */
var objectProto$3 = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty$2 = objectProto$3.hasOwnProperty;

/**
 * Gets the hash value for `key`.
 *
 * @private
 * @name get
 * @memberOf Hash
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */
function hashGet(key) {
  var data = this.__data__;
  if (_nativeCreate) {
    var result = data[key];
    return result === HASH_UNDEFINED ? undefined : result;
  }
  return hasOwnProperty$2.call(data, key) ? data[key] : undefined;
}

var _hashGet = hashGet;

/** Used for built-in method references. */
var objectProto$4 = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty$3 = objectProto$4.hasOwnProperty;

/**
 * Checks if a hash value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf Hash
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function hashHas(key) {
  var data = this.__data__;
  return _nativeCreate ? (data[key] !== undefined) : hasOwnProperty$3.call(data, key);
}

var _hashHas = hashHas;

/** Used to stand-in for `undefined` hash values. */
var HASH_UNDEFINED$1 = '__lodash_hash_undefined__';

/**
 * Sets the hash `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf Hash
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the hash instance.
 */
function hashSet(key, value) {
  var data = this.__data__;
  this.size += this.has(key) ? 0 : 1;
  data[key] = (_nativeCreate && value === undefined) ? HASH_UNDEFINED$1 : value;
  return this;
}

var _hashSet = hashSet;

/**
 * Creates a hash object.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */
function Hash(entries) {
  var index = -1,
      length = entries == null ? 0 : entries.length;

  this.clear();
  while (++index < length) {
    var entry = entries[index];
    this.set(entry[0], entry[1]);
  }
}

// Add methods to `Hash`.
Hash.prototype.clear = _hashClear;
Hash.prototype['delete'] = _hashDelete;
Hash.prototype.get = _hashGet;
Hash.prototype.has = _hashHas;
Hash.prototype.set = _hashSet;

var _Hash = Hash;

/**
 * Removes all key-value entries from the map.
 *
 * @private
 * @name clear
 * @memberOf MapCache
 */
function mapCacheClear() {
  this.size = 0;
  this.__data__ = {
    'hash': new _Hash,
    'map': new (_Map || _ListCache),
    'string': new _Hash
  };
}

var _mapCacheClear = mapCacheClear;

/**
 * Checks if `value` is suitable for use as unique object key.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is suitable, else `false`.
 */
function isKeyable(value) {
  var type = typeof value;
  return (type == 'string' || type == 'number' || type == 'symbol' || type == 'boolean')
    ? (value !== '__proto__')
    : (value === null);
}

var _isKeyable = isKeyable;

/**
 * Gets the data for `map`.
 *
 * @private
 * @param {Object} map The map to query.
 * @param {string} key The reference key.
 * @returns {*} Returns the map data.
 */
function getMapData(map, key) {
  var data = map.__data__;
  return _isKeyable(key)
    ? data[typeof key == 'string' ? 'string' : 'hash']
    : data.map;
}

var _getMapData = getMapData;

/**
 * Removes `key` and its value from the map.
 *
 * @private
 * @name delete
 * @memberOf MapCache
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */
function mapCacheDelete(key) {
  var result = _getMapData(this, key)['delete'](key);
  this.size -= result ? 1 : 0;
  return result;
}

var _mapCacheDelete = mapCacheDelete;

/**
 * Gets the map value for `key`.
 *
 * @private
 * @name get
 * @memberOf MapCache
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */
function mapCacheGet(key) {
  return _getMapData(this, key).get(key);
}

var _mapCacheGet = mapCacheGet;

/**
 * Checks if a map value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf MapCache
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function mapCacheHas(key) {
  return _getMapData(this, key).has(key);
}

var _mapCacheHas = mapCacheHas;

/**
 * Sets the map `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf MapCache
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the map cache instance.
 */
function mapCacheSet(key, value) {
  var data = _getMapData(this, key),
      size = data.size;

  data.set(key, value);
  this.size += data.size == size ? 0 : 1;
  return this;
}

var _mapCacheSet = mapCacheSet;

/**
 * Creates a map cache object to store key-value pairs.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */
function MapCache(entries) {
  var index = -1,
      length = entries == null ? 0 : entries.length;

  this.clear();
  while (++index < length) {
    var entry = entries[index];
    this.set(entry[0], entry[1]);
  }
}

// Add methods to `MapCache`.
MapCache.prototype.clear = _mapCacheClear;
MapCache.prototype['delete'] = _mapCacheDelete;
MapCache.prototype.get = _mapCacheGet;
MapCache.prototype.has = _mapCacheHas;
MapCache.prototype.set = _mapCacheSet;

var _MapCache = MapCache;

/** Used as the size to enable large array optimizations. */
var LARGE_ARRAY_SIZE = 200;

/**
 * Sets the stack `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf Stack
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the stack cache instance.
 */
function stackSet(key, value) {
  var data = this.__data__;
  if (data instanceof _ListCache) {
    var pairs = data.__data__;
    if (!_Map || (pairs.length < LARGE_ARRAY_SIZE - 1)) {
      pairs.push([key, value]);
      this.size = ++data.size;
      return this;
    }
    data = this.__data__ = new _MapCache(pairs);
  }
  data.set(key, value);
  this.size = data.size;
  return this;
}

var _stackSet = stackSet;

/**
 * Creates a stack cache object to store key-value pairs.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */
function Stack(entries) {
  var data = this.__data__ = new _ListCache(entries);
  this.size = data.size;
}

// Add methods to `Stack`.
Stack.prototype.clear = _stackClear;
Stack.prototype['delete'] = _stackDelete;
Stack.prototype.get = _stackGet;
Stack.prototype.has = _stackHas;
Stack.prototype.set = _stackSet;

var _Stack = Stack;

/**
 * A specialized version of `_.forEach` for arrays without support for
 * iteratee shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns `array`.
 */
function arrayEach(array, iteratee) {
  var index = -1,
      length = array == null ? 0 : array.length;

  while (++index < length) {
    if (iteratee(array[index], index, array) === false) {
      break;
    }
  }
  return array;
}

var _arrayEach = arrayEach;

var defineProperty$1 = (function() {
  try {
    var func = _getNative(Object, 'defineProperty');
    func({}, '', {});
    return func;
  } catch (e) {}
}());

var _defineProperty$1 = defineProperty$1;

/**
 * The base implementation of `assignValue` and `assignMergeValue` without
 * value checks.
 *
 * @private
 * @param {Object} object The object to modify.
 * @param {string} key The key of the property to assign.
 * @param {*} value The value to assign.
 */
function baseAssignValue(object, key, value) {
  if (key == '__proto__' && _defineProperty$1) {
    _defineProperty$1(object, key, {
      'configurable': true,
      'enumerable': true,
      'value': value,
      'writable': true
    });
  } else {
    object[key] = value;
  }
}

var _baseAssignValue = baseAssignValue;

/** Used for built-in method references. */
var objectProto$5 = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty$4 = objectProto$5.hasOwnProperty;

/**
 * Assigns `value` to `key` of `object` if the existing value is not equivalent
 * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
 * for equality comparisons.
 *
 * @private
 * @param {Object} object The object to modify.
 * @param {string} key The key of the property to assign.
 * @param {*} value The value to assign.
 */
function assignValue(object, key, value) {
  var objValue = object[key];
  if (!(hasOwnProperty$4.call(object, key) && eq_1(objValue, value)) ||
      (value === undefined && !(key in object))) {
    _baseAssignValue(object, key, value);
  }
}

var _assignValue = assignValue;

/**
 * Copies properties of `source` to `object`.
 *
 * @private
 * @param {Object} source The object to copy properties from.
 * @param {Array} props The property identifiers to copy.
 * @param {Object} [object={}] The object to copy properties to.
 * @param {Function} [customizer] The function to customize copied values.
 * @returns {Object} Returns `object`.
 */
function copyObject(source, props, object, customizer) {
  var isNew = !object;
  object || (object = {});

  var index = -1,
      length = props.length;

  while (++index < length) {
    var key = props[index];

    var newValue = customizer
      ? customizer(object[key], source[key], key, object, source)
      : undefined;

    if (newValue === undefined) {
      newValue = source[key];
    }
    if (isNew) {
      _baseAssignValue(object, key, newValue);
    } else {
      _assignValue(object, key, newValue);
    }
  }
  return object;
}

var _copyObject = copyObject;

/**
 * The base implementation of `_.times` without support for iteratee shorthands
 * or max array length checks.
 *
 * @private
 * @param {number} n The number of times to invoke `iteratee`.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns the array of results.
 */
function baseTimes(n, iteratee) {
  var index = -1,
      result = Array(n);

  while (++index < n) {
    result[index] = iteratee(index);
  }
  return result;
}

var _baseTimes = baseTimes;

/**
 * Checks if `value` is object-like. A value is object-like if it's not `null`
 * and has a `typeof` result of "object".
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
 * @example
 *
 * _.isObjectLike({});
 * // => true
 *
 * _.isObjectLike([1, 2, 3]);
 * // => true
 *
 * _.isObjectLike(_.noop);
 * // => false
 *
 * _.isObjectLike(null);
 * // => false
 */
function isObjectLike(value) {
  return value != null && typeof value == 'object';
}

var isObjectLike_1 = isObjectLike;

/** `Object#toString` result references. */
var argsTag = '[object Arguments]';

/**
 * The base implementation of `_.isArguments`.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an `arguments` object,
 */
function baseIsArguments(value) {
  return isObjectLike_1(value) && _baseGetTag(value) == argsTag;
}

var _baseIsArguments = baseIsArguments;

/** Used for built-in method references. */
var objectProto$6 = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty$5 = objectProto$6.hasOwnProperty;

/** Built-in value references. */
var propertyIsEnumerable = objectProto$6.propertyIsEnumerable;

/**
 * Checks if `value` is likely an `arguments` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an `arguments` object,
 *  else `false`.
 * @example
 *
 * _.isArguments(function() { return arguments; }());
 * // => true
 *
 * _.isArguments([1, 2, 3]);
 * // => false
 */
var isArguments = _baseIsArguments(function() { return arguments; }()) ? _baseIsArguments : function(value) {
  return isObjectLike_1(value) && hasOwnProperty$5.call(value, 'callee') &&
    !propertyIsEnumerable.call(value, 'callee');
};

var isArguments_1 = isArguments;

/**
 * Checks if `value` is classified as an `Array` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an array, else `false`.
 * @example
 *
 * _.isArray([1, 2, 3]);
 * // => true
 *
 * _.isArray(document.body.children);
 * // => false
 *
 * _.isArray('abc');
 * // => false
 *
 * _.isArray(_.noop);
 * // => false
 */
var isArray = Array.isArray;

var isArray_1 = isArray;

/**
 * This method returns `false`.
 *
 * @static
 * @memberOf _
 * @since 4.13.0
 * @category Util
 * @returns {boolean} Returns `false`.
 * @example
 *
 * _.times(2, _.stubFalse);
 * // => [false, false]
 */
function stubFalse() {
  return false;
}

var stubFalse_1 = stubFalse;

var isBuffer_1 = createCommonjsModule(function (module, exports) {
/** Detect free variable `exports`. */
var freeExports =  exports && !exports.nodeType && exports;

/** Detect free variable `module`. */
var freeModule = freeExports && 'object' == 'object' && module && !module.nodeType && module;

/** Detect the popular CommonJS extension `module.exports`. */
var moduleExports = freeModule && freeModule.exports === freeExports;

/** Built-in value references. */
var Buffer = moduleExports ? _root.Buffer : undefined;

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeIsBuffer = Buffer ? Buffer.isBuffer : undefined;

/**
 * Checks if `value` is a buffer.
 *
 * @static
 * @memberOf _
 * @since 4.3.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a buffer, else `false`.
 * @example
 *
 * _.isBuffer(new Buffer(2));
 * // => true
 *
 * _.isBuffer(new Uint8Array(2));
 * // => false
 */
var isBuffer = nativeIsBuffer || stubFalse_1;

module.exports = isBuffer;
});

/** Used as references for various `Number` constants. */
var MAX_SAFE_INTEGER = 9007199254740991;

/** Used to detect unsigned integer values. */
var reIsUint = /^(?:0|[1-9]\d*)$/;

/**
 * Checks if `value` is a valid array-like index.
 *
 * @private
 * @param {*} value The value to check.
 * @param {number} [length=MAX_SAFE_INTEGER] The upper bounds of a valid index.
 * @returns {boolean} Returns `true` if `value` is a valid index, else `false`.
 */
function isIndex(value, length) {
  var type = typeof value;
  length = length == null ? MAX_SAFE_INTEGER : length;

  return !!length &&
    (type == 'number' ||
      (type != 'symbol' && reIsUint.test(value))) &&
        (value > -1 && value % 1 == 0 && value < length);
}

var _isIndex = isIndex;

/** Used as references for various `Number` constants. */
var MAX_SAFE_INTEGER$1 = 9007199254740991;

/**
 * Checks if `value` is a valid array-like length.
 *
 * **Note:** This method is loosely based on
 * [`ToLength`](http://ecma-international.org/ecma-262/7.0/#sec-tolength).
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a valid length, else `false`.
 * @example
 *
 * _.isLength(3);
 * // => true
 *
 * _.isLength(Number.MIN_VALUE);
 * // => false
 *
 * _.isLength(Infinity);
 * // => false
 *
 * _.isLength('3');
 * // => false
 */
function isLength(value) {
  return typeof value == 'number' &&
    value > -1 && value % 1 == 0 && value <= MAX_SAFE_INTEGER$1;
}

var isLength_1 = isLength;

/** `Object#toString` result references. */
var argsTag$1 = '[object Arguments]',
    arrayTag = '[object Array]',
    boolTag = '[object Boolean]',
    dateTag = '[object Date]',
    errorTag = '[object Error]',
    funcTag$1 = '[object Function]',
    mapTag = '[object Map]',
    numberTag = '[object Number]',
    objectTag = '[object Object]',
    regexpTag = '[object RegExp]',
    setTag = '[object Set]',
    stringTag = '[object String]',
    weakMapTag = '[object WeakMap]';

var arrayBufferTag = '[object ArrayBuffer]',
    dataViewTag = '[object DataView]',
    float32Tag = '[object Float32Array]',
    float64Tag = '[object Float64Array]',
    int8Tag = '[object Int8Array]',
    int16Tag = '[object Int16Array]',
    int32Tag = '[object Int32Array]',
    uint8Tag = '[object Uint8Array]',
    uint8ClampedTag = '[object Uint8ClampedArray]',
    uint16Tag = '[object Uint16Array]',
    uint32Tag = '[object Uint32Array]';

/** Used to identify `toStringTag` values of typed arrays. */
var typedArrayTags = {};
typedArrayTags[float32Tag] = typedArrayTags[float64Tag] =
typedArrayTags[int8Tag] = typedArrayTags[int16Tag] =
typedArrayTags[int32Tag] = typedArrayTags[uint8Tag] =
typedArrayTags[uint8ClampedTag] = typedArrayTags[uint16Tag] =
typedArrayTags[uint32Tag] = true;
typedArrayTags[argsTag$1] = typedArrayTags[arrayTag] =
typedArrayTags[arrayBufferTag] = typedArrayTags[boolTag] =
typedArrayTags[dataViewTag] = typedArrayTags[dateTag] =
typedArrayTags[errorTag] = typedArrayTags[funcTag$1] =
typedArrayTags[mapTag] = typedArrayTags[numberTag] =
typedArrayTags[objectTag] = typedArrayTags[regexpTag] =
typedArrayTags[setTag] = typedArrayTags[stringTag] =
typedArrayTags[weakMapTag] = false;

/**
 * The base implementation of `_.isTypedArray` without Node.js optimizations.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
 */
function baseIsTypedArray(value) {
  return isObjectLike_1(value) &&
    isLength_1(value.length) && !!typedArrayTags[_baseGetTag(value)];
}

var _baseIsTypedArray = baseIsTypedArray;

/**
 * The base implementation of `_.unary` without support for storing metadata.
 *
 * @private
 * @param {Function} func The function to cap arguments for.
 * @returns {Function} Returns the new capped function.
 */
function baseUnary(func) {
  return function(value) {
    return func(value);
  };
}

var _baseUnary = baseUnary;

var _nodeUtil = createCommonjsModule(function (module, exports) {
/** Detect free variable `exports`. */
var freeExports =  exports && !exports.nodeType && exports;

/** Detect free variable `module`. */
var freeModule = freeExports && 'object' == 'object' && module && !module.nodeType && module;

/** Detect the popular CommonJS extension `module.exports`. */
var moduleExports = freeModule && freeModule.exports === freeExports;

/** Detect free variable `process` from Node.js. */
var freeProcess = moduleExports && _freeGlobal.process;

/** Used to access faster Node.js helpers. */
var nodeUtil = (function() {
  try {
    // Use `util.types` for Node.js 10+.
    var types = freeModule && freeModule.require && freeModule.require('util').types;

    if (types) {
      return types;
    }

    // Legacy `process.binding('util')` for Node.js < 10.
    return freeProcess && freeProcess.binding && freeProcess.binding('util');
  } catch (e) {}
}());

module.exports = nodeUtil;
});

/* Node.js helper references. */
var nodeIsTypedArray = _nodeUtil && _nodeUtil.isTypedArray;

/**
 * Checks if `value` is classified as a typed array.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
 * @example
 *
 * _.isTypedArray(new Uint8Array);
 * // => true
 *
 * _.isTypedArray([]);
 * // => false
 */
var isTypedArray = nodeIsTypedArray ? _baseUnary(nodeIsTypedArray) : _baseIsTypedArray;

var isTypedArray_1 = isTypedArray;

/** Used for built-in method references. */
var objectProto$7 = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty$6 = objectProto$7.hasOwnProperty;

/**
 * Creates an array of the enumerable property names of the array-like `value`.
 *
 * @private
 * @param {*} value The value to query.
 * @param {boolean} inherited Specify returning inherited property names.
 * @returns {Array} Returns the array of property names.
 */
function arrayLikeKeys(value, inherited) {
  var isArr = isArray_1(value),
      isArg = !isArr && isArguments_1(value),
      isBuff = !isArr && !isArg && isBuffer_1(value),
      isType = !isArr && !isArg && !isBuff && isTypedArray_1(value),
      skipIndexes = isArr || isArg || isBuff || isType,
      result = skipIndexes ? _baseTimes(value.length, String) : [],
      length = result.length;

  for (var key in value) {
    if ((inherited || hasOwnProperty$6.call(value, key)) &&
        !(skipIndexes && (
           // Safari 9 has enumerable `arguments.length` in strict mode.
           key == 'length' ||
           // Node.js 0.10 has enumerable non-index properties on buffers.
           (isBuff && (key == 'offset' || key == 'parent')) ||
           // PhantomJS 2 has enumerable non-index properties on typed arrays.
           (isType && (key == 'buffer' || key == 'byteLength' || key == 'byteOffset')) ||
           // Skip index properties.
           _isIndex(key, length)
        ))) {
      result.push(key);
    }
  }
  return result;
}

var _arrayLikeKeys = arrayLikeKeys;

/** Used for built-in method references. */
var objectProto$8 = Object.prototype;

/**
 * Checks if `value` is likely a prototype object.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a prototype, else `false`.
 */
function isPrototype(value) {
  var Ctor = value && value.constructor,
      proto = (typeof Ctor == 'function' && Ctor.prototype) || objectProto$8;

  return value === proto;
}

var _isPrototype = isPrototype;

/**
 * Creates a unary function that invokes `func` with its argument transformed.
 *
 * @private
 * @param {Function} func The function to wrap.
 * @param {Function} transform The argument transform.
 * @returns {Function} Returns the new function.
 */
function overArg(func, transform) {
  return function(arg) {
    return func(transform(arg));
  };
}

var _overArg = overArg;

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeKeys = _overArg(Object.keys, Object);

var _nativeKeys = nativeKeys;

/** Used for built-in method references. */
var objectProto$9 = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty$7 = objectProto$9.hasOwnProperty;

/**
 * The base implementation of `_.keys` which doesn't treat sparse arrays as dense.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 */
function baseKeys(object) {
  if (!_isPrototype(object)) {
    return _nativeKeys(object);
  }
  var result = [];
  for (var key in Object(object)) {
    if (hasOwnProperty$7.call(object, key) && key != 'constructor') {
      result.push(key);
    }
  }
  return result;
}

var _baseKeys = baseKeys;

/**
 * Checks if `value` is array-like. A value is considered array-like if it's
 * not a function and has a `value.length` that's an integer greater than or
 * equal to `0` and less than or equal to `Number.MAX_SAFE_INTEGER`.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is array-like, else `false`.
 * @example
 *
 * _.isArrayLike([1, 2, 3]);
 * // => true
 *
 * _.isArrayLike(document.body.children);
 * // => true
 *
 * _.isArrayLike('abc');
 * // => true
 *
 * _.isArrayLike(_.noop);
 * // => false
 */
function isArrayLike(value) {
  return value != null && isLength_1(value.length) && !isFunction_1(value);
}

var isArrayLike_1 = isArrayLike;

/**
 * Creates an array of the own enumerable property names of `object`.
 *
 * **Note:** Non-object values are coerced to objects. See the
 * [ES spec](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
 * for more details.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Object
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 *   this.b = 2;
 * }
 *
 * Foo.prototype.c = 3;
 *
 * _.keys(new Foo);
 * // => ['a', 'b'] (iteration order is not guaranteed)
 *
 * _.keys('hi');
 * // => ['0', '1']
 */
function keys(object) {
  return isArrayLike_1(object) ? _arrayLikeKeys(object) : _baseKeys(object);
}

var keys_1 = keys;

/**
 * The base implementation of `_.assign` without support for multiple sources
 * or `customizer` functions.
 *
 * @private
 * @param {Object} object The destination object.
 * @param {Object} source The source object.
 * @returns {Object} Returns `object`.
 */
function baseAssign(object, source) {
  return object && _copyObject(source, keys_1(source), object);
}

var _baseAssign = baseAssign;

/**
 * This function is like
 * [`Object.keys`](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
 * except that it includes inherited enumerable properties.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 */
function nativeKeysIn(object) {
  var result = [];
  if (object != null) {
    for (var key in Object(object)) {
      result.push(key);
    }
  }
  return result;
}

var _nativeKeysIn = nativeKeysIn;

/** Used for built-in method references. */
var objectProto$a = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty$8 = objectProto$a.hasOwnProperty;

/**
 * The base implementation of `_.keysIn` which doesn't treat sparse arrays as dense.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 */
function baseKeysIn(object) {
  if (!isObject_1(object)) {
    return _nativeKeysIn(object);
  }
  var isProto = _isPrototype(object),
      result = [];

  for (var key in object) {
    if (!(key == 'constructor' && (isProto || !hasOwnProperty$8.call(object, key)))) {
      result.push(key);
    }
  }
  return result;
}

var _baseKeysIn = baseKeysIn;

/**
 * Creates an array of the own and inherited enumerable property names of `object`.
 *
 * **Note:** Non-object values are coerced to objects.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category Object
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 *   this.b = 2;
 * }
 *
 * Foo.prototype.c = 3;
 *
 * _.keysIn(new Foo);
 * // => ['a', 'b', 'c'] (iteration order is not guaranteed)
 */
function keysIn$1(object) {
  return isArrayLike_1(object) ? _arrayLikeKeys(object, true) : _baseKeysIn(object);
}

var keysIn_1 = keysIn$1;

/**
 * The base implementation of `_.assignIn` without support for multiple sources
 * or `customizer` functions.
 *
 * @private
 * @param {Object} object The destination object.
 * @param {Object} source The source object.
 * @returns {Object} Returns `object`.
 */
function baseAssignIn(object, source) {
  return object && _copyObject(source, keysIn_1(source), object);
}

var _baseAssignIn = baseAssignIn;

var _cloneBuffer = createCommonjsModule(function (module, exports) {
/** Detect free variable `exports`. */
var freeExports =  exports && !exports.nodeType && exports;

/** Detect free variable `module`. */
var freeModule = freeExports && 'object' == 'object' && module && !module.nodeType && module;

/** Detect the popular CommonJS extension `module.exports`. */
var moduleExports = freeModule && freeModule.exports === freeExports;

/** Built-in value references. */
var Buffer = moduleExports ? _root.Buffer : undefined,
    allocUnsafe = Buffer ? Buffer.allocUnsafe : undefined;

/**
 * Creates a clone of  `buffer`.
 *
 * @private
 * @param {Buffer} buffer The buffer to clone.
 * @param {boolean} [isDeep] Specify a deep clone.
 * @returns {Buffer} Returns the cloned buffer.
 */
function cloneBuffer(buffer, isDeep) {
  if (isDeep) {
    return buffer.slice();
  }
  var length = buffer.length,
      result = allocUnsafe ? allocUnsafe(length) : new buffer.constructor(length);

  buffer.copy(result);
  return result;
}

module.exports = cloneBuffer;
});

/**
 * Copies the values of `source` to `array`.
 *
 * @private
 * @param {Array} source The array to copy values from.
 * @param {Array} [array=[]] The array to copy values to.
 * @returns {Array} Returns `array`.
 */
function copyArray(source, array) {
  var index = -1,
      length = source.length;

  array || (array = Array(length));
  while (++index < length) {
    array[index] = source[index];
  }
  return array;
}

var _copyArray = copyArray;

/**
 * A specialized version of `_.filter` for arrays without support for
 * iteratee shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} predicate The function invoked per iteration.
 * @returns {Array} Returns the new filtered array.
 */
function arrayFilter(array, predicate) {
  var index = -1,
      length = array == null ? 0 : array.length,
      resIndex = 0,
      result = [];

  while (++index < length) {
    var value = array[index];
    if (predicate(value, index, array)) {
      result[resIndex++] = value;
    }
  }
  return result;
}

var _arrayFilter = arrayFilter;

/**
 * This method returns a new empty array.
 *
 * @static
 * @memberOf _
 * @since 4.13.0
 * @category Util
 * @returns {Array} Returns the new empty array.
 * @example
 *
 * var arrays = _.times(2, _.stubArray);
 *
 * console.log(arrays);
 * // => [[], []]
 *
 * console.log(arrays[0] === arrays[1]);
 * // => false
 */
function stubArray() {
  return [];
}

var stubArray_1 = stubArray;

/** Used for built-in method references. */
var objectProto$b = Object.prototype;

/** Built-in value references. */
var propertyIsEnumerable$1 = objectProto$b.propertyIsEnumerable;

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeGetSymbols = Object.getOwnPropertySymbols;

/**
 * Creates an array of the own enumerable symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of symbols.
 */
var getSymbols = !nativeGetSymbols ? stubArray_1 : function(object) {
  if (object == null) {
    return [];
  }
  object = Object(object);
  return _arrayFilter(nativeGetSymbols(object), function(symbol) {
    return propertyIsEnumerable$1.call(object, symbol);
  });
};

var _getSymbols = getSymbols;

/**
 * Copies own symbols of `source` to `object`.
 *
 * @private
 * @param {Object} source The object to copy symbols from.
 * @param {Object} [object={}] The object to copy symbols to.
 * @returns {Object} Returns `object`.
 */
function copySymbols(source, object) {
  return _copyObject(source, _getSymbols(source), object);
}

var _copySymbols = copySymbols;

/**
 * Appends the elements of `values` to `array`.
 *
 * @private
 * @param {Array} array The array to modify.
 * @param {Array} values The values to append.
 * @returns {Array} Returns `array`.
 */
function arrayPush(array, values) {
  var index = -1,
      length = values.length,
      offset = array.length;

  while (++index < length) {
    array[offset + index] = values[index];
  }
  return array;
}

var _arrayPush = arrayPush;

/** Built-in value references. */
var getPrototype = _overArg(Object.getPrototypeOf, Object);

var _getPrototype = getPrototype;

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeGetSymbols$1 = Object.getOwnPropertySymbols;

/**
 * Creates an array of the own and inherited enumerable symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of symbols.
 */
var getSymbolsIn = !nativeGetSymbols$1 ? stubArray_1 : function(object) {
  var result = [];
  while (object) {
    _arrayPush(result, _getSymbols(object));
    object = _getPrototype(object);
  }
  return result;
};

var _getSymbolsIn = getSymbolsIn;

/**
 * Copies own and inherited symbols of `source` to `object`.
 *
 * @private
 * @param {Object} source The object to copy symbols from.
 * @param {Object} [object={}] The object to copy symbols to.
 * @returns {Object} Returns `object`.
 */
function copySymbolsIn(source, object) {
  return _copyObject(source, _getSymbolsIn(source), object);
}

var _copySymbolsIn = copySymbolsIn;

/**
 * The base implementation of `getAllKeys` and `getAllKeysIn` which uses
 * `keysFunc` and `symbolsFunc` to get the enumerable property names and
 * symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {Function} keysFunc The function to get the keys of `object`.
 * @param {Function} symbolsFunc The function to get the symbols of `object`.
 * @returns {Array} Returns the array of property names and symbols.
 */
function baseGetAllKeys(object, keysFunc, symbolsFunc) {
  var result = keysFunc(object);
  return isArray_1(object) ? result : _arrayPush(result, symbolsFunc(object));
}

var _baseGetAllKeys = baseGetAllKeys;

/**
 * Creates an array of own enumerable property names and symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names and symbols.
 */
function getAllKeys(object) {
  return _baseGetAllKeys(object, keys_1, _getSymbols);
}

var _getAllKeys = getAllKeys;

/**
 * Creates an array of own and inherited enumerable property names and
 * symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names and symbols.
 */
function getAllKeysIn(object) {
  return _baseGetAllKeys(object, keysIn_1, _getSymbolsIn);
}

var _getAllKeysIn = getAllKeysIn;

/* Built-in method references that are verified to be native. */
var DataView = _getNative(_root, 'DataView');

var _DataView = DataView;

/* Built-in method references that are verified to be native. */
var Promise$1 = _getNative(_root, 'Promise');

var _Promise = Promise$1;

/* Built-in method references that are verified to be native. */
var Set$1 = _getNative(_root, 'Set');

var _Set = Set$1;

/* Built-in method references that are verified to be native. */
var WeakMap = _getNative(_root, 'WeakMap');

var _WeakMap = WeakMap;

/** `Object#toString` result references. */
var mapTag$1 = '[object Map]',
    objectTag$1 = '[object Object]',
    promiseTag = '[object Promise]',
    setTag$1 = '[object Set]',
    weakMapTag$1 = '[object WeakMap]';

var dataViewTag$1 = '[object DataView]';

/** Used to detect maps, sets, and weakmaps. */
var dataViewCtorString = _toSource(_DataView),
    mapCtorString = _toSource(_Map),
    promiseCtorString = _toSource(_Promise),
    setCtorString = _toSource(_Set),
    weakMapCtorString = _toSource(_WeakMap);

/**
 * Gets the `toStringTag` of `value`.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the `toStringTag`.
 */
var getTag = _baseGetTag;

// Fallback for data views, maps, sets, and weak maps in IE 11 and promises in Node.js < 6.
if ((_DataView && getTag(new _DataView(new ArrayBuffer(1))) != dataViewTag$1) ||
    (_Map && getTag(new _Map) != mapTag$1) ||
    (_Promise && getTag(_Promise.resolve()) != promiseTag) ||
    (_Set && getTag(new _Set) != setTag$1) ||
    (_WeakMap && getTag(new _WeakMap) != weakMapTag$1)) {
  getTag = function(value) {
    var result = _baseGetTag(value),
        Ctor = result == objectTag$1 ? value.constructor : undefined,
        ctorString = Ctor ? _toSource(Ctor) : '';

    if (ctorString) {
      switch (ctorString) {
        case dataViewCtorString: return dataViewTag$1;
        case mapCtorString: return mapTag$1;
        case promiseCtorString: return promiseTag;
        case setCtorString: return setTag$1;
        case weakMapCtorString: return weakMapTag$1;
      }
    }
    return result;
  };
}

var _getTag = getTag;

/** Used for built-in method references. */
var objectProto$c = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty$9 = objectProto$c.hasOwnProperty;

/**
 * Initializes an array clone.
 *
 * @private
 * @param {Array} array The array to clone.
 * @returns {Array} Returns the initialized clone.
 */
function initCloneArray(array) {
  var length = array.length,
      result = new array.constructor(length);

  // Add properties assigned by `RegExp#exec`.
  if (length && typeof array[0] == 'string' && hasOwnProperty$9.call(array, 'index')) {
    result.index = array.index;
    result.input = array.input;
  }
  return result;
}

var _initCloneArray = initCloneArray;

/** Built-in value references. */
var Uint8Array = _root.Uint8Array;

var _Uint8Array = Uint8Array;

/**
 * Creates a clone of `arrayBuffer`.
 *
 * @private
 * @param {ArrayBuffer} arrayBuffer The array buffer to clone.
 * @returns {ArrayBuffer} Returns the cloned array buffer.
 */
function cloneArrayBuffer(arrayBuffer) {
  var result = new arrayBuffer.constructor(arrayBuffer.byteLength);
  new _Uint8Array(result).set(new _Uint8Array(arrayBuffer));
  return result;
}

var _cloneArrayBuffer = cloneArrayBuffer;

/**
 * Creates a clone of `dataView`.
 *
 * @private
 * @param {Object} dataView The data view to clone.
 * @param {boolean} [isDeep] Specify a deep clone.
 * @returns {Object} Returns the cloned data view.
 */
function cloneDataView(dataView, isDeep) {
  var buffer = isDeep ? _cloneArrayBuffer(dataView.buffer) : dataView.buffer;
  return new dataView.constructor(buffer, dataView.byteOffset, dataView.byteLength);
}

var _cloneDataView = cloneDataView;

/** Used to match `RegExp` flags from their coerced string values. */
var reFlags = /\w*$/;

/**
 * Creates a clone of `regexp`.
 *
 * @private
 * @param {Object} regexp The regexp to clone.
 * @returns {Object} Returns the cloned regexp.
 */
function cloneRegExp(regexp) {
  var result = new regexp.constructor(regexp.source, reFlags.exec(regexp));
  result.lastIndex = regexp.lastIndex;
  return result;
}

var _cloneRegExp = cloneRegExp;

/** Used to convert symbols to primitives and strings. */
var symbolProto = _Symbol ? _Symbol.prototype : undefined,
    symbolValueOf = symbolProto ? symbolProto.valueOf : undefined;

/**
 * Creates a clone of the `symbol` object.
 *
 * @private
 * @param {Object} symbol The symbol object to clone.
 * @returns {Object} Returns the cloned symbol object.
 */
function cloneSymbol(symbol) {
  return symbolValueOf ? Object(symbolValueOf.call(symbol)) : {};
}

var _cloneSymbol = cloneSymbol;

/**
 * Creates a clone of `typedArray`.
 *
 * @private
 * @param {Object} typedArray The typed array to clone.
 * @param {boolean} [isDeep] Specify a deep clone.
 * @returns {Object} Returns the cloned typed array.
 */
function cloneTypedArray(typedArray, isDeep) {
  var buffer = isDeep ? _cloneArrayBuffer(typedArray.buffer) : typedArray.buffer;
  return new typedArray.constructor(buffer, typedArray.byteOffset, typedArray.length);
}

var _cloneTypedArray = cloneTypedArray;

/** `Object#toString` result references. */
var boolTag$1 = '[object Boolean]',
    dateTag$1 = '[object Date]',
    mapTag$2 = '[object Map]',
    numberTag$1 = '[object Number]',
    regexpTag$1 = '[object RegExp]',
    setTag$2 = '[object Set]',
    stringTag$1 = '[object String]',
    symbolTag = '[object Symbol]';

var arrayBufferTag$1 = '[object ArrayBuffer]',
    dataViewTag$2 = '[object DataView]',
    float32Tag$1 = '[object Float32Array]',
    float64Tag$1 = '[object Float64Array]',
    int8Tag$1 = '[object Int8Array]',
    int16Tag$1 = '[object Int16Array]',
    int32Tag$1 = '[object Int32Array]',
    uint8Tag$1 = '[object Uint8Array]',
    uint8ClampedTag$1 = '[object Uint8ClampedArray]',
    uint16Tag$1 = '[object Uint16Array]',
    uint32Tag$1 = '[object Uint32Array]';

/**
 * Initializes an object clone based on its `toStringTag`.
 *
 * **Note:** This function only supports cloning values with tags of
 * `Boolean`, `Date`, `Error`, `Map`, `Number`, `RegExp`, `Set`, or `String`.
 *
 * @private
 * @param {Object} object The object to clone.
 * @param {string} tag The `toStringTag` of the object to clone.
 * @param {boolean} [isDeep] Specify a deep clone.
 * @returns {Object} Returns the initialized clone.
 */
function initCloneByTag(object, tag, isDeep) {
  var Ctor = object.constructor;
  switch (tag) {
    case arrayBufferTag$1:
      return _cloneArrayBuffer(object);

    case boolTag$1:
    case dateTag$1:
      return new Ctor(+object);

    case dataViewTag$2:
      return _cloneDataView(object, isDeep);

    case float32Tag$1: case float64Tag$1:
    case int8Tag$1: case int16Tag$1: case int32Tag$1:
    case uint8Tag$1: case uint8ClampedTag$1: case uint16Tag$1: case uint32Tag$1:
      return _cloneTypedArray(object, isDeep);

    case mapTag$2:
      return new Ctor;

    case numberTag$1:
    case stringTag$1:
      return new Ctor(object);

    case regexpTag$1:
      return _cloneRegExp(object);

    case setTag$2:
      return new Ctor;

    case symbolTag:
      return _cloneSymbol(object);
  }
}

var _initCloneByTag = initCloneByTag;

/** Built-in value references. */
var objectCreate = Object.create;

/**
 * The base implementation of `_.create` without support for assigning
 * properties to the created object.
 *
 * @private
 * @param {Object} proto The object to inherit from.
 * @returns {Object} Returns the new object.
 */
var baseCreate = (function() {
  function object() {}
  return function(proto) {
    if (!isObject_1(proto)) {
      return {};
    }
    if (objectCreate) {
      return objectCreate(proto);
    }
    object.prototype = proto;
    var result = new object;
    object.prototype = undefined;
    return result;
  };
}());

var _baseCreate = baseCreate;

/**
 * Initializes an object clone.
 *
 * @private
 * @param {Object} object The object to clone.
 * @returns {Object} Returns the initialized clone.
 */
function initCloneObject(object) {
  return (typeof object.constructor == 'function' && !_isPrototype(object))
    ? _baseCreate(_getPrototype(object))
    : {};
}

var _initCloneObject = initCloneObject;

/** `Object#toString` result references. */
var mapTag$3 = '[object Map]';

/**
 * The base implementation of `_.isMap` without Node.js optimizations.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a map, else `false`.
 */
function baseIsMap(value) {
  return isObjectLike_1(value) && _getTag(value) == mapTag$3;
}

var _baseIsMap = baseIsMap;

/* Node.js helper references. */
var nodeIsMap = _nodeUtil && _nodeUtil.isMap;

/**
 * Checks if `value` is classified as a `Map` object.
 *
 * @static
 * @memberOf _
 * @since 4.3.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a map, else `false`.
 * @example
 *
 * _.isMap(new Map);
 * // => true
 *
 * _.isMap(new WeakMap);
 * // => false
 */
var isMap = nodeIsMap ? _baseUnary(nodeIsMap) : _baseIsMap;

var isMap_1 = isMap;

/** `Object#toString` result references. */
var setTag$3 = '[object Set]';

/**
 * The base implementation of `_.isSet` without Node.js optimizations.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a set, else `false`.
 */
function baseIsSet(value) {
  return isObjectLike_1(value) && _getTag(value) == setTag$3;
}

var _baseIsSet = baseIsSet;

/* Node.js helper references. */
var nodeIsSet = _nodeUtil && _nodeUtil.isSet;

/**
 * Checks if `value` is classified as a `Set` object.
 *
 * @static
 * @memberOf _
 * @since 4.3.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a set, else `false`.
 * @example
 *
 * _.isSet(new Set);
 * // => true
 *
 * _.isSet(new WeakSet);
 * // => false
 */
var isSet = nodeIsSet ? _baseUnary(nodeIsSet) : _baseIsSet;

var isSet_1 = isSet;

/** Used to compose bitmasks for cloning. */
var CLONE_DEEP_FLAG = 1,
    CLONE_FLAT_FLAG = 2,
    CLONE_SYMBOLS_FLAG = 4;

/** `Object#toString` result references. */
var argsTag$2 = '[object Arguments]',
    arrayTag$1 = '[object Array]',
    boolTag$2 = '[object Boolean]',
    dateTag$2 = '[object Date]',
    errorTag$1 = '[object Error]',
    funcTag$2 = '[object Function]',
    genTag$1 = '[object GeneratorFunction]',
    mapTag$4 = '[object Map]',
    numberTag$2 = '[object Number]',
    objectTag$2 = '[object Object]',
    regexpTag$2 = '[object RegExp]',
    setTag$4 = '[object Set]',
    stringTag$2 = '[object String]',
    symbolTag$1 = '[object Symbol]',
    weakMapTag$2 = '[object WeakMap]';

var arrayBufferTag$2 = '[object ArrayBuffer]',
    dataViewTag$3 = '[object DataView]',
    float32Tag$2 = '[object Float32Array]',
    float64Tag$2 = '[object Float64Array]',
    int8Tag$2 = '[object Int8Array]',
    int16Tag$2 = '[object Int16Array]',
    int32Tag$2 = '[object Int32Array]',
    uint8Tag$2 = '[object Uint8Array]',
    uint8ClampedTag$2 = '[object Uint8ClampedArray]',
    uint16Tag$2 = '[object Uint16Array]',
    uint32Tag$2 = '[object Uint32Array]';

/** Used to identify `toStringTag` values supported by `_.clone`. */
var cloneableTags = {};
cloneableTags[argsTag$2] = cloneableTags[arrayTag$1] =
cloneableTags[arrayBufferTag$2] = cloneableTags[dataViewTag$3] =
cloneableTags[boolTag$2] = cloneableTags[dateTag$2] =
cloneableTags[float32Tag$2] = cloneableTags[float64Tag$2] =
cloneableTags[int8Tag$2] = cloneableTags[int16Tag$2] =
cloneableTags[int32Tag$2] = cloneableTags[mapTag$4] =
cloneableTags[numberTag$2] = cloneableTags[objectTag$2] =
cloneableTags[regexpTag$2] = cloneableTags[setTag$4] =
cloneableTags[stringTag$2] = cloneableTags[symbolTag$1] =
cloneableTags[uint8Tag$2] = cloneableTags[uint8ClampedTag$2] =
cloneableTags[uint16Tag$2] = cloneableTags[uint32Tag$2] = true;
cloneableTags[errorTag$1] = cloneableTags[funcTag$2] =
cloneableTags[weakMapTag$2] = false;

/**
 * The base implementation of `_.clone` and `_.cloneDeep` which tracks
 * traversed objects.
 *
 * @private
 * @param {*} value The value to clone.
 * @param {boolean} bitmask The bitmask flags.
 *  1 - Deep clone
 *  2 - Flatten inherited properties
 *  4 - Clone symbols
 * @param {Function} [customizer] The function to customize cloning.
 * @param {string} [key] The key of `value`.
 * @param {Object} [object] The parent object of `value`.
 * @param {Object} [stack] Tracks traversed objects and their clone counterparts.
 * @returns {*} Returns the cloned value.
 */
function baseClone(value, bitmask, customizer, key, object, stack) {
  var result,
      isDeep = bitmask & CLONE_DEEP_FLAG,
      isFlat = bitmask & CLONE_FLAT_FLAG,
      isFull = bitmask & CLONE_SYMBOLS_FLAG;

  if (customizer) {
    result = object ? customizer(value, key, object, stack) : customizer(value);
  }
  if (result !== undefined) {
    return result;
  }
  if (!isObject_1(value)) {
    return value;
  }
  var isArr = isArray_1(value);
  if (isArr) {
    result = _initCloneArray(value);
    if (!isDeep) {
      return _copyArray(value, result);
    }
  } else {
    var tag = _getTag(value),
        isFunc = tag == funcTag$2 || tag == genTag$1;

    if (isBuffer_1(value)) {
      return _cloneBuffer(value, isDeep);
    }
    if (tag == objectTag$2 || tag == argsTag$2 || (isFunc && !object)) {
      result = (isFlat || isFunc) ? {} : _initCloneObject(value);
      if (!isDeep) {
        return isFlat
          ? _copySymbolsIn(value, _baseAssignIn(result, value))
          : _copySymbols(value, _baseAssign(result, value));
      }
    } else {
      if (!cloneableTags[tag]) {
        return object ? value : {};
      }
      result = _initCloneByTag(value, tag, isDeep);
    }
  }
  // Check for circular references and return its corresponding clone.
  stack || (stack = new _Stack);
  var stacked = stack.get(value);
  if (stacked) {
    return stacked;
  }
  stack.set(value, result);

  if (isSet_1(value)) {
    value.forEach(function(subValue) {
      result.add(baseClone(subValue, bitmask, customizer, subValue, value, stack));
    });
  } else if (isMap_1(value)) {
    value.forEach(function(subValue, key) {
      result.set(key, baseClone(subValue, bitmask, customizer, key, value, stack));
    });
  }

  var keysFunc = isFull
    ? (isFlat ? _getAllKeysIn : _getAllKeys)
    : (isFlat ? keysIn : keys_1);

  var props = isArr ? undefined : keysFunc(value);
  _arrayEach(props || value, function(subValue, key) {
    if (props) {
      key = subValue;
      subValue = value[key];
    }
    // Recursively populate clone (susceptible to call stack limits).
    _assignValue(result, key, baseClone(subValue, bitmask, customizer, key, value, stack));
  });
  return result;
}

var _baseClone = baseClone;

/** `Object#toString` result references. */
var symbolTag$2 = '[object Symbol]';

/**
 * Checks if `value` is classified as a `Symbol` primitive or object.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a symbol, else `false`.
 * @example
 *
 * _.isSymbol(Symbol.iterator);
 * // => true
 *
 * _.isSymbol('abc');
 * // => false
 */
function isSymbol(value) {
  return typeof value == 'symbol' ||
    (isObjectLike_1(value) && _baseGetTag(value) == symbolTag$2);
}

var isSymbol_1 = isSymbol;

/** Used to match property names within property paths. */
var reIsDeepProp = /\.|\[(?:[^[\]]*|(["'])(?:(?!\1)[^\\]|\\.)*?\1)\]/,
    reIsPlainProp = /^\w*$/;

/**
 * Checks if `value` is a property name and not a property path.
 *
 * @private
 * @param {*} value The value to check.
 * @param {Object} [object] The object to query keys on.
 * @returns {boolean} Returns `true` if `value` is a property name, else `false`.
 */
function isKey(value, object) {
  if (isArray_1(value)) {
    return false;
  }
  var type = typeof value;
  if (type == 'number' || type == 'symbol' || type == 'boolean' ||
      value == null || isSymbol_1(value)) {
    return true;
  }
  return reIsPlainProp.test(value) || !reIsDeepProp.test(value) ||
    (object != null && value in Object(object));
}

var _isKey = isKey;

/** Error message constants. */
var FUNC_ERROR_TEXT = 'Expected a function';

/**
 * Creates a function that memoizes the result of `func`. If `resolver` is
 * provided, it determines the cache key for storing the result based on the
 * arguments provided to the memoized function. By default, the first argument
 * provided to the memoized function is used as the map cache key. The `func`
 * is invoked with the `this` binding of the memoized function.
 *
 * **Note:** The cache is exposed as the `cache` property on the memoized
 * function. Its creation may be customized by replacing the `_.memoize.Cache`
 * constructor with one whose instances implement the
 * [`Map`](http://ecma-international.org/ecma-262/7.0/#sec-properties-of-the-map-prototype-object)
 * method interface of `clear`, `delete`, `get`, `has`, and `set`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Function
 * @param {Function} func The function to have its output memoized.
 * @param {Function} [resolver] The function to resolve the cache key.
 * @returns {Function} Returns the new memoized function.
 * @example
 *
 * var object = { 'a': 1, 'b': 2 };
 * var other = { 'c': 3, 'd': 4 };
 *
 * var values = _.memoize(_.values);
 * values(object);
 * // => [1, 2]
 *
 * values(other);
 * // => [3, 4]
 *
 * object.a = 2;
 * values(object);
 * // => [1, 2]
 *
 * // Modify the result cache.
 * values.cache.set(object, ['a', 'b']);
 * values(object);
 * // => ['a', 'b']
 *
 * // Replace `_.memoize.Cache`.
 * _.memoize.Cache = WeakMap;
 */
function memoize(func, resolver) {
  if (typeof func != 'function' || (resolver != null && typeof resolver != 'function')) {
    throw new TypeError(FUNC_ERROR_TEXT);
  }
  var memoized = function() {
    var args = arguments,
        key = resolver ? resolver.apply(this, args) : args[0],
        cache = memoized.cache;

    if (cache.has(key)) {
      return cache.get(key);
    }
    var result = func.apply(this, args);
    memoized.cache = cache.set(key, result) || cache;
    return result;
  };
  memoized.cache = new (memoize.Cache || _MapCache);
  return memoized;
}

// Expose `MapCache`.
memoize.Cache = _MapCache;

var memoize_1 = memoize;

/** Used as the maximum memoize cache size. */
var MAX_MEMOIZE_SIZE = 500;

/**
 * A specialized version of `_.memoize` which clears the memoized function's
 * cache when it exceeds `MAX_MEMOIZE_SIZE`.
 *
 * @private
 * @param {Function} func The function to have its output memoized.
 * @returns {Function} Returns the new memoized function.
 */
function memoizeCapped(func) {
  var result = memoize_1(func, function(key) {
    if (cache.size === MAX_MEMOIZE_SIZE) {
      cache.clear();
    }
    return key;
  });

  var cache = result.cache;
  return result;
}

var _memoizeCapped = memoizeCapped;

/** Used to match property names within property paths. */
var rePropName = /[^.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|$))/g;

/** Used to match backslashes in property paths. */
var reEscapeChar = /\\(\\)?/g;

/**
 * Converts `string` to a property path array.
 *
 * @private
 * @param {string} string The string to convert.
 * @returns {Array} Returns the property path array.
 */
var stringToPath = _memoizeCapped(function(string) {
  var result = [];
  if (string.charCodeAt(0) === 46 /* . */) {
    result.push('');
  }
  string.replace(rePropName, function(match, number, quote, subString) {
    result.push(quote ? subString.replace(reEscapeChar, '$1') : (number || match));
  });
  return result;
});

var _stringToPath = stringToPath;

/** Used as references for various `Number` constants. */
var INFINITY = 1 / 0;

/** Used to convert symbols to primitives and strings. */
var symbolProto$1 = _Symbol ? _Symbol.prototype : undefined,
    symbolToString = symbolProto$1 ? symbolProto$1.toString : undefined;

/**
 * The base implementation of `_.toString` which doesn't convert nullish
 * values to empty strings.
 *
 * @private
 * @param {*} value The value to process.
 * @returns {string} Returns the string.
 */
function baseToString(value) {
  // Exit early for strings to avoid a performance hit in some environments.
  if (typeof value == 'string') {
    return value;
  }
  if (isArray_1(value)) {
    // Recursively convert values (susceptible to call stack limits).
    return _arrayMap(value, baseToString) + '';
  }
  if (isSymbol_1(value)) {
    return symbolToString ? symbolToString.call(value) : '';
  }
  var result = (value + '');
  return (result == '0' && (1 / value) == -INFINITY) ? '-0' : result;
}

var _baseToString = baseToString;

/**
 * Converts `value` to a string. An empty string is returned for `null`
 * and `undefined` values. The sign of `-0` is preserved.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to convert.
 * @returns {string} Returns the converted string.
 * @example
 *
 * _.toString(null);
 * // => ''
 *
 * _.toString(-0);
 * // => '-0'
 *
 * _.toString([1, 2, 3]);
 * // => '1,2,3'
 */
function toString(value) {
  return value == null ? '' : _baseToString(value);
}

var toString_1 = toString;

/**
 * Casts `value` to a path array if it's not one.
 *
 * @private
 * @param {*} value The value to inspect.
 * @param {Object} [object] The object to query keys on.
 * @returns {Array} Returns the cast property path array.
 */
function castPath(value, object) {
  if (isArray_1(value)) {
    return value;
  }
  return _isKey(value, object) ? [value] : _stringToPath(toString_1(value));
}

var _castPath = castPath;

/**
 * Gets the last element of `array`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Array
 * @param {Array} array The array to query.
 * @returns {*} Returns the last element of `array`.
 * @example
 *
 * _.last([1, 2, 3]);
 * // => 3
 */
function last(array) {
  var length = array == null ? 0 : array.length;
  return length ? array[length - 1] : undefined;
}

var last_1 = last;

/** Used as references for various `Number` constants. */
var INFINITY$1 = 1 / 0;

/**
 * Converts `value` to a string key if it's not a string or symbol.
 *
 * @private
 * @param {*} value The value to inspect.
 * @returns {string|symbol} Returns the key.
 */
function toKey(value) {
  if (typeof value == 'string' || isSymbol_1(value)) {
    return value;
  }
  var result = (value + '');
  return (result == '0' && (1 / value) == -INFINITY$1) ? '-0' : result;
}

var _toKey = toKey;

/**
 * The base implementation of `_.get` without support for default values.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {Array|string} path The path of the property to get.
 * @returns {*} Returns the resolved value.
 */
function baseGet(object, path) {
  path = _castPath(path, object);

  var index = 0,
      length = path.length;

  while (object != null && index < length) {
    object = object[_toKey(path[index++])];
  }
  return (index && index == length) ? object : undefined;
}

var _baseGet = baseGet;

/**
 * The base implementation of `_.slice` without an iteratee call guard.
 *
 * @private
 * @param {Array} array The array to slice.
 * @param {number} [start=0] The start position.
 * @param {number} [end=array.length] The end position.
 * @returns {Array} Returns the slice of `array`.
 */
function baseSlice(array, start, end) {
  var index = -1,
      length = array.length;

  if (start < 0) {
    start = -start > length ? 0 : (length + start);
  }
  end = end > length ? length : end;
  if (end < 0) {
    end += length;
  }
  length = start > end ? 0 : ((end - start) >>> 0);
  start >>>= 0;

  var result = Array(length);
  while (++index < length) {
    result[index] = array[index + start];
  }
  return result;
}

var _baseSlice = baseSlice;

/**
 * Gets the parent value at `path` of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {Array} path The path to get the parent value of.
 * @returns {*} Returns the parent value.
 */
function parent(object, path) {
  return path.length < 2 ? object : _baseGet(object, _baseSlice(path, 0, -1));
}

var _parent = parent;

/**
 * The base implementation of `_.unset`.
 *
 * @private
 * @param {Object} object The object to modify.
 * @param {Array|string} path The property path to unset.
 * @returns {boolean} Returns `true` if the property is deleted, else `false`.
 */
function baseUnset(object, path) {
  path = _castPath(path, object);
  object = _parent(object, path);
  return object == null || delete object[_toKey(last_1(path))];
}

var _baseUnset = baseUnset;

/** `Object#toString` result references. */
var objectTag$3 = '[object Object]';

/** Used for built-in method references. */
var funcProto$2 = Function.prototype,
    objectProto$d = Object.prototype;

/** Used to resolve the decompiled source of functions. */
var funcToString$2 = funcProto$2.toString;

/** Used to check objects for own properties. */
var hasOwnProperty$a = objectProto$d.hasOwnProperty;

/** Used to infer the `Object` constructor. */
var objectCtorString = funcToString$2.call(Object);

/**
 * Checks if `value` is a plain object, that is, an object created by the
 * `Object` constructor or one with a `[[Prototype]]` of `null`.
 *
 * @static
 * @memberOf _
 * @since 0.8.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a plain object, else `false`.
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 * }
 *
 * _.isPlainObject(new Foo);
 * // => false
 *
 * _.isPlainObject([1, 2, 3]);
 * // => false
 *
 * _.isPlainObject({ 'x': 0, 'y': 0 });
 * // => true
 *
 * _.isPlainObject(Object.create(null));
 * // => true
 */
function isPlainObject(value) {
  if (!isObjectLike_1(value) || _baseGetTag(value) != objectTag$3) {
    return false;
  }
  var proto = _getPrototype(value);
  if (proto === null) {
    return true;
  }
  var Ctor = hasOwnProperty$a.call(proto, 'constructor') && proto.constructor;
  return typeof Ctor == 'function' && Ctor instanceof Ctor &&
    funcToString$2.call(Ctor) == objectCtorString;
}

var isPlainObject_1 = isPlainObject;

/**
 * Used by `_.omit` to customize its `_.cloneDeep` use to only clone plain
 * objects.
 *
 * @private
 * @param {*} value The value to inspect.
 * @param {string} key The key of the property to inspect.
 * @returns {*} Returns the uncloned value or `undefined` to defer cloning to `_.cloneDeep`.
 */
function customOmitClone(value) {
  return isPlainObject_1(value) ? undefined : value;
}

var _customOmitClone = customOmitClone;

/** Built-in value references. */
var spreadableSymbol = _Symbol ? _Symbol.isConcatSpreadable : undefined;

/**
 * Checks if `value` is a flattenable `arguments` object or array.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is flattenable, else `false`.
 */
function isFlattenable(value) {
  return isArray_1(value) || isArguments_1(value) ||
    !!(spreadableSymbol && value && value[spreadableSymbol]);
}

var _isFlattenable = isFlattenable;

/**
 * The base implementation of `_.flatten` with support for restricting flattening.
 *
 * @private
 * @param {Array} array The array to flatten.
 * @param {number} depth The maximum recursion depth.
 * @param {boolean} [predicate=isFlattenable] The function invoked per iteration.
 * @param {boolean} [isStrict] Restrict to values that pass `predicate` checks.
 * @param {Array} [result=[]] The initial result value.
 * @returns {Array} Returns the new flattened array.
 */
function baseFlatten(array, depth, predicate, isStrict, result) {
  var index = -1,
      length = array.length;

  predicate || (predicate = _isFlattenable);
  result || (result = []);

  while (++index < length) {
    var value = array[index];
    if (depth > 0 && predicate(value)) {
      if (depth > 1) {
        // Recursively flatten arrays (susceptible to call stack limits).
        baseFlatten(value, depth - 1, predicate, isStrict, result);
      } else {
        _arrayPush(result, value);
      }
    } else if (!isStrict) {
      result[result.length] = value;
    }
  }
  return result;
}

var _baseFlatten = baseFlatten;

/**
 * Flattens `array` a single level deep.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Array
 * @param {Array} array The array to flatten.
 * @returns {Array} Returns the new flattened array.
 * @example
 *
 * _.flatten([1, [2, [3, [4]], 5]]);
 * // => [1, 2, [3, [4]], 5]
 */
function flatten(array) {
  var length = array == null ? 0 : array.length;
  return length ? _baseFlatten(array, 1) : [];
}

var flatten_1 = flatten;

/**
 * A faster alternative to `Function#apply`, this function invokes `func`
 * with the `this` binding of `thisArg` and the arguments of `args`.
 *
 * @private
 * @param {Function} func The function to invoke.
 * @param {*} thisArg The `this` binding of `func`.
 * @param {Array} args The arguments to invoke `func` with.
 * @returns {*} Returns the result of `func`.
 */
function apply(func, thisArg, args) {
  switch (args.length) {
    case 0: return func.call(thisArg);
    case 1: return func.call(thisArg, args[0]);
    case 2: return func.call(thisArg, args[0], args[1]);
    case 3: return func.call(thisArg, args[0], args[1], args[2]);
  }
  return func.apply(thisArg, args);
}

var _apply = apply;

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeMax = Math.max;

/**
 * A specialized version of `baseRest` which transforms the rest array.
 *
 * @private
 * @param {Function} func The function to apply a rest parameter to.
 * @param {number} [start=func.length-1] The start position of the rest parameter.
 * @param {Function} transform The rest array transform.
 * @returns {Function} Returns the new function.
 */
function overRest(func, start, transform) {
  start = nativeMax(start === undefined ? (func.length - 1) : start, 0);
  return function() {
    var args = arguments,
        index = -1,
        length = nativeMax(args.length - start, 0),
        array = Array(length);

    while (++index < length) {
      array[index] = args[start + index];
    }
    index = -1;
    var otherArgs = Array(start + 1);
    while (++index < start) {
      otherArgs[index] = args[index];
    }
    otherArgs[start] = transform(array);
    return _apply(func, this, otherArgs);
  };
}

var _overRest = overRest;

/**
 * Creates a function that returns `value`.
 *
 * @static
 * @memberOf _
 * @since 2.4.0
 * @category Util
 * @param {*} value The value to return from the new function.
 * @returns {Function} Returns the new constant function.
 * @example
 *
 * var objects = _.times(2, _.constant({ 'a': 1 }));
 *
 * console.log(objects);
 * // => [{ 'a': 1 }, { 'a': 1 }]
 *
 * console.log(objects[0] === objects[1]);
 * // => true
 */
function constant(value) {
  return function() {
    return value;
  };
}

var constant_1 = constant;

/**
 * This method returns the first argument it receives.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Util
 * @param {*} value Any value.
 * @returns {*} Returns `value`.
 * @example
 *
 * var object = { 'a': 1 };
 *
 * console.log(_.identity(object) === object);
 * // => true
 */
function identity(value) {
  return value;
}

var identity_1 = identity;

/**
 * The base implementation of `setToString` without support for hot loop shorting.
 *
 * @private
 * @param {Function} func The function to modify.
 * @param {Function} string The `toString` result.
 * @returns {Function} Returns `func`.
 */
var baseSetToString = !_defineProperty$1 ? identity_1 : function(func, string) {
  return _defineProperty$1(func, 'toString', {
    'configurable': true,
    'enumerable': false,
    'value': constant_1(string),
    'writable': true
  });
};

var _baseSetToString = baseSetToString;

/** Used to detect hot functions by number of calls within a span of milliseconds. */
var HOT_COUNT = 800,
    HOT_SPAN = 16;

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeNow = Date.now;

/**
 * Creates a function that'll short out and invoke `identity` instead
 * of `func` when it's called `HOT_COUNT` or more times in `HOT_SPAN`
 * milliseconds.
 *
 * @private
 * @param {Function} func The function to restrict.
 * @returns {Function} Returns the new shortable function.
 */
function shortOut(func) {
  var count = 0,
      lastCalled = 0;

  return function() {
    var stamp = nativeNow(),
        remaining = HOT_SPAN - (stamp - lastCalled);

    lastCalled = stamp;
    if (remaining > 0) {
      if (++count >= HOT_COUNT) {
        return arguments[0];
      }
    } else {
      count = 0;
    }
    return func.apply(undefined, arguments);
  };
}

var _shortOut = shortOut;

/**
 * Sets the `toString` method of `func` to return `string`.
 *
 * @private
 * @param {Function} func The function to modify.
 * @param {Function} string The `toString` result.
 * @returns {Function} Returns `func`.
 */
var setToString = _shortOut(_baseSetToString);

var _setToString = setToString;

/**
 * A specialized version of `baseRest` which flattens the rest array.
 *
 * @private
 * @param {Function} func The function to apply a rest parameter to.
 * @returns {Function} Returns the new function.
 */
function flatRest(func) {
  return _setToString(_overRest(func, undefined, flatten_1), func + '');
}

var _flatRest = flatRest;

/** Used to compose bitmasks for cloning. */
var CLONE_DEEP_FLAG$1 = 1,
    CLONE_FLAT_FLAG$1 = 2,
    CLONE_SYMBOLS_FLAG$1 = 4;

/**
 * The opposite of `_.pick`; this method creates an object composed of the
 * own and inherited enumerable property paths of `object` that are not omitted.
 *
 * **Note:** This method is considerably slower than `_.pick`.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Object
 * @param {Object} object The source object.
 * @param {...(string|string[])} [paths] The property paths to omit.
 * @returns {Object} Returns the new object.
 * @example
 *
 * var object = { 'a': 1, 'b': '2', 'c': 3 };
 *
 * _.omit(object, ['a', 'c']);
 * // => { 'b': '2' }
 */
var omit = _flatRest(function(object, paths) {
  var result = {};
  if (object == null) {
    return result;
  }
  var isDeep = false;
  paths = _arrayMap(paths, function(path) {
    path = _castPath(path, object);
    isDeep || (isDeep = path.length > 1);
    return path;
  });
  _copyObject(object, _getAllKeysIn(object), result);
  if (isDeep) {
    result = _baseClone(result, CLONE_DEEP_FLAG$1 | CLONE_FLAT_FLAG$1 | CLONE_SYMBOLS_FLAG$1, _customOmitClone);
  }
  var length = paths.length;
  while (length--) {
    _baseUnset(result, paths[length]);
  }
  return result;
});

var omit_1 = omit;

/**
 * The base implementation of `_.set`.
 *
 * @private
 * @param {Object} object The object to modify.
 * @param {Array|string} path The path of the property to set.
 * @param {*} value The value to set.
 * @param {Function} [customizer] The function to customize path creation.
 * @returns {Object} Returns `object`.
 */
function baseSet(object, path, value, customizer) {
  if (!isObject_1(object)) {
    return object;
  }
  path = _castPath(path, object);

  var index = -1,
      length = path.length,
      lastIndex = length - 1,
      nested = object;

  while (nested != null && ++index < length) {
    var key = _toKey(path[index]),
        newValue = value;

    if (index != lastIndex) {
      var objValue = nested[key];
      newValue = customizer ? customizer(objValue, key, nested) : undefined;
      if (newValue === undefined) {
        newValue = isObject_1(objValue)
          ? objValue
          : (_isIndex(path[index + 1]) ? [] : {});
      }
    }
    _assignValue(nested, key, newValue);
    nested = nested[key];
  }
  return object;
}

var _baseSet = baseSet;

/**
 * The base implementation of  `_.pickBy` without support for iteratee shorthands.
 *
 * @private
 * @param {Object} object The source object.
 * @param {string[]} paths The property paths to pick.
 * @param {Function} predicate The function invoked per property.
 * @returns {Object} Returns the new object.
 */
function basePickBy(object, paths, predicate) {
  var index = -1,
      length = paths.length,
      result = {};

  while (++index < length) {
    var path = paths[index],
        value = _baseGet(object, path);

    if (predicate(value, path)) {
      _baseSet(result, _castPath(path, object), value);
    }
  }
  return result;
}

var _basePickBy = basePickBy;

/**
 * The base implementation of `_.hasIn` without support for deep paths.
 *
 * @private
 * @param {Object} [object] The object to query.
 * @param {Array|string} key The key to check.
 * @returns {boolean} Returns `true` if `key` exists, else `false`.
 */
function baseHasIn(object, key) {
  return object != null && key in Object(object);
}

var _baseHasIn = baseHasIn;

/**
 * Checks if `path` exists on `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {Array|string} path The path to check.
 * @param {Function} hasFunc The function to check properties.
 * @returns {boolean} Returns `true` if `path` exists, else `false`.
 */
function hasPath(object, path, hasFunc) {
  path = _castPath(path, object);

  var index = -1,
      length = path.length,
      result = false;

  while (++index < length) {
    var key = _toKey(path[index]);
    if (!(result = object != null && hasFunc(object, key))) {
      break;
    }
    object = object[key];
  }
  if (result || ++index != length) {
    return result;
  }
  length = object == null ? 0 : object.length;
  return !!length && isLength_1(length) && _isIndex(key, length) &&
    (isArray_1(object) || isArguments_1(object));
}

var _hasPath = hasPath;

/**
 * Checks if `path` is a direct or inherited property of `object`.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Object
 * @param {Object} object The object to query.
 * @param {Array|string} path The path to check.
 * @returns {boolean} Returns `true` if `path` exists, else `false`.
 * @example
 *
 * var object = _.create({ 'a': _.create({ 'b': 2 }) });
 *
 * _.hasIn(object, 'a');
 * // => true
 *
 * _.hasIn(object, 'a.b');
 * // => true
 *
 * _.hasIn(object, ['a', 'b']);
 * // => true
 *
 * _.hasIn(object, 'b');
 * // => false
 */
function hasIn(object, path) {
  return object != null && _hasPath(object, path, _baseHasIn);
}

var hasIn_1 = hasIn;

/**
 * The base implementation of `_.pick` without support for individual
 * property identifiers.
 *
 * @private
 * @param {Object} object The source object.
 * @param {string[]} paths The property paths to pick.
 * @returns {Object} Returns the new object.
 */
function basePick(object, paths) {
  return _basePickBy(object, paths, function(value, path) {
    return hasIn_1(object, path);
  });
}

var _basePick = basePick;

/**
 * Creates an object composed of the picked `object` properties.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Object
 * @param {Object} object The source object.
 * @param {...(string|string[])} [paths] The property paths to pick.
 * @returns {Object} Returns the new object.
 * @example
 *
 * var object = { 'a': 1, 'b': '2', 'c': 3 };
 *
 * _.pick(object, ['a', 'c']);
 * // => { 'a': 1, 'c': 3 }
 */
var pick = _flatRest(function(object, paths) {
  return object == null ? {} : _basePick(object, paths);
});

var pick_1 = pick;

var checkIfHasAudio = function checkIfHasAudio(video) {
  return video.mozHasAudio || Boolean(video.webkitAudioDecodedByteCount) || Boolean(video.audioTracks && video.audioTracks.length);
};

var VideoContext = createContext({
    dimensions: {},
});

var _class, _class2, _temp;

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(source, true).forEach(function (key) { defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(source).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }
var IS_MOBILE = mobileCheck(); // TODO `useContext` makes this irrelevant if we're using hooks

var withVideoContext = function withVideoContext() {
  var whitelist = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
  var blacklist = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
  return function (WrappedComponent) {
    return function VideoContextHoC(props) {
      var getContext = function getContext(context) {
        var selected = whitelist.length ? pick_1(context, whitelist) : context;
        return blacklist.length ? omit_1(selected, blacklist) : selected;
      };

      return React.createElement(VideoContext.Consumer, null, function (context) {
        return React.createElement(WrappedComponent, _extends_1({}, getContext(context), props));
      });
    };
  };
};
var spread = produce(Object.assign); // state that will change for every video

var getDefaultMediaState = function getDefaultMediaState() {
  return {
    mediaState: '',
    playhead: 0,
    scrubProgress: 0,
    error: null,
    ended: false,
    isReady: false,
    hasAudio: false
  };
};

var VideoContextManager = withStorageContext(_class = (_temp = _class2 =
/*#__PURE__*/
function (_PureComponent) {
  inherits(VideoContextManager, _PureComponent);

  createClass(VideoContextManager, null, [{
    key: "getDerivedStateFromProps",
    value: function getDerivedStateFromProps(_ref, prevState) {
      var videoData = _ref.videoData,
          toggleShare = _ref.toggleShare;

      if (videoData.id !== prevState.videoData.id) {
        // reset state that pertains to the video
        return _objectSpread({}, getDefaultMediaState(), {
          videoData: videoData,
          isShare: false
        });
      }

      if (toggleShare !== prevState.toggleShare) {
        return {
          isShare: !prevState.isShare,
          toggleShare: toggleShare
        };
      }

      return null;
    }
  }]);

  function VideoContextManager(props) {
    var _this;

    classCallCheck(this, VideoContextManager);

    _this = possibleConstructorReturn(this, getPrototypeOf(VideoContextManager).call(this, props));

    defineProperty(assertThisInitialized(_this), "videoEl", null);

    defineProperty(assertThisInitialized(_this), "value", {});

    defineProperty(assertThisInitialized(_this), "api", {
      play: function play() {
        _this.videoEl.play(); // check audio again, onCanPlay doesn't
        // seem to be accurate


        var hasAudio = checkIfHasAudio(_this.videoEl);

        _this.setState({
          hasAudio: hasAudio
        });
      },
      pause: function pause() {
        return _this.videoEl.pause();
      },
      fullscreenVideoEl: function fullscreenVideoEl() {
        return _this.videoEl.webkitEnterFullscreen();
      },
      getDuration: function getDuration() {
        if (_this.videoEl && !isNaN(_this.videoEl.duration)) {
          return _this.videoEl.duration;
        }

        return 0;
      },
      scrub: function scrub(scrubProgress) {
        _this.videoEl.currentTime = scrubProgress * _this.videoEl.duration;

        _this.setState({
          scrubProgress: scrubProgress
        });
      },
      setVideoEl: function setVideoEl(videoEl) {
        // possibly, all videoEl stuff would be encapsulated in the video.js file,
        // but then would we need state for isPlaying etc.?
        _this.videoEl = videoEl;
      },
      setPoster: function setPoster(showPoster) {
        return _this.setState({
          showPoster: showPoster
        });
      },
      onStateChange: function onStateChange(mediaState) {
        _this.setState({
          mediaState: mediaState
        });
      },
      onTimeUpdate: function onTimeUpdate(playhead) {
        return _this.setState({
          playhead: playhead
        });
      },
      onCanPlay: function onCanPlay() {
        var hasAudio = checkIfHasAudio(_this.videoEl);

        _this.setState({
          isReady: true,
          hasAudio: hasAudio
        });
      },
      onError: function onError(error) {
        return _this.setState({
          error: error
        });
      },
      onEnded: function onEnded() {
        return _this.setState({
          ended: true
        });
      },
      setMuted: function setMuted(isMuted) {
        return _this.props.saveSession({
          isMuted: isMuted
        });
      },
      setFullscreen: function setFullscreen(isFullscreen) {
        return _this.setState({
          isFullscreen: isFullscreen
        });
      },
      setLoop: function setLoop(isLoop) {
        return _this.setState({
          isLoop: isLoop
        });
      },
      setVolume: function setVolume(volume) {
        return _this.props.saveSession({
          volume: volume
        });
      },
      setRenditionInfo: function setRenditionInfo(_ref2) {
        var hdAvailable = _ref2.hdAvailable,
            sdAvailable = _ref2.sdAvailable;
        return _this.setState({
          hdAvailable: hdAvailable,
          sdAvailable: sdAvailable
        });
      },
      setHD: function setHD(isHD) {
        return _this.props.saveSession({
          isHD: isHD
        });
      },
      setIsShare: function setIsShare(isShare) {
        return _this.setState({
          isShare: isShare
        });
      },
      onShareAction: function onShareAction(shareAction) {
        return _this.setState({
          shareAction: shareAction
        });
      },
      setIsOverlayVisible: function setIsOverlayVisible(isOverlayVisible) {
        return _this.setState({
          isOverlayVisible: isOverlayVisible
        });
      }
    });

    var _this$props = _this.props,
        forceMute = _this$props.forceMute,
        saveSession = _this$props.saveSession,
        autoPlay = _this$props.autoPlay,
        videoData = _this$props.videoData; // if the player was initialized with forceMute
    // or the user has muted

    if (forceMute) {
      saveSession({
        isMuted: true
      });
    }

    _this.state = _objectSpread({}, getDefaultMediaState(), {
      showPoster: !autoPlay,
      showTooltips: !IS_MOBILE,
      isOverlayVisible: false,
      isFullscreen: false,
      isShare: false,
      toggleShare: false,
      isLoop: true,
      videoData: videoData
    });
    return _this;
  }

  createClass(VideoContextManager, [{
    key: "render",
    value: function render() {
      var _this$props2 = this.props,
          videoData = _this$props2.videoData,
          children = _this$props2.children,
          _this$props2$dimensio = _this$props2.dimensions,
          dimensions = _this$props2$dimensio === void 0 ? {} : _this$props2$dimensio,
          playerElement = _this$props2.playerElement,
          noShare = _this$props2.noShare,
          noCutout = _this$props2.noCutout,
          _this$props2$session = _this$props2.session,
          _this$props2$session$ = _this$props2$session.isMuted,
          isMuted = _this$props2$session$ === void 0 ? false : _this$props2$session$,
          _this$props2$session$2 = _this$props2$session.volume,
          volume = _this$props2$session$2 === void 0 ? 0.7 : _this$props2$session$2,
          _this$props2$session$3 = _this$props2$session.isHD,
          isHD = _this$props2$session$3 === void 0 ? true : _this$props2$session$3;
      var _this$state = this.state,
          isFullscreen = _this$state.isFullscreen,
          showPoster = _this$state.showPoster;
      var width = dimensions.width,
          height = dimensions.height;
      var isSmall = !isFullscreen && (height <= 200 || width <= 300); // value === this.value, if nothing changes

      var value = spread(this.value, _objectSpread({}, this.state, {}, this.api, {
        noCutout: showPoster || isFullscreen || isSmall || noCutout,
        // hide cutout when player is small or fullscreen
        videoData: videoData,
        playerElement: playerElement,
        dimensions: dimensions,
        isMuted: isMuted,
        volume: volume,
        isHD: isHD,
        noShare: noShare,
        isSmall: isSmall
      }));
      this.value = value;
      return React.createElement(VideoContext.Provider, {
        value: value
      }, children);
    }
  }]);

  return VideoContextManager;
}(PureComponent), defineProperty(_class2, "propTypes", {}), _temp)) || _class;

function _taggedTemplateLiteral(strings, raw) {
  if (!raw) {
    raw = strings.slice(0);
  }

  return Object.freeze(Object.defineProperties(strings, {
    raw: {
      value: Object.freeze(raw)
    }
  }));
}

var taggedTemplateLiteral = _taggedTemplateLiteral;

var mediaHasRoomToGrow = function (media, width, height) { return media.width < width || media.height < height; };
var getBestMedia = function (gif, _a, isHD, isFullscreen) {
    var width = _a.width, height = _a.height;
    var video = gif.video;
    var assets = video.assets;
    if (isFullscreen) {
        width = innerWidth;
        height = innerHeight;
    }
    var filteredAssets = Object.values(omit$1(assets, 'source')).sort(function (a, b) { return a.width - b.width; });
    var media;
    if (isHD) {
        media = bestfit(filteredAssets, width, height);
    }
    else {
        // TODO this was just temporaty, maybe we choose the next lowest?
        media = bestfit(filteredAssets, width / 2, height / 2);
    }
    var lowestRendition = filteredAssets[0];
    var highestRendition = filteredAssets[filteredAssets.length - 1];
    return {
        media: media,
        hdAvailable: mediaHasRoomToGrow(media, width, height) && media !== highestRendition,
        sdAvailable: lowestRendition !== media,
    };
};

var _dec, _class$1, _temp$1;

function _templateObject() {
  var data = taggedTemplateLiteral(["\n    width: 100%;\n    height: 100%;\n    object-fit: contain;\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}
var VideoStyled = styled.video(_templateObject());
var MEDIA_STATE = {
  PLAYING: 'playing',
  PAUSED: 'paused'
};

var getErrorMessage = function getErrorMessage(code) {
  var src = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';

  switch (code) {
    case 1:
      return "Aborted. The fetching process for the media resource was aborted by the user agent at the user's request.";

    case 2:
      return 'Network Error. A network error of some description caused the user agent to stop fetching the media resource, after the resource was established to be usable.';

    case 3:
      return 'Decode Error. An error of some description occurred while decoding the media resource, after the resource was established to be usable.';

    case 4:
      return "Can not play a video of type \"".concat(src.split('.').pop(), "\" on this platform.");

    default:
      return '';
  }
};

var Video = (_dec = withVideoContext(undefined, ['playhead']), _dec(_class$1 = (_temp$1 =
/*#__PURE__*/
function (_PureComponent) {
  inherits(Video, _PureComponent);

  function Video() {
    var _getPrototypeOf2;

    var _this;

    classCallCheck(this, Video);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = possibleConstructorReturn(this, (_getPrototypeOf2 = getPrototypeOf(Video)).call.apply(_getPrototypeOf2, [this].concat(args)));

    defineProperty(assertThisInitialized(_this), "state", {});

    defineProperty(assertThisInitialized(_this), "onError", function () {
      var _this$videoEl = _this.videoEl,
          code = _this$videoEl.error.code,
          src = _this$videoEl.src;
      var message = getErrorMessage(code, src);
      console.error(message);

      _this.props.onError(code);
    });

    defineProperty(assertThisInitialized(_this), "onPlaying", function () {
      return _this.props.onStateChange(MEDIA_STATE.PLAYING);
    });

    defineProperty(assertThisInitialized(_this), "onPaused", function () {
      return _this.props.onStateChange(MEDIA_STATE.PAUSED);
    });

    defineProperty(assertThisInitialized(_this), "onTimeUpdate", function () {
      return _this.props.onTimeUpdate(_this.videoEl.currentTime);
    });

    defineProperty(assertThisInitialized(_this), "onCanPlay", function () {
      return _this.props.onCanPlay();
    });

    defineProperty(assertThisInitialized(_this), "onEnded", function () {
      return _this.props.onEnded();
    });

    defineProperty(assertThisInitialized(_this), "onEndFullscreen", function () {
      return _this.props.setFullscreen(false);
    });

    defineProperty(assertThisInitialized(_this), "addEvents", function () {
      var _assertThisInitialize = assertThisInitialized(_this),
          videoEl = _assertThisInitialize.videoEl;

      videoEl.addEventListener('play', _this.onPlaying);
      videoEl.addEventListener('pause', _this.onPaused);
      videoEl.addEventListener('error', _this.onError);
      videoEl.addEventListener('timeupdate', _this.onTimeUpdate);
      videoEl.addEventListener('canplay', _this.onCanPlay);
      videoEl.addEventListener('ended', _this.onEnded);
      videoEl.addEventListener('webkitendfullscreen', _this.onEndFullscreen); // this is needed for iOS
    });

    return _this;
  }

  createClass(Video, [{
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      var videoEl = this.videoEl;
      videoEl.removeEventListener('play', this.onPlaying);
      videoEl.removeEventListener('pause', this.onPaused);
      videoEl.removeEventListener('error', this.onError);
      videoEl.removeEventListener('timeupdate', this.onTimeUpdate);
      videoEl.removeEventListener('canplay', this.onCanPlay);
      videoEl.removeEventListener('ended', this.onEnded);
      videoEl.removeEventListener('webkitendfullscreen', this.onEndFullscreen);
    }
  }, {
    key: "componentDidMount",
    value: function componentDidMount() {
      var _this$props = this.props,
          volume = _this$props.volume,
          setVideoEl = _this$props.setVideoEl,
          setRenditionInfo = _this$props.setRenditionInfo;
      setVideoEl(this.videoEl);
      this.addEvents(this.videoEl);

      if (!isNaN(volume)) {
        this.videoEl.volume = volume;
      }

      var _this$state = this.state,
          hdAvailable = _this$state.hdAvailable,
          sdAvailable = _this$state.sdAvailable;
      setRenditionInfo({
        hdAvailable: hdAvailable,
        sdAvailable: sdAvailable
      });
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate(_ref, _ref2) {
      var prevVolume = _ref.volume;
      var prevHDAvailable = _ref2.hdAvailable,
          prevSDAvailable = _ref2.sdAvailable;
      var volume = this.props.volume;

      if (volume !== prevVolume && !isNaN(volume)) {
        this.videoEl.volume = volume;
      }

      var _this$state2 = this.state,
          hdAvailable = _this$state2.hdAvailable,
          sdAvailable = _this$state2.sdAvailable;

      if (hdAvailable !== prevHDAvailable || sdAvailable !== prevSDAvailable) {
        var setRenditionInfo = this.props.setRenditionInfo;
        setRenditionInfo({
          hdAvailable: hdAvailable,
          sdAvailable: sdAvailable
        });
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;

      var _this$props2 = this.props,
          isFullscreen = _this$props2.isFullscreen,
          isMuted = _this$props2.isMuted,
          isLoop = _this$props2.isLoop;
      var src = this.state.media.url;
      return React.createElement(VideoStyled, {
        autoPlay: true,
        isFullscreen: isFullscreen,
        loop: isLoop,
        muted: isMuted,
        playsInline: true,
        ref: function ref(c) {
          return _this2.videoEl = c;
        },
        src: src
      });
    }
  }], [{
    key: "getDerivedStateFromProps",
    value: function getDerivedStateFromProps(_ref3, prevState) {
      var dimensions = _ref3.dimensions,
          videoData = _ref3.videoData,
          isHD = _ref3.isHD,
          isFullscreen = _ref3.isFullscreen;

      if (videoData !== prevState.videoData || dimensions !== prevState.dimensions || isHD !== prevState.isHD || isFullscreen !== prevState.isFullscreen) {
        var _getBestMedia = getBestMedia(videoData, dimensions, isHD, isFullscreen),
            media = _getBestMedia.media,
            hdAvailable = _getBestMedia.hdAvailable,
            sdAvailable = _getBestMedia.sdAvailable;

        return {
          media: media,
          hdAvailable: hdAvailable,
          sdAvailable: sdAvailable,
          dimensions: dimensions,
          videoData: videoData,
          isHD: isHD,
          isFullscreen: isFullscreen
        };
      }

      return null;
    }
  }]);

  return Video;
}(PureComponent), _temp$1)) || _class$1);

var _dec$1, _class$2, _temp$2;
var FullscreenManager = (_dec$1 = withVideoContext(['isFullscreen', 'playerElement', 'setFullscreen', 'play', 'pause', 'mediaState']), _dec$1(_class$2 = (_temp$2 =
/*#__PURE__*/
function (_PureComponent) {
  inherits(FullscreenManager, _PureComponent);

  function FullscreenManager() {
    var _getPrototypeOf2;

    var _this;

    classCallCheck(this, FullscreenManager);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = possibleConstructorReturn(this, (_getPrototypeOf2 = getPrototypeOf(FullscreenManager)).call.apply(_getPrototypeOf2, [this].concat(args)));

    defineProperty(assertThisInitialized(_this), "onFullscreenChange", function () {
      if (document.fullscreenElement === null) {
        var setFullscreen = _this.props.setFullscreen;
        setFullscreen(false);
      }
    });

    defineProperty(assertThisInitialized(_this), "onKeyDown", function (e) {
      var _this$props = _this.props,
          play = _this$props.play,
          pause = _this$props.pause,
          mediaState = _this$props.mediaState;

      if (e.which === 32) {
        e.preventDefault();
        mediaState === MEDIA_STATE.PLAYING ? pause() : play();
      }
    });

    return _this;
  }

  createClass(FullscreenManager, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      document.addEventListener('fullscreenchange', this.onFullscreenChange);
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      document.removeEventListener('fullscreenchange', this.onFullscreenChange);
      this.unbindKeyEvents();
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps) {
      var _this$props2 = this.props,
          isFullscreen = _this$props2.isFullscreen,
          playerElement = _this$props2.playerElement;

      if (isFullscreen !== prevProps.isFullscreen) {
        try {
          // isFullscreen is more like go fullscreen
          !isFullscreen ? document.exitFullscreen() : playerElement.requestFullscreen();
          !isFullscreen ? this.unbindKeyEvents() : this.bindKeyEvents();
        } catch (error) {}
      }
    }
  }, {
    key: "bindKeyEvents",
    value: function bindKeyEvents() {
      document.addEventListener('keydown', this.onKeyDown, false);
    }
  }, {
    key: "unbindKeyEvents",
    value: function unbindKeyEvents() {
      document.removeEventListener('keydown', this.onKeyDown, false);
    }
  }, {
    key: "render",
    value: function render() {
      return null;
    }
  }]);

  return FullscreenManager;
}(PureComponent), _temp$2)) || _class$2);

var _dec$2, _class$3, _class2$1, _temp$3;

function _templateObject2() {
  var data = taggedTemplateLiteral(["\n    animation: ", " 0.2s ease-out;\n    cursor: pointer;\n    font-size: 18px;\n    height: 60px;\n    line-height: 64px;\n    text-align: center;\n    width: 60px;\n    position: absolute;\n    right: 55px;\n"]);

  _templateObject2 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject$1() {
  var data = taggedTemplateLiteral(["\n    box-sizing: border-box;\n    display: flex;\n    height: 60px;\n    left: 0;\n    padding: 0 ", "px 0 20px;\n    position: absolute;\n    top: 0;\n    transform: translateY(", "%);\n    transition: transform 0.2s ease-out;\n    width: 100%;\n    z-index: 1;\n\n    &:before {\n        background: linear-gradient(rgba(18, 18, 18, 0.6), rgba(0, 0, 0, 0));\n        content: '';\n        height: ", "px;\n        left: 0;\n        pointer-events: none;\n        position: absolute;\n        top: 0;\n        width: 100%;\n        z-index: -1;\n    }\n\n    ", ";\n"]);

  _templateObject$1 = function _templateObject() {
    return data;
  };

  return data;
}
var shareButtonIn = keyframes(["0%{opacity:0;transform:rotate(-180deg);}100%{opacity:1;transform:rotate(0deg);}"]);
var Container$1 = styled.div(_templateObject$1(), function (props) {
  return props.noPadding ? 10 : 60;
}, function (props) {
  return props.isVisible ? 0 : -100;
}, function (props) {
  return props.dimSize;
}, function (props) {
  return props.isSmall && css$6(["padding-left:10px;padding-right:0;"]);
});
var Share = styled.div(_templateObject2(), shareButtonIn);
var Header = (_dec$2 = withVideoContext(['videoData', 'setIsShare', 'isFullscreen', 'noShare', 'noCutout', 'isSmall']), _dec$2(_class$3 = (_temp$3 = _class2$1 =
/*#__PURE__*/
function (_PureComponent) {
  inherits(Header, _PureComponent);

  function Header() {
    var _getPrototypeOf2;

    var _this;

    classCallCheck(this, Header);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = possibleConstructorReturn(this, (_getPrototypeOf2 = getPrototypeOf(Header)).call.apply(_getPrototypeOf2, [this].concat(args)));

    defineProperty(assertThisInitialized(_this), "onShareClick", function () {
      _this.props.setIsShare(true);
    });

    return _this;
  }

  createClass(Header, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
          dimSize = _this$props.dimSize,
          isVisible = _this$props.isVisible,
          isSmall = _this$props.isSmall,
          onMouseOver = _this$props.onMouseOver,
          noShare = _this$props.noShare,
          noCutout = _this$props.noCutout;
      return React.createElement(Container$1, {
        dimSize: dimSize,
        isSmall: isSmall,
        isVisible: isVisible,
        noPadding: noCutout,
        onMouseOver: onMouseOver
      }, !noShare && React.createElement(Share, {
        className: "ss-send",
        onClick: this.onShareClick
      }));
    }
  }]);

  return Header;
}(PureComponent), defineProperty(_class2$1, "defaultProps", {
  dimSize: 0,
  isVisible: false,
  isSmall: false,
  setIsShare: function setIsShare() {},
  videoData: {}
}), _temp$3)) || _class$3);

/**
 * The base implementation of `_.rest` which doesn't validate or coerce arguments.
 *
 * @private
 * @param {Function} func The function to apply a rest parameter to.
 * @param {number} [start=func.length-1] The start position of the rest parameter.
 * @returns {Function} Returns the new function.
 */
function baseRest(func, start) {
  return _setToString(_overRest(func, start, identity_1), func + '');
}

var _baseRest = baseRest;

/**
 * The base implementation of `_.findIndex` and `_.findLastIndex` without
 * support for iteratee shorthands.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {Function} predicate The function invoked per iteration.
 * @param {number} fromIndex The index to search from.
 * @param {boolean} [fromRight] Specify iterating from right to left.
 * @returns {number} Returns the index of the matched value, else `-1`.
 */
function baseFindIndex(array, predicate, fromIndex, fromRight) {
  var length = array.length,
      index = fromIndex + (fromRight ? 1 : -1);

  while ((fromRight ? index-- : ++index < length)) {
    if (predicate(array[index], index, array)) {
      return index;
    }
  }
  return -1;
}

var _baseFindIndex = baseFindIndex;

/**
 * The base implementation of `_.isNaN` without support for number objects.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is `NaN`, else `false`.
 */
function baseIsNaN(value) {
  return value !== value;
}

var _baseIsNaN = baseIsNaN;

/**
 * A specialized version of `_.indexOf` which performs strict equality
 * comparisons of values, i.e. `===`.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {*} value The value to search for.
 * @param {number} fromIndex The index to search from.
 * @returns {number} Returns the index of the matched value, else `-1`.
 */
function strictIndexOf(array, value, fromIndex) {
  var index = fromIndex - 1,
      length = array.length;

  while (++index < length) {
    if (array[index] === value) {
      return index;
    }
  }
  return -1;
}

var _strictIndexOf = strictIndexOf;

/**
 * The base implementation of `_.indexOf` without `fromIndex` bounds checks.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {*} value The value to search for.
 * @param {number} fromIndex The index to search from.
 * @returns {number} Returns the index of the matched value, else `-1`.
 */
function baseIndexOf(array, value, fromIndex) {
  return value === value
    ? _strictIndexOf(array, value, fromIndex)
    : _baseFindIndex(array, _baseIsNaN, fromIndex);
}

var _baseIndexOf = baseIndexOf;

/**
 * This function is like `baseIndexOf` except that it accepts a comparator.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {*} value The value to search for.
 * @param {number} fromIndex The index to search from.
 * @param {Function} comparator The comparator invoked per element.
 * @returns {number} Returns the index of the matched value, else `-1`.
 */
function baseIndexOfWith(array, value, fromIndex, comparator) {
  var index = fromIndex - 1,
      length = array.length;

  while (++index < length) {
    if (comparator(array[index], value)) {
      return index;
    }
  }
  return -1;
}

var _baseIndexOfWith = baseIndexOfWith;

/** Used for built-in method references. */
var arrayProto$1 = Array.prototype;

/** Built-in value references. */
var splice$1 = arrayProto$1.splice;

/**
 * The base implementation of `_.pullAllBy` without support for iteratee
 * shorthands.
 *
 * @private
 * @param {Array} array The array to modify.
 * @param {Array} values The values to remove.
 * @param {Function} [iteratee] The iteratee invoked per element.
 * @param {Function} [comparator] The comparator invoked per element.
 * @returns {Array} Returns `array`.
 */
function basePullAll(array, values, iteratee, comparator) {
  var indexOf = comparator ? _baseIndexOfWith : _baseIndexOf,
      index = -1,
      length = values.length,
      seen = array;

  if (array === values) {
    values = _copyArray(values);
  }
  if (iteratee) {
    seen = _arrayMap(array, _baseUnary(iteratee));
  }
  while (++index < length) {
    var fromIndex = 0,
        value = values[index],
        computed = iteratee ? iteratee(value) : value;

    while ((fromIndex = indexOf(seen, computed, fromIndex, comparator)) > -1) {
      if (seen !== array) {
        splice$1.call(seen, fromIndex, 1);
      }
      splice$1.call(array, fromIndex, 1);
    }
  }
  return array;
}

var _basePullAll = basePullAll;

/**
 * This method is like `_.pull` except that it accepts an array of values to remove.
 *
 * **Note:** Unlike `_.difference`, this method mutates `array`.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Array
 * @param {Array} array The array to modify.
 * @param {Array} values The values to remove.
 * @returns {Array} Returns `array`.
 * @example
 *
 * var array = ['a', 'b', 'c', 'a', 'b', 'c'];
 *
 * _.pullAll(array, ['a', 'c']);
 * console.log(array);
 * // => ['b', 'b']
 */
function pullAll(array, values) {
  return (array && array.length && values && values.length)
    ? _basePullAll(array, values)
    : array;
}

var pullAll_1 = pullAll;

/**
 * Removes all given values from `array` using
 * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
 * for equality comparisons.
 *
 * **Note:** Unlike `_.without`, this method mutates `array`. Use `_.remove`
 * to remove elements from an array by predicate.
 *
 * @static
 * @memberOf _
 * @since 2.0.0
 * @category Array
 * @param {Array} array The array to modify.
 * @param {...*} [values] The values to remove.
 * @returns {Array} Returns `array`.
 * @example
 *
 * var array = ['a', 'b', 'c', 'a', 'b', 'c'];
 *
 * _.pull(array, 'a', 'c');
 * console.log(array);
 * // => ['b', 'b']
 */
var pull = _baseRest(pullAll_1);

var pull_1 = pull;

function ownKeys$1(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread$1(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys$1(source, true).forEach(function (key) { defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys$1(source).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }
var darkDropdown = {
  dropdownTextColor: giphyWhite,
  dropdownBackgroundColor: giphyDarkestGrey
};
var lightDropdown = {
  dropdownTextColor: giphyDarkGrey,
  dropdownBackgroundColor: giphyWhite
};
var lightSelectorBar = {
  dropdownDisplay: {
    color: giphyDarkGrey,
    background: giphyWhite,
    textAlign: 'left',
    padding: null
  },
  arrow: {
    background: primaryCTA,
    color: giphyWhite
  }
};
var darkSelectorBar = {
  dropdownDisplay: {
    color: giphyLightGrey,
    background: giphyDarkGrey,
    textAlign: 'left',
    padding: null
  },
  arrow: {
    background: giphyDarkestGrey,
    color: giphyBlue
  }
};
var transparentSelectorBar = {
  dropdownDisplay: {
    color: giphyWhite,
    background: 'transparent',
    textAlign: 'right',
    padding: '0px 0px 0px 0px'
  },
  arrow: {
    background: 'transparent',
    color: giphyWhite
  }
}; // white background transparent selector

var transparent = _objectSpread$1({
  container: {
    minWidth: '10px'
  }
}, transparentSelectorBar, {}, lightDropdown);
var transparentDark = _objectSpread$1({
  container: {
    minWidth: '10px'
  }
}, transparentSelectorBar, {}, darkDropdown); // dark dropdown dark selector

var dark = _objectSpread$1({
  container: {
    minWidth: '150px'
  }
}, darkSelectorBar, {}, darkDropdown); // light background dark selector

var darkLight = _objectSpread$1({
  container: {
    minWidth: '150px'
  }
}, darkSelectorBar, {}, lightDropdown); // light dropdown light selector

var light = _objectSpread$1({
  container: {
    minWidth: '150px'
  }
}, lightSelectorBar, {}, lightDropdown); // light background dark selector

var lightDark = _objectSpread$1({
  container: {
    minWidth: '150px'
  }
}, lightSelectorBar, {}, darkDropdown);

var themes = /*#__PURE__*/Object.freeze({
    __proto__: null,
    transparent: transparent,
    transparentDark: transparentDark,
    dark: dark,
    darkLight: darkLight,
    light: light,
    lightDark: lightDark
});

function _templateObject2$1() {
  var data = taggedTemplateLiteral(["\n    border-bottom: 6px solid ", ";\n    border-left: 6px solid transparent;\n    border-right: 6px solid transparent;\n    height: 0;\n    margin-left: -6px;\n    position: absolute;\n    top: ", ";\n    bottom: ", ";\n    transform: ", ";\n    width: 0;\n"]);

  _templateObject2$1 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject$2() {
  var data = taggedTemplateLiteral(["\n    ", ";\n    background: ", ";\n    ", ";\n    box-sizing: border-box;\n    color: ", ";\n    min-width: ", "px;\n    padding: 15px 20px;\n    position: relative;\n    text-align: left;\n    z-index: 2147483646;\n\n    hr {\n        background: ", ";\n        clear: both;\n        height: 1px;\n        margin: 10px 0;\n        width: 100%;\n    }\n"]);

  _templateObject$2 = function _templateObject() {
    return data;
  };

  return data;
}
var dropdownUp = keyframes(["0%{opacity:0;transform:translateY(-10px);}100%{opacity:1;transform:translateY(0);}"]);
var dropdownDown = keyframes(["0%{opacity:0;transform:translateY(10px);}100%{opacity:1;transform:translateY(0);}"]);
var DropdownContainer = styled.div(_templateObject$2(), function (props) {
  return props.animate && css$6(["animation:", " 0.2s ease-out;"], function (props) {
    return props.isExtendUp ? dropdownDown : dropdownUp;
  });
}, function (props) {
  return props.theme.dropdownBackgroundColor;
}, function (props) {
  return props.shadow && css$6(["box-shadow:0 2px 20px 0 rgba(0,0,0,0.5);"]);
}, function (props) {
  return props.theme.dropdownTextColor;
}, function (props) {
  return props.autoSize ? 0 : 165;
}, giphyLightGrey);
var Nip = styled.div(_templateObject2$1(), function (props) {
  return props.theme.dropdownBackgroundColor;
}, function (props) {
  return props.isExtendUp ? null : '-6px';
}, function (props) {
  return props.isExtendUp ? '-6px' : null;
}, function (props) {
  return props.isExtendUp ? 'rotate(180deg) translateY(1px)' : null;
});

var Dropdown = function Dropdown(_ref) {
  var isExtendUp = _ref.isExtendUp,
      children = _ref.children,
      _ref$autoSize = _ref.autoSize,
      autoSize = _ref$autoSize === void 0 ? false : _ref$autoSize,
      _ref$nipX = _ref.nipX,
      nipX = _ref$nipX === void 0 ? '50%' : _ref$nipX,
      _ref$hasNip = _ref.hasNip,
      hasNip = _ref$hasNip === void 0 ? true : _ref$hasNip,
      _ref$shadow = _ref.shadow,
      shadow = _ref$shadow === void 0 ? true : _ref$shadow,
      _ref$animate = _ref.animate,
      animate = _ref$animate === void 0 ? true : _ref$animate,
      _ref$theme = _ref.theme,
      theme = _ref$theme === void 0 ? 'light' : _ref$theme;
  return React.createElement(ThemeProvider, {
    theme: themes[theme]
  }, React.createElement(DropdownContainer, {
    animate: animate,
    autoSize: autoSize,
    shadow: shadow
  }, hasNip && React.createElement(Nip, {
    isExtendUp: isExtendUp,
    style: {
      left: nipX
    }
  }), children));
};

function _templateObject2$2() {
  var data = taggedTemplateLiteral(["\n    font-size: 14px;\n    font-weight: bold;\n    text-align: center;\n    -webkit-font-smoothing: antialiased;\n"]);

  _templateObject2$2 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject$3() {
  var data = taggedTemplateLiteral(["\n    left: 50%;\n    ", ";\n"]);

  _templateObject$3 = function _templateObject() {
    return data;
  };

  return data;
}
var Nip$1 = styled(Nip)(_templateObject$3(), function (props) {
  return props.isExtendUp ? css$6(["bottom:100%;"]) : css$6(["top:100%;"]);
});
var Container$2 = styled.div(function (_ref) {
  var isExtendUp = _ref.isExtendUp,
      delay = _ref.delay,
      offsetY = _ref.offsetY,
      offsetX = _ref.offsetX;
  return css$6(["opacity:0;animation:", " 0.2s ease-out ", "s forwards;pointer-events:none;position:absolute;top:", "px;left:", "px;right:0;bottom:0;"], isExtendUp ? dropdownDown : dropdownUp, delay, isExtendUp ? -offsetY : 0, offsetX);
});
var BubbleWrapper = styled.div(function (_ref2) {
  var isExtendUp = _ref2.isExtendUp,
      align = _ref2.align,
      isMultiWord = _ref2.isMultiWord,
      maxWidth = _ref2.maxWidth,
      bubbleOffset = _ref2.bubbleOffset;
  return css$6(["", " left:", ";position:absolute;right:", ";width:", ";", ";"], isExtendUp ? css$6(["bottom:100%;margin-bottom:6px;"]) : css$6(["top:100%;margin-top:6px;"]), align === 'right' ? "-".concat(bubbleOffset, "px") : 'auto', align === 'left' ? "-".concat(bubbleOffset, "px") : 'auto', isMultiWord ? "".concat(maxWidth, "px") : 'auto', align === 'center' && css$6(["left:50%;transform:translateX(-50%);"]));
});
var Label = styled.div(_templateObject2$2());

var TooltipView =
/*#__PURE__*/
function (_PureComponent) {
  inherits(TooltipView, _PureComponent);

  function TooltipView() {
    classCallCheck(this, TooltipView);

    return possibleConstructorReturn(this, getPrototypeOf(TooltipView).apply(this, arguments));
  }

  createClass(TooltipView, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
          align = _this$props.align,
          label = _this$props.label,
          theme = _this$props.theme,
          delay = _this$props.delay,
          isVisible = _this$props.isVisible,
          _this$props$isExtendU = _this$props.isExtendUp,
          isExtendUp = _this$props$isExtendU === void 0 ? true : _this$props$isExtendU,
          maxWidth = _this$props.maxWidth,
          bubbleOffset = _this$props.bubbleOffset,
          offsetY = _this$props.offsetY,
          offsetX = _this$props.offsetX;
      return React.createElement(Container$2, _extends_1({
        delay: delay / 1000
      }, {
        isExtendUp: isExtendUp,
        offsetY: offsetY,
        offsetX: offsetX
      }), React.createElement(BubbleWrapper, {
        align: align,
        bubbleOffset: bubbleOffset,
        isExtendUp: isExtendUp,
        isMultiWord: String(label).split(' ').length > 1,
        isVisible: isVisible,
        maxWidth: maxWidth
      }, React.createElement(Dropdown, {
        theme: theme,
        autoSize: true,
        isExtendUp: isExtendUp,
        hasNip: false,
        shadow: false,
        animate: false
      }, React.createElement(Label, null, label))), React.createElement(Nip$1, {
        isExtendUp: isExtendUp
      }));
    }
  }]);

  return TooltipView;
}(PureComponent);

defineProperty(TooltipView, "defaultProps", {
  align: 'center',
  label: '',
  theme: 'light',
  delay: 0,
  isVisible: false
});

var onHideCallbacks = [];

function _templateObject2$3() {
  var data = taggedTemplateLiteral(["\n    position: absolute;\n    width: 100%;\n    height: 100%;\n    top: 0;\n    left: 0;\n"]);

  _templateObject2$3 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject$4() {
  var data = taggedTemplateLiteral(["\n    position: relative;\n"]);

  _templateObject$4 = function _templateObject() {
    return data;
  };

  return data;
}
var MAX_WIDTH = 200;
var Container$3 = styled.div(_templateObject$4());
var TooltipContainer = styled.div(_templateObject2$3());

var Tooltip =
/*#__PURE__*/
function (_PureComponent) {
  inherits(Tooltip, _PureComponent);

  function Tooltip() {
    var _getPrototypeOf2;

    var _this;

    classCallCheck(this, Tooltip);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = possibleConstructorReturn(this, (_getPrototypeOf2 = getPrototypeOf(Tooltip)).call.apply(_getPrototypeOf2, [this].concat(args)));

    defineProperty(assertThisInitialized(_this), "state", {
      showToolTip: false,
      align: 'center'
    });

    defineProperty(assertThisInitialized(_this), "show", function (_ref) {
      var clientX = _ref.clientX,
          _ref$touches = _ref.touches,
          touches = _ref$touches === void 0 ? [] : _ref$touches;
      Tooltip.hideToolTips();

      pull_1(onHideCallbacks, _this.hide);

      onHideCallbacks.push(_this.hide); // use prop

      var _this$props = _this.props,
          align = _this$props.align,
          label = _this$props.label,
          maxWidth = _this$props.maxWidth;
      var isSingleWord = String(label).split(' ').length === 1;

      if (isSingleWord) {
        // force align center single word
        _this.setState({
          showToolTip: true,
          align: 'center'
        });
      } else {
        if (!align) {
          var _align = 'center'; // window size

          var middle = innerWidth / 2;
          var padding = 10;
          var maxHalfBubble = maxWidth / 2 + padding; // sometimes clientX is undefined on mobile

          if (!clientX && touches.length) {
            clientX = touches[0].clientX;
          }

          if (clientX < middle && clientX < maxHalfBubble) {
            _align = 'right';
          } else if (clientX > middle && innerWidth - clientX < maxHalfBubble) {
            _align = 'left';
          }

          _this.setState({
            showToolTip: true,
            align: _align
          });
        } else {
          _this.setState({
            showToolTip: true,
            align: align
          });
        }
      }
    });

    defineProperty(assertThisInitialized(_this), "handleTouch", function (e) {
      _this.show(e); // add a touch handler for the document
      // so when a user touches anything else
      // we can hide


      var onDocumentTouch = function onDocumentTouch(_ref2) {
        var currentNode = _ref2.target;

        while (currentNode.parentNode) {
          if (currentNode === _this.container) return;
          currentNode = currentNode.parentNode;
        }

        if (currentNode !== document) return;

        _this.hide();

        document.removeEventListener('touchstart', onDocumentTouch);
      };

      document.addEventListener('touchstart', onDocumentTouch);
    });

    defineProperty(assertThisInitialized(_this), "hide", function () {
      pull_1(onHideCallbacks, _this.hide);

      if (_this.unmounted) {
        return;
      }

      _this.setState({
        showToolTip: false
      });
    });

    return _this;
  }

  createClass(Tooltip, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      var showOnMount = this.props.showOnMount;

      if (showOnMount) {
        var _this$container$getBo = this.container.getBoundingClientRect(),
            left = _this$container$getBo.left,
            width = _this$container$getBo.width;

        this.show({
          clientX: left + width / 2
        });
      }
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      this.unmounted = true;

      pull_1(onHideCallbacks, this.hide);
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;

      var _this$state = this.state,
          showToolTip = _this$state.showToolTip,
          align = _this$state.align;
      var isExtendUp = true; // TODO extend down

      var _this$props2 = this.props,
          label = _this$props2.label,
          theme = _this$props2.theme,
          delay = _this$props2.delay,
          children = _this$props2.children,
          className = _this$props2.className,
          maxWidth = _this$props2.maxWidth,
          bubbleOffset = _this$props2.bubbleOffset,
          offsetY = _this$props2.offsetY,
          offsetX = _this$props2.offsetX;
      return React.createElement(Container$3, {
        className: className,
        onMouseEnter: this.show,
        onMouseLeave: this.hide,
        onTouchStart: this.handleTouch,
        ref: function ref(c) {
          return _this2.container = c;
        }
      }, showToolTip && label && React.createElement(TooltipContainer, null, React.createElement(TooltipView, _extends_1({
        align: align,
        theme: theme,
        delay: delay,
        label: label,
        isExtendUp: isExtendUp,
        maxWidth: maxWidth,
        bubbleOffset: bubbleOffset,
        offsetY: offsetY,
        offsetX: offsetX
      }, {
        isVisible: true
      }))), children);
    }
  }]);

  return Tooltip;
}(PureComponent);

defineProperty(Tooltip, "defaultProps", {
  label: '',
  theme: 'light',
  delay: 0,
  showOnMount: false,
  maxWidth: MAX_WIDTH,
  bubbleOffset: 20,
  // offset from bubble to arrow when not centered
  offsetY: 3,
  // for tweaking arrow (nip) position Y
  offsetX: 0 // for tweaking arrow (nip) position X

});

defineProperty(Tooltip, "hideToolTips", function () {
  return onHideCallbacks.forEach(function (cb) {
    return cb();
  });
});

function _templateObject3() {
  var data = taggedTemplateLiteral(["\n    align-items: center;\n    display: flex;\n    height: 100%;\n    justify-content: center;\n    left: 0;\n    pointer-events: none;\n    position: absolute;\n    top: 0;\n    transition: opacity 0.2s ease-out, transform 0.2s ease-out;\n    width: 100%;\n"]);

  _templateObject3 = function _templateObject3() {
    return data;
  };

  return data;
}

function _templateObject2$4() {
  var data = taggedTemplateLiteral(["\n    cursor: pointer;\n    height: 100%;\n    left: 0;\n    position: absolute;\n    top: 0;\n    transition: transform 0.2s ease-out;\n    width: 100%;\n\n    &:before {\n        background: ", ";\n        content: '';\n        display: block;\n        height: 100%;\n        opacity: 0;\n        transition: opacity 0.2s ease-out;\n        width: 100%;\n    }\n\n    &:hover {\n        transform: scale(1.1);\n\n        &:before {\n            opacity: 1;\n        }\n    }\n"]);

  _templateObject2$4 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject$5() {
  var data = taggedTemplateLiteral(["\n    flex-grow: 0;\n    flex-shrink: 0;\n    height: ", "px;\n    position: relative;\n    width: ", "px;\n    ", ";\n"]);

  _templateObject$5 = function _templateObject() {
    return data;
  };

  return data;
}
var Container$4 = styled.div(_templateObject$5(), function (props) {
  return props.size;
}, function (props) {
  return props.size;
}, function (props) {
  return props.disabled && css$6(["pointer-events:none;"]);
});
var Button = styled.div(_templateObject2$4(), function (props) {
  return props.backgroundColor;
});
var IconWrapper = styled.div(_templateObject3());

var getIconStyles = function getIconStyles(index, activeIndex) {
  return {
    opacity: activeIndex % 2 === index ? 1 : 0,
    transform: activeIndex % 2 === index ? 'scale(1.0)' : 'scale(0.6)'
  };
};

var AnimatedButton =
/*#__PURE__*/
function (_PureComponent) {
  inherits(AnimatedButton, _PureComponent);

  function AnimatedButton(props) {
    var _this;

    classCallCheck(this, AnimatedButton);

    _this = possibleConstructorReturn(this, getPrototypeOf(AnimatedButton).call(this, props));

    defineProperty(assertThisInitialized(_this), "animateIcon", function () {
      _this.setState({
        iconPosition: _this.state.iconPosition + 1
      });
    });

    _this.state = {
      iconPosition: props.isOn ? 0 : 1
    };
    return _this;
  }

  createClass(AnimatedButton, [{
    key: "componentDidUpdate",
    value: function componentDidUpdate(_ref) {
      var prevIsOn = _ref.isOn;

      if (this.props.isOn !== prevIsOn) {
        this.animateIcon();
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props = this.props,
          backgroundColor = _this$props.backgroundColor,
          className = _this$props.className,
          _this$props$tooltip = _this$props.tooltip,
          tooltip = _this$props$tooltip === void 0 ? {} : _this$props$tooltip,
          size = _this$props.size,
          onIcon = _this$props.onIcon,
          offIcon = _this$props.offIcon,
          onClick = _this$props.onClick;
      var iconPosition = this.state.iconPosition;
      return React.createElement(Tooltip, _extends_1({}, tooltip, {
        maxWidth: 130,
        offsetY: 6
      }), React.createElement(Container$4, {
        className: className,
        size: size
      }, React.createElement(Button, {
        backgroundColor: backgroundColor,
        onClick: onClick
      }, React.createElement(IconWrapper, {
        style: getIconStyles(0, iconPosition)
      }, onIcon), React.createElement(IconWrapper, {
        style: getIconStyles(1, iconPosition)
      }, offIcon))));
    }
  }]);

  return AnimatedButton;
}(PureComponent);

defineProperty(AnimatedButton, "defaultProps", {
  backgroundColor: 'transparent',
  size: 38,
  onIcon: null,
  offIcon: null,
  onClick: null,
  isOn: false,
  tooltip: undefined
});

var FullscreenEnterIcon = function FullscreenEnterIcon(_ref) {
  var _ref$size = _ref.size,
      size = _ref$size === void 0 ? 38 : _ref$size;
  return React.createElement("svg", {
    height: size,
    viewBox: "0 0 115 115",
    width: size,
    xmlns: "http://www.w3.org/2000/svg"
  }, React.createElement("path", {
    d: "M28.624 49.45c.195-.194.448-.318.758-.373l10.98-.088a.874.874 0 0 1 .705.265c.197.196.286.43.267.702l-.228 21.87 21.695.11a.874.874 0 0 1 .705.266c.197.196.285.43.267.702l-.258 10.986c-.008.283-.125.537-.35.761-.226.225-.48.34-.765.349l-33.412-.126a.93.93 0 0 1-.713-.274.922.922 0 0 1-.275-.71l.267-33.704c.056-.308.175-.554.357-.736zm58.752 11.1a1.386 1.386 0 0 1-.758.373l-10.98.088a.874.874 0 0 1-.705-.265.866.866 0 0 1-.267-.702l.228-21.87-21.695-.11a.874.874 0 0 1-.705-.266.866.866 0 0 1-.267-.702l.258-10.986c.008-.283.125-.537.35-.761.226-.225.48-.34.765-.349l33.412.126a.93.93 0 0 1 .713.274c.191.19.283.427.275.71l-.267 33.704c-.056.308-.175.554-.357.736z",
    fill: "#FFF",
    fillRule: "evenodd"
  }));
};
var FullscreenExitIcon = function FullscreenExitIcon(_ref2) {
  var _ref2$size = _ref2.size,
      size = _ref2$size === void 0 ? 38 : _ref2$size;
  return React.createElement("svg", {
    height: size,
    viewBox: "0 0 115 115",
    width: size,
    xmlns: "http://www.w3.org/2000/svg"
  }, React.createElement("path", {
    d: "M59.47 23.401c.168-.168.386-.275.655-.323l9.493-.076c.236-.016.44.06.61.23a.75.75 0 0 1 .23.607l-.197 18.924 18.757.095c.237-.016.44.06.61.23a.75.75 0 0 1 .23.608l-.222 9.506a.948.948 0 0 1-.303.658.955.955 0 0 1-.66.302l-28.889-.11a.804.804 0 0 1-.617-.236.798.798 0 0 1-.237-.614l.23-29.164c.048-.267.151-.48.31-.637zm-3.078 63.426a1.198 1.198 0 0 1-.656.324l-9.493.076a.755.755 0 0 1-.61-.23.75.75 0 0 1-.23-.608l.197-18.924-18.757-.095a.755.755 0 0 1-.61-.23.75.75 0 0 1-.23-.607l.222-9.506a.948.948 0 0 1 .303-.658.955.955 0 0 1 .66-.302l28.889.11a.804.804 0 0 1 .617.236c.165.164.244.37.237.614l-.23 29.163a1.16 1.16 0 0 1-.31.637z",
    fill: "#FFF",
    fillRule: "evenodd"
  }));
};

function _templateObject$6() {
  var data = taggedTemplateLiteral(["\n    box-shadow: 0 2px 20px rgba(0, 0, 0, 0.33);\n    display: block;\n    position: relative;\n    transition: box-shadow 0.2s ease-out;\n\n    path {\n        transition: all 0.2s ease-out;\n    }\n\n    &:hover {\n        box-shadow: 0 0 0 4px ", ";\n\n        path[data-playbackground] {\n            fill: ", ";\n        }\n\n        path[data-playicon] {\n            animation: ", " 1s linear 0s infinite;\n            opacity: 1;\n        }\n    }\n"]);

  _templateObject$6 = function _templateObject() {
    return data;
  };

  return data;
}
var jazzy = keyframes(["0%{fill:", ";}16%{fill:", ";}32%{fill:", ";}48%{fill:", ";}64%{fill:", ";}80%{fill:", ";}100%{fill:", ";}"], giphyPurple, giphyBlue, giphyGreen, giphyYellow, giphyRed, giphyPink, giphyPurple);
var PlaySVG = styled.svg(_templateObject$6(), giphyBlack, giphyBlack, jazzy);
var PlayPauseSize = 38;
var PlayIcon = function PlayIcon(_ref) {
  var _ref$size = _ref.size,
      size = _ref$size === void 0 ? PlayPauseSize : _ref$size;
  return React.createElement(PlaySVG, {
    height: size,
    viewBox: "0 0 45 45",
    width: size,
    xmlns: "http://www.w3.org/2000/svg"
  }, React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, React.createElement("path", {
    d: "M0 0h45v45H0V0zm15.836 10.842a.804.804 0 0 0-.417.12l-.024 23.75c.107.087.244.13.41.13.11 0 5.99-3.787 17.639-11.361a.389.389 0 0 0 .161-.311.389.389 0 0 0-.161-.31L16.24 10.961a.782.782 0 0 0-.404-.12z",
    "data-playbackground": true,
    fill: "#FFF",
    fillRule: "nonzero"
  }), React.createElement("path", {
    d: "M15.836 10.842c.135 0 .27.04.404.12L33.444 22.86c.107.087.161.19.161.311 0 .12-.054.224-.161.31-11.649 7.575-17.528 11.362-17.64 11.362a.632.632 0 0 1-.41-.13l.025-23.75a.804.804 0 0 1 .417-.12z",
    "data-playicon": true,
    fill: "#121212",
    opacity: ".5"
  })));
};
var PauseIcon = function PauseIcon(_ref2) {
  var _ref2$size = _ref2.size,
      size = _ref2$size === void 0 ? PlayPauseSize : _ref2$size;
  return React.createElement("svg", {
    height: size,
    viewBox: "0 0 50 50",
    width: size,
    xmlns: "http://www.w3.org/2000/svg"
  }, React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, React.createElement("path", {
    d: "m0 0h50v50h-50z"
  }), React.createElement("g", {
    fill: "#fff",
    transform: "translate(10 10)"
  }, React.createElement("path", {
    d: "m.208696 29.208696v-28c0-.55228475.44771525-1 1-1h9.25c.5522847 0 1 .44771525 1 1v28c0 .5522847-.4477153 1-1 1h-9.25c-.55228475 0-1-.4477153-1-1z"
  }), React.createElement("path", {
    d: "m18.958696 29.208696v-28c0-.55228475.4477153-1 1-1h9.25c.5522847 0 1 .44771525 1 1v28c0 .5522847-.4477153 1-1 1h-9.25c-.5522847 0-1-.4477153-1-1z"
  }))));
};

var _dec$3, _class$4, _temp$4;

function _templateObject$7() {
  var data = taggedTemplateLiteral(["\n    margin-right: 6px;\n    margin-top: ", "px;\n"]);

  _templateObject$7 = function _templateObject() {
    return data;
  };

  return data;
}
var FullscreenToggleButton = styled(AnimatedButton)(_templateObject$7(), PlayPauseSize / 2);
var FullscreenButton = (_dec$3 = withVideoContext(['isFullscreen', 'setFullscreen', 'fullscreenVideoEl', 'showTooltips']), _dec$3(_class$4 = (_temp$4 =
/*#__PURE__*/
function (_PureComponent) {
  inherits(FullscreenButton, _PureComponent);

  function FullscreenButton() {
    var _getPrototypeOf2;

    var _this;

    classCallCheck(this, FullscreenButton);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = possibleConstructorReturn(this, (_getPrototypeOf2 = getPrototypeOf(FullscreenButton)).call.apply(_getPrototypeOf2, [this].concat(args)));

    defineProperty(assertThisInitialized(_this), "toggleFullscreen", function () {
      var _this$props = _this.props,
          isFullscreen = _this$props.isFullscreen,
          setFullscreen = _this$props.setFullscreen,
          fullscreenVideoEl = _this$props.fullscreenVideoEl;

      if (document.fullscreenEnabled) {
        setFullscreen(!isFullscreen);
      } else {
        fullscreenVideoEl(); // forever in fullscreen after this,
        // since there is no way to know
        // and we want to show HR on fullscreen

        setFullscreen(true);
      }
    });

    return _this;
  }

  createClass(FullscreenButton, [{
    key: "render",
    value: function render() {
      var _this$props2 = this.props,
          showTooltips = _this$props2.showTooltips,
          isFullscreen = _this$props2.isFullscreen;
      var tooltip = {
        align: 'left',
        label: "".concat(isFullscreen ? 'Exit' : 'Enter', " Fullscreen"),
        delay: 1500,
        bubbleOffset: 0
      };
      return React.createElement(FullscreenToggleButton, {
        isOn: isFullscreen,
        offIcon: React.createElement(FullscreenEnterIcon, null),
        onClick: this.toggleFullscreen,
        onIcon: React.createElement(FullscreenExitIcon, null),
        tooltip: showTooltips ? tooltip : null
      });
    }
  }]);

  return FullscreenButton;
}(PureComponent), _temp$4)) || _class$4);

var _dec$4, _class$5, _temp$5;

function _templateObject$8() {
  var data = taggedTemplateLiteral(["\n    flex-grow: 0;\n    flex-shrink: 0;\n    height: 38px;\n    overflow: hidden;\n    width: 38px;\n    margin: ", ";\n\n    ", "\n"]);

  _templateObject$8 = function _templateObject() {
    return data;
  };

  return data;
}
var Container$5 = styled.div(_templateObject$8(), function (props) {
  return props.centered ? '-19px 0 0 -19px' : '0 0 5px';
}, function (props) {
  return props.centered && css$6(["position:absolute;left:50%;top:50%;z-index:1;"]);
});
var PlayPause = (_dec$4 = withVideoContext(['play', 'pause', 'mediaState']), _dec$4(_class$5 = (_temp$5 =
/*#__PURE__*/
function (_PureComponent) {
  inherits(PlayPause, _PureComponent);

  function PlayPause() {
    var _getPrototypeOf2;

    var _this;

    classCallCheck(this, PlayPause);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = possibleConstructorReturn(this, (_getPrototypeOf2 = getPrototypeOf(PlayPause)).call.apply(_getPrototypeOf2, [this].concat(args)));

    defineProperty(assertThisInitialized(_this), "togglePlay", function () {
      var _this$props = _this.props,
          play = _this$props.play,
          pause = _this$props.pause,
          mediaState = _this$props.mediaState;
      mediaState === MEDIA_STATE.PLAYING ? pause() : play();
    });

    return _this;
  }

  createClass(PlayPause, [{
    key: "render",
    value: function render() {
      var _this$props2 = this.props,
          mediaState = _this$props2.mediaState,
          _this$props2$centered = _this$props2.centered,
          centered = _this$props2$centered === void 0 ? false : _this$props2$centered;
      return React.createElement(Container$5, {
        centered: centered
      }, React.createElement(AnimatedButton, {
        isOn: mediaState === MEDIA_STATE.PLAYING,
        offIcon: React.createElement(PlayIcon, null),
        onClick: this.togglePlay,
        onIcon: React.createElement(PauseIcon, null)
      }));
    }
  }]);

  return PlayPause;
}(PureComponent), _temp$5)) || _class$5);

var VolumeOnIcon = function VolumeOnIcon(_ref) {
  var _ref$size = _ref.size,
      size = _ref$size === void 0 ? 38 : _ref$size;
  return React.createElement("svg", {
    height: size,
    viewBox: "0 0 115 115",
    width: size,
    xmlns: "http://www.w3.org/2000/svg"
  }, React.createElement("g", {
    fill: "#FFF",
    fillRule: "evenodd"
  }, React.createElement("path", {
    d: "M59.48 26.507v56.986c0 .68-.305 1.148-.914 1.405-.703.211-1.253.094-1.651-.351L40.824 66.88H29.51c-.422 0-.78-.146-1.072-.439A1.458 1.458 0 0 1 28 65.37V44.607c0-.422.146-.779.44-1.072.292-.292.65-.439 1.07-.439h11.314l16.09-17.643c.399-.445.95-.562 1.652-.351.609.257.913.726.913 1.405z"
  }), React.createElement("path", {
    d: "M69.468 67.346l-2.837-6.4A6.501 6.501 0 0 0 70.5 55a6.501 6.501 0 0 0-3.855-5.94l2.854-6.392A13.5 13.5 0 0 1 77.5 55a13.5 13.5 0 0 1-8.032 12.346z",
    fillRule: "nonzero"
  }), React.createElement("path", {
    d: "M76.328 78.321l-2.838-6.4A18.503 18.503 0 0 0 84.5 55c0-7.373-4.351-13.95-10.968-16.903l2.853-6.392A25.502 25.502 0 0 1 91.5 55a25.502 25.502 0 0 1-15.172 23.321z",
    fillRule: "nonzero"
  })));
};
var VolumeOffIcon = function VolumeOffIcon(_ref2) {
  var _ref2$size = _ref2.size,
      size = _ref2$size === void 0 ? 38 : _ref2$size;
  return React.createElement("svg", {
    height: size,
    viewBox: "0 0 115 115",
    width: size,
    xmlns: "http://www.w3.org/2000/svg"
  }, React.createElement("g", {
    fill: "#FFF",
    fillRule: "evenodd"
  }, React.createElement("path", {
    d: "M90.853 62.002a.637.637 0 0 1 0 .815l-4.036 4.036a.637.637 0 0 1-.815 0L79 59.851l-7.002 7.002a.637.637 0 0 1-.815 0l-4.036-4.036a.637.637 0 0 1 0-.815L74.149 55l-7.002-7.002a.637.637 0 0 1 0-.815l4.036-4.036a.637.637 0 0 1 .815 0L79 50.149l7.002-7.002a.637.637 0 0 1 .815 0l4.036 4.036a.637.637 0 0 1 0 .815L83.851 55l7.002 7.002zM59.48 26.507v56.986c0 .68-.305 1.148-.914 1.405-.703.211-1.253.094-1.651-.351L40.824 66.88H29.51c-.422 0-.78-.146-1.072-.439A1.458 1.458 0 0 1 28 65.37V44.607c0-.422.146-.779.44-1.072.292-.292.65-.439 1.07-.439h11.314l16.09-17.643c.399-.445.95-.562 1.652-.351.609.257.913.726.913 1.405z"
  })));
};

var _dec$5, _class$6, _temp$6;

function _templateObject$9() {
  var data = taggedTemplateLiteral(["\n    animation: ", " ", "s ease-in-out 0.8s 1 normal backwards;\n    flex-grow: 0;\n    flex-shrink: 0;\n    height: 38px;\n    margin-right: 5px;\n    opacity: ", ";\n    position: relative;\n    pointer-events: ", ";\n    width: 38px;\n    margin-top: ", "px;\n"]);

  _templateObject$9 = function _templateObject() {
    return data;
  };

  return data;
}
var bloop = keyframes(["0%{transform:scale(1) translateY(0);}50%{transform:scale(1.5) translateY(-30%);}100%{transform:scale(1) translateY(0);}"]);
var Container$6 = styled.div(_templateObject$9(), bloop, function (props) {
  return props.isMuted ? 0.5 : 0;
}, function (props) {
  return props.hasAudio ? 1 : 0.3;
}, function (props) {
  return props.hasAudio ? 'auto' : 'none';
}, PlayPauseSize / 2);
var Volume = (_dec$5 = withVideoContext(['hasAudio', 'isReady', 'isMuted', 'setMuted']), _dec$5(_class$6 = (_temp$6 =
/*#__PURE__*/
function (_PureComponent) {
  inherits(Volume, _PureComponent);

  function Volume() {
    var _getPrototypeOf2;

    var _this;

    classCallCheck(this, Volume);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = possibleConstructorReturn(this, (_getPrototypeOf2 = getPrototypeOf(Volume)).call.apply(_getPrototypeOf2, [this].concat(args)));

    defineProperty(assertThisInitialized(_this), "toggleMute", function () {
      var _this$props = _this.props,
          isMuted = _this$props.isMuted,
          setMuted = _this$props.setMuted;
      setMuted(!isMuted);
    });

    return _this;
  }

  createClass(Volume, [{
    key: "render",
    value: function render() {
      var _this$props2 = this.props,
          isMuted = _this$props2.isMuted,
          isReady = _this$props2.isReady,
          hasAudio = _this$props2.hasAudio;
      return React.createElement(Container$6, {
        hasAudio: hasAudio,
        isMuted: isMuted
      }, React.createElement(AnimatedButton, {
        disabled: !isReady,
        isOn: !isMuted && hasAudio,
        offIcon: React.createElement(VolumeOffIcon, null),
        onClick: this.toggleMute,
        onIcon: React.createElement(VolumeOnIcon, null)
      }));
    }
  }]);

  return Volume;
}(PureComponent), _temp$6)) || _class$6);

// seems like we need these...
var FOOTER = 2;
var SLIDER = FOOTER + 1;

function _templateObject2$5() {
  var data = taggedTemplateLiteral(["\n    flex: 1;\n"]);

  _templateObject2$5 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject$a() {
  var data = taggedTemplateLiteral(["\n    display: flex;\n    padding: ", "px;\n    pointer-events: ", ";\n    position: relative;\n    align-items: center;\n    transform: translateY(", "%);\n    transition: transform 0.2s ease-out;\n    z-index: ", ";\n\n    &:before {\n        background: linear-gradient(rgba(0, 0, 0, 0), rgba(18, 18, 18, 0.6));\n        bottom: 0;\n        content: '';\n        height: ", "px;\n        left: 0;\n        pointer-events: none;\n        position: absolute;\n        width: 100%;\n        z-index: -1;\n    }\n\n    svg {\n        display: block;\n    }\n"]);

  _templateObject$a = function _templateObject() {
    return data;
  };

  return data;
}
var IS_MOBILE$1 = mobileCheck();
var Container$7 = styled.div(_templateObject$a(), function (props) {
  return props.isSmall ? 6 : 10;
}, function (props) {
  return props.isVisible ? 'auto' : 'none';
}, function (props) {
  return props.isVisible ? 0 : 100;
}, FOOTER, function (props) {
  return props.dimSize;
});
var Phil = styled.div(_templateObject2$5());

var Footer = function Footer(_ref) {
  var _ref$dimSize = _ref.dimSize,
      dimSize = _ref$dimSize === void 0 ? 0 : _ref$dimSize,
      _ref$isSmall = _ref.isSmall,
      isSmall = _ref$isSmall === void 0 ? false : _ref$isSmall,
      _ref$isVisible = _ref.isVisible,
      isVisible = _ref$isVisible === void 0 ? false : _ref$isVisible,
      onMouseOver = _ref.onMouseOver;
  return React.createElement(Container$7, {
    dimSize: dimSize,
    isSmall: isSmall,
    isVisible: isVisible,
    onMouseOver: onMouseOver
  }, !IS_MOBILE$1 && React.createElement(PlayPause, null), React.createElement(Phil, null), React.createElement(Volume, {
    showSlider: !IS_MOBILE$1 && !isSmall
  }), React.createElement(FullscreenButton, null));
};

var Footer$1 = withVideoContext(['videoData', 'playhead'])(Footer);

var Container$8 = styled.div(templateObject_1$1 || (templateObject_1$1 = __makeTemplateObject(["\n    height: 100%;\n    pointer-events: none;\n    position: absolute;\n    bottom: 0;\n    left: 0;\n    transform: translate3d(0, 0, 0);\n    width: 100%;\n    z-index: ", ";\n"], ["\n    height: 100%;\n    pointer-events: none;\n    position: absolute;\n    bottom: 0;\n    left: 0;\n    transform: translate3d(0, 0, 0);\n    width: 100%;\n    z-index: ", ";\n"])), SLIDER);
var Value = styled.div(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n    background: ", ";\n    height: 5px;\n    position: absolute;\n    width: 5px;\n    bottom: -1px;\n    left: 0;\n"], ["\n    background: ", ";\n    height: 5px;\n    position: absolute;\n    width: 5px;\n    bottom: -1px;\n    left: 0;\n"])), giphyWhite);
var Slider = function () {
    var _a = useContext(VideoContext), isSmall = _a.isSmall, playhead = _a.playhead, getDuration = _a.getDuration;
    var duration = getDuration();
    if (duration < 6)
        return null;
    var progress = playhead / duration;
    var progressValue = Math.round(progress * 100) + "%";
    var style = { width: progressValue };
    return !isSmall ? (React.createElement(Container$8, null,
        React.createElement(Value, { style: style }))) : null;
};
var templateObject_1$1, templateObject_2;

var _dec$6, _class$7, _class2$2, _temp$7;

function _templateObject2$6() {
  var data = taggedTemplateLiteral(["\n    height: 100%;\n    left: 0;\n    position: absolute;\n    top: 0;\n    width: 100%;\n    z-index: 1;\n"]);

  _templateObject2$6 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject$b() {
  var data = taggedTemplateLiteral(["\n    position: absolute;\n    top: 0;\n    left: 0;\n    opacity: ", ";\n    overflow: hidden;\n    width: 100%;\n    height: 100%;\n    display: flex;\n    transition: opacity 0.2s ease-out;\n    flex-direction: column;\n    justify-content: flex-end;\n"]);

  _templateObject$b = function _templateObject() {
    return data;
  };

  return data;
}
var CONTROLS_DIM_SIZE = 125;
var IS_MOBILE$2 = mobileCheck();
var Container$9 = styled.div(_templateObject$b(), function (props) {
  return props.isVisible ? 1 : 0;
});
var HitZone = styled.div(_templateObject2$6());
var Controls = (_dec$6 = withVideoContext(['dimensions', 'play', 'pause', 'mediaState', 'isOverlayVisible', 'setIsOverlayVisible']), _dec$6(_class$7 = (_temp$7 = _class2$2 =
/*#__PURE__*/
function (_PureComponent) {
  inherits(Controls, _PureComponent);

  function Controls() {
    var _getPrototypeOf2;

    var _this;

    classCallCheck(this, Controls);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = possibleConstructorReturn(this, (_getPrototypeOf2 = getPrototypeOf(Controls)).call.apply(_getPrototypeOf2, [this].concat(args)));

    defineProperty(assertThisInitialized(_this), "overlayTimeout", null);

    defineProperty(assertThisInitialized(_this), "hasPeeked", false);

    defineProperty(assertThisInitialized(_this), "peekOverlay", function () {
      _this.showOverlay();

      _this.overlayTimeout = setTimeout(function () {
        _this.hasPeeked = true;

        _this.hideOverlay();
      }, 2000);
    });

    defineProperty(assertThisInitialized(_this), "hideOverlay", function () {
      if (!_this.hasPeeked) return;
      var setIsOverlayVisible = _this.props.setIsOverlayVisible;
      clearTimeout(_this.overlayTimeout);
      setIsOverlayVisible(false);
    });

    defineProperty(assertThisInitialized(_this), "showOverlay", function () {
      var setIsOverlayVisible = _this.props.setIsOverlayVisible;
      clearTimeout(_this.overlayTimeout);
      setIsOverlayVisible(true);
    });

    defineProperty(assertThisInitialized(_this), "toggleOverlay", function () {
      var isOverlayVisible = _this.props.isOverlayVisible;
      isOverlayVisible ? _this.hideOverlay() : _this.peekOverlay();
    });

    defineProperty(assertThisInitialized(_this), "togglePlayPause", function () {
      var _this$props = _this.props,
          play = _this$props.play,
          pause = _this$props.pause,
          mediaState = _this$props.mediaState;
      mediaState === MEDIA_STATE.PLAYING ? pause() : play();
    });

    defineProperty(assertThisInitialized(_this), "onHitClick", function () {
      if (IS_MOBILE$2) {
        _this.toggleOverlay();
      } else {
        _this.togglePlayPause();
      }
    });

    return _this;
  }

  createClass(Controls, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      // show overlay for first 2 seconds and then hide
      this.peekOverlay();
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      clearTimeout(this.overlayTimeout);
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props2 = this.props,
          className = _this$props2.className,
          isOverlayVisible = _this$props2.isOverlayVisible;
      return React.createElement(Container$9, {
        className: className,
        isVisible: isOverlayVisible,
        onMouseOut: this.hideOverlay
      }, React.createElement(FullscreenManager, null), React.createElement(HitZone, {
        onClick: this.onHitClick,
        onMouseMove: IS_MOBILE$2 ? null : this.peekOverlay
      }), React.createElement(Header, {
        dimSize: CONTROLS_DIM_SIZE,
        isVisible: isOverlayVisible,
        onMouseOver: this.showOverlay
      }), IS_MOBILE$2 && React.createElement(PlayPause, {
        centered: true,
        onClick: this.showOverlay
      }), React.createElement(Footer$1, {
        dimSize: CONTROLS_DIM_SIZE,
        isVisible: isOverlayVisible,
        onMouseOver: this.showOverlay
      }), React.createElement(Slider, null));
    }
  }]);

  return Controls;
}(PureComponent), defineProperty(_class2$2, "defaultProps", {
  dimensions: {},
  play: function play() {},
  pause: function pause() {},
  mediaState: {},
  isOverlayVisible: false,
  setIsOverlayVisible: function setIsOverlayVisible() {}
}), _temp$7)) || _class$7);

function _templateObject3$1() {
  var data = taggedTemplateLiteral(["\n    animation: ", " 0.2s ease-out;\n    color: ", ";\n    cursor: pointer;\n    font-size: 16px;\n    height: 60px;\n    line-height: 64px;\n    margin-left: auto;\n    margin-right: -10px;\n    text-align: center;\n    width: 60px;\n"]);

  _templateObject3$1 = function _templateObject3() {
    return data;
  };

  return data;
}

function _templateObject2$7() {
  var data = taggedTemplateLiteral(["\n    border-bottom: 1px solid rgba(216, 216, 216, 0.16);\n    box-sizing: border-box;\n    display: flex;\n    flex-shrink: 0;\n    font-size: 16px;\n    height: 60px;\n    line-height: 60px;\n    margin: 0 ", "px 0 25px;\n\n    ", ";\n"]);

  _templateObject2$7 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject$c() {
  var data = taggedTemplateLiteral(["\n    box-shadow: ", ";\n    color: ", ";\n    font-weight: bold;\n"]);

  _templateObject$c = function _templateObject() {
    return data;
  };

  return data;
}
var closeButtonIn = keyframes(["0%{transform:rotate(-180deg);}100%{transform:rotate(0deg);}"]);
var Tab = styled.div(_templateObject$c(), function (props) {
  return props.active ? "inset 0 -4px 0 ".concat(giphyBlue) : 'none';
}, function (props) {
  return props.active ? giphyBlue : giphyWhite;
});
var Container$a = styled.div(_templateObject2$7(), function (props) {
  return props.noPadding ? 20 : 70;
}, function (props) {
  return props.isSmall && css$6(["border-bottom:0;margin:0 10px;", "{box-shadow:none;}"], Tab);
});
var CloseButton = styled.div(_templateObject3$1(), closeButtonIn, giphyWhite);

var ShareHeader = function ShareHeader(_ref) {
  var isFullscreen = _ref.isFullscreen,
      isSmall = _ref.isSmall,
      setIsShare = _ref.setIsShare,
      noCutout = _ref.noCutout;
  return React.createElement(Container$a, {
    isSmall: isSmall,
    noPadding: isFullscreen || noCutout
  }, React.createElement(Tab, {
    active: true
  }, "Share Link"), React.createElement(CloseButton, {
    className: "ss-delete",
    onClick: function onClick() {
      return setIsShare(false);
    }
  }));
};

var Header$1 = withVideoContext(['isFullscreen', 'setIsShare', 'noCutout', 'isSmall'])(ShareHeader);

var isiOS = function isiOS() {
  return /iPad|iPhone|iPod/.test(navigator.userAgent) && !window.MSStream;
};

var LINKS = [{
  id: 'facebook',
  backgroundColor: facebookColor,
  className: 'ss-social ss-facebook',
  getUrl: function getUrl(url) {
    return "http://www.facebook.com/sharer/sharer.php?u=".concat(encodeURIComponent(url || location.href));
  }
}, {
  id: 'twitter',
  backgroundColor: twitterColor,
  className: 'ss-social ss-twitter',
  getUrl: function getUrl(url) {
    return "http://twitter.com/share?url=".concat(encodeURIComponent(url || location.href), "?tc=1&via=giphy");
  }
}, {
  id: 'instagram',
  backgroundColor: instagramColor,
  className: 'ss-social ss-instagram',
  getUrl: function getUrl(url) {
    return "/login/?next=".concat(encodeURIComponent(url || location.href), "&ref=auth_required");
  }
}, {
  id: 'pinterest',
  backgroundColor: pinterestColor,
  className: 'ss-social ss-pinterest',
  getUrl: function getUrl(shareUrl, mediaUrl, description) {
    return "http://pinterest.com/pin/create/bookmarklet/?media=".concat(mediaUrl, "&url=").concat(encodeURIComponent(shareUrl || location.href), "&description=").concat(description);
  }
}, {
  id: 'reddit',
  backgroundColor: redditColor,
  className: 'ss-social ss-reddit',
  getUrl: function getUrl(url) {
    return "//www.reddit.com/submit?url=".concat(encodeURIComponent(url || location.href));
  }
}]; // if mobile, add sms link

mobileCheck() && LINKS.unshift({
  id: 'sms',
  backgroundColor: smsColor,
  className: 'ss-chat',
  getUrl: function getUrl(url) {
    return "sms:".concat(isiOS() ? '&' : '?', "body=").concat(encodeURIComponent(url || location.href));
  }
});

var titleFont = "'nexablack', sans-serif";
var smallTitleSize = '20px';
var titleSize = '26px';
var largeTitleSize = '36px';
var subheaderSize = '16px';
var smallSubheaderSize = '12px';
var Title = styled.div(templateObject_1$2 || (templateObject_1$2 = __makeTemplateObject(["\n    font-family: ", ";\n    -webkit-font-smoothing: antialiased;\n    font-size: ", ";\n"], ["\n    font-family: ", ";\n    -webkit-font-smoothing: antialiased;\n    font-size: ", ";\n"])), titleFont, titleSize);
var TitleLarge = styled(Title)(templateObject_2$1 || (templateObject_2$1 = __makeTemplateObject(["\n    font-size: ", ";\n"], ["\n    font-size: ", ";\n"])), largeTitleSize);
var TitleSmall = styled(Title)(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n    font-size: ", ";\n"], ["\n    font-size: ", ";\n"])), smallTitleSize);
var Subheader = styled.div(templateObject_4 || (templateObject_4 = __makeTemplateObject(["\n    font-size: ", ";\n    font-weight: bold;\n    -webkit-font-smoothing: antialiased;\n"], ["\n    font-size: ", ";\n    font-weight: bold;\n    -webkit-font-smoothing: antialiased;\n"])), subheaderSize);
var SubheaderSmall = styled(Subheader)(templateObject_5 || (templateObject_5 = __makeTemplateObject(["\n    font-size: ", ";\n"], ["\n    font-size: ", ";\n"])), smallSubheaderSize);
var SectionHeader = styled.div(templateObject_6 || (templateObject_6 = __makeTemplateObject(["\n    font-size: 14px;\n    font-weight: bold;\n    text-transform: capitalize;\n    -webkit-font-smoothing: antialiased;\n"], ["\n    font-size: 14px;\n    font-weight: bold;\n    text-transform: capitalize;\n    -webkit-font-smoothing: antialiased;\n"])));
var templateObject_1$2, templateObject_2$1, templateObject_3, templateObject_4, templateObject_5, templateObject_6;

function _templateObject$d() {
  var data = taggedTemplateLiteral(["\n    color: ", ";\n    margin-bottom: 10px;\n    text-transform: capitalize;\n"]);

  _templateObject$d = function _templateObject() {
    return data;
  };

  return data;
}
var SectionLabel = styled(Subheader)(_templateObject$d(), giphyLightGrey);

function _templateObject3$2() {
  var data = taggedTemplateLiteral(["\n    display: block;\n    color: ", ";\n    font-size: 18px;\n    height: 36px;\n    justify-content: center;\n    line-height: 40px;\n    margin-left: 10px;\n    text-align: center;\n    width: 100%;\n\n    &:first-child {\n        margin-left: 0;\n    }\n"]);

  _templateObject3$2 = function _templateObject3() {
    return data;
  };

  return data;
}

function _templateObject2$8() {
  var data = taggedTemplateLiteral(["\n    display: flex;\n    height: 36px;\n    width: 100%;\n"]);

  _templateObject2$8 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject$e() {
  var data = taggedTemplateLiteral(["\n    margin-bottom: ", "px;\n    width: 100%;\n"]);

  _templateObject$e = function _templateObject() {
    return data;
  };

  return data;
}
var Container$b = styled.div(_templateObject$e(), function (props) {
  return props.isSmall ? 10 : 20;
});
var Buttons = styled.div(_templateObject2$8());
var Button$1 = styled.a(_templateObject3$2(), giphyWhite);

var getBestFit = function getBestFit(assets, _ref) {
  var width = _ref.width,
      height = _ref.height;
  var keys = Object.keys(assets);
  return bestfit(keys.filter(function (key) {
    return key !== 'source';
  }).map(function (key) {
    return assets[key];
  }, width, height));
};

var ShareSocial = function ShareSocial(_ref2) {
  var _ref2$videoData = _ref2.videoData,
      url = _ref2$videoData.url,
      title = _ref2$videoData.title,
      assets = _ref2$videoData.video.assets,
      _ref2$dimensions = _ref2.dimensions,
      dimensions = _ref2$dimensions === void 0 ? {} : _ref2$dimensions,
      isSmall = _ref2.isSmall,
      onShareAction = _ref2.onShareAction;
  return React.createElement(Container$b, {
    isSmall: isSmall
  }, !isSmall && React.createElement(SectionLabel, null, "Share to Socials"), React.createElement(Buttons, null, LINKS.map(function (_ref3) {
    var backgroundColor = _ref3.backgroundColor,
        className = _ref3.className,
        getUrl = _ref3.getUrl,
        id = _ref3.id;
    return id !== 'instagram' && React.createElement(Button$1, {
      className: className,
      href: getUrl(url, getBestFit(assets, dimensions).url, title),
      key: id,
      onClick: function onClick() {
        return onShareAction(id);
      },
      rel: "noopener noreferrer",
      style: {
        backgroundColor: backgroundColor
      },
      target: "_blank"
    });
  })));
};

var Social = withVideoContext(['videoData', 'dimensions', 'isSmall', 'onShareAction'])(ShareSocial);

function _templateObject$f() {
  var data = taggedTemplateLiteral(["\n    white-space: nowrap;\n    border: 0;\n    box-sizing: border-box;\n    color: ", ";\n    cursor: pointer;\n    font-family: inherit;\n    font-size: 14px;\n    font-weight: bold;\n    height: 36px;\n    line-height: 36px;\n    min-width: 36px;\n    outline: none;\n    padding: 0 15px;\n    text-align: center;\n    user-select: none;\n    -webkit-appearance: none;\n    -webkit-font-smoothing: antialiased;\n\n    ", ";\n\n    &:active {\n        opacity: 0.9;\n    }\n\n    &:disabled {\n        cursor: default;\n        opacity: 0.5;\n    }\n    background-color: ", ";\n"]);

  _templateObject$f = function _templateObject() {
    return data;
  };

  return data;
}
var isMobile = mobileCheck();
var Button$2 = styled.button(_templateObject$f(), giphyWhite, !isMobile && css$6(["&:hover{color:", ";}"], giphyWhite), function (_ref) {
  var color = _ref.color,
      secondary = _ref.secondary,
      _ref$theme = _ref.theme,
      _ref$theme$buttonColo = _ref$theme.buttonColor,
      buttonColor = _ref$theme$buttonColo === void 0 ? primaryCTA : _ref$theme$buttonColo,
      _ref$theme$secondaryB = _ref$theme.secondaryButtonColor,
      secondaryButtonColor = _ref$theme$secondaryB === void 0 ? secondaryCTA : _ref$theme$secondaryB;
  return color || (secondary ? secondaryButtonColor : buttonColor);
});

function _templateObject$g() {
  var data = taggedTemplateLiteral(["\n    display: block;\n    width: 100%;\n    background-color: ", ";\n\n    ", ";\n    transition: background-color 0.1s ease-out;\n"]);

  _templateObject$g = function _templateObject() {
    return data;
  };

  return data;
}

var getButtonColor = function getButtonColor(_ref) {
  var primary = _ref.primary,
      secondary = _ref.secondary,
      error = _ref.error,
      success = _ref.success;

  if (success) {
    return giphyGreen;
  }

  if (error) {
    return giphyRed;
  }

  return primary ? primaryCTA : secondary ? secondaryCTA : giphyDarkGrey;
};

var Button$3 = styled(Button$2)(_templateObject$g(), function (props) {
  return getButtonColor(props);
}, function (props) {
  return props.success && css$6(["color:black;&:hover{color:black;}"]);
});

var showClipboard = Clipboard.isSupported();
var MESSAGE_DELAY = 2500,
    SUCCESS_MESSAGE = 'Link Copied!',
    ERROR_MESSAGE = 'Error Copying Link';

var CopyButton =
/*#__PURE__*/
function (_PureComponent) {
  inherits(CopyButton, _PureComponent);

  function CopyButton() {
    var _getPrototypeOf2;

    var _this;

    classCallCheck(this, CopyButton);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = possibleConstructorReturn(this, (_getPrototypeOf2 = getPrototypeOf(CopyButton)).call.apply(_getPrototypeOf2, [this].concat(args)));

    defineProperty(assertThisInitialized(_this), "state", {
      message: '',
      isError: false
    });

    defineProperty(assertThisInitialized(_this), "messageDelay", null);

    return _this;
  }

  createClass(CopyButton, [{
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      clearTimeout(this.messageDelay);
    }
  }, {
    key: "createClipboard",
    value: function createClipboard() {
      var _this2 = this;

      var url = this.props.url;
      this.clipboard = new Clipboard(this.copyButton, {
        text: function text() {
          return url;
        }
      });
      this.clipboard.on('success', function () {
        _this2.showMessage();
      });
      this.clipboard.on('error', function () {
        _this2.showMessage(true);
      });
    }
  }, {
    key: "destroyClipboard",
    value: function destroyClipboard() {
      if (this.clipboard) {
        this.clipboard.destroy();
      }
    }
  }, {
    key: "showMessage",
    value: function showMessage() {
      var _this3 = this;

      var isError = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
      clearTimeout(this.messageDelay);
      this.setState({
        message: isError ? ERROR_MESSAGE : SUCCESS_MESSAGE,
        isError: isError
      });
      this.messageDelay = setTimeout(function () {
        _this3.setState({
          message: '',
          isError: false
        });
      }, MESSAGE_DELAY);
    }
  }, {
    key: "render",
    value: function render() {
      var _this4 = this;

      var _this$props = this.props,
          CTA = _this$props.CTA,
          primary = _this$props.primary;
      var _this$state = this.state,
          message = _this$state.message,
          isError = _this$state.isError;
      return React.createElement(Fragment, null, showClipboard && React.createElement(Button$3, {
        error: message && isError,
        onClick: function onClick(e) {
          return e.preventDefault();
        },
        onMouseOut: function onMouseOut() {
          return _this4.destroyClipboard();
        },
        onMouseOver: function onMouseOver() {
          return _this4.createClipboard();
        },
        primary: primary,
        ref: function ref(c) {
          return _this4.copyButton = c;
        },
        success: message && !isError
      }, message || CTA));
    }
  }]);

  return CopyButton;
}(PureComponent);

defineProperty(CopyButton, "defaultProps", {
  text: ''
});

function _templateObject4() {
  var data = taggedTemplateLiteral(["\n    width: ", ";\n"]);

  _templateObject4 = function _templateObject4() {
    return data;
  };

  return data;
}

function _templateObject3$3() {
  var data = taggedTemplateLiteral(["\n    background: ", ";\n    border: 0;\n    border-radius: 0;\n    box-sizing: border-box;\n    font-family: inherit;\n    font-size: 14px;\n    height: 36px;\n    outline: none;\n    padding: 6px 12px;\n    width: 100%;\n    -webkit-appearance: none;\n"]);

  _templateObject3$3 = function _templateObject3() {
    return data;
  };

  return data;
}

function _templateObject2$9() {
  var data = taggedTemplateLiteral(["\n    display: flex;\n    height: 100%;\n    width: 100%;\n"]);

  _templateObject2$9 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject$h() {
  var data = taggedTemplateLiteral(["\n    height: 36px;\n    margin-bottom: 20px;\n    width: 100%;\n"]);

  _templateObject$h = function _templateObject() {
    return data;
  };

  return data;
}
var Container$c = styled.div(_templateObject$h());
var Wrapper = styled.div(_templateObject2$9());
var TextInput = styled.input(_templateObject3$3(), giphyWhite);
var CopyWrapper = styled.div(_templateObject4(), function (props) {
  return props.isFullWidth ? '100%' : '220px';
});

var ShareLink = function ShareLink(_ref) {
  var url = _ref.videoData.url,
      isSmall = _ref.isSmall;
  return React.createElement(Container$c, null, !isSmall && React.createElement(SectionLabel, null, "Copy Link to Video"), React.createElement(Wrapper, null, !isSmall && React.createElement(TextInput, {
    onFocus: function onFocus(e) {
      return e.target.select();
    },
    readOnly: true,
    type: "text",
    value: url
  }), React.createElement(CopyWrapper, {
    isFullWidth: isSmall
  }, React.createElement(CopyButton, {
    CTA: "Copy Video Link",
    primary: true,
    url: url
  }))));
};

var CopyLink = withVideoContext(['videoData', 'isSmall'])(ShareLink);

function _templateObject2$a() {
  var data = taggedTemplateLiteral(["\n    box-sizing: border-box;\n    height: 100%;\n    display: flex;\n    flex-direction: column;\n    justify-content: center;\n    margin: 0 auto;\n    max-height: ", ";\n    max-width: 800px;\n    padding: 0 ", "px;\n    width: 100%;\n"]);

  _templateObject2$a = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject$i() {
  var data = taggedTemplateLiteral(["\n    animation: ", " 0.2s ease-out;\n    background: ", ";\n    display: flex;\n    flex-direction: column;\n    height: 100%;\n    left: 0;\n    position: absolute;\n    top: 0;\n    width: 100%;\n"]);

  _templateObject$i = function _templateObject() {
    return data;
  };

  return data;
}
var fadeIn = keyframes(["0%{opacity:0;}100%{opacity:1;}"]);
var Container$d = styled.div(_templateObject$i(), fadeIn, dimColor);
var Content = styled.div(_templateObject2$a(), function (props) {
  return props.isFullscreen ? 'auto' : '300px';
}, function (props) {
  return props.isSmall ? 10 : 30;
});

var ShareMenu = function ShareMenu(_ref) {
  var isSmall = _ref.isSmall,
      isFullscreen = _ref.isFullscreen;
  return React.createElement(Container$d, null, React.createElement(Header$1, null), React.createElement(Content, {
    isFullscreen: isFullscreen,
    isSmall: isSmall
  }, React.createElement(Social, null), React.createElement(CopyLink, null)));
};

var Share$1 = withVideoContext(['isSmall', 'isFullscreen'])(ShareMenu);

var getPosterUrl = function getPosterUrl(previews, width, height) {
  var _bestfit = bestfit(previews, width, height),
      url = _bestfit.url; // perhaps webp?


  return url;
};

var IS_MOBILE$3 = mobileCheck();
var Container$e = styled.div(templateObject_1$3 || (templateObject_1$3 = __makeTemplateObject(["\n    box-sizing: border-box;\n    position: absolute;\n    cursor: pointer;\n    padding: 12px;\n    top: 0;\n    left: 0;\n    width: 100%;\n    height: 100%;\n    display: flex;\n    justify-content: ", ";\n    align-items: ", ";\n    transition: transform 0.2s ease-out;\n\n    img {\n        object-fit: cover;\n        width: 100%;\n        height: 100%;\n        left: 0;\n        top: 0;\n        position: absolute;\n    }\n"], ["\n    box-sizing: border-box;\n    position: absolute;\n    cursor: pointer;\n    padding: 12px;\n    top: 0;\n    left: 0;\n    width: 100%;\n    height: 100%;\n    display: flex;\n    justify-content: ", ";\n    align-items: ", ";\n    transition: transform 0.2s ease-out;\n\n    img {\n        object-fit: cover;\n        width: 100%;\n        height: 100%;\n        left: 0;\n        top: 0;\n        position: absolute;\n    }\n"])), function (props) { return (props.isMobile ? 'center' : 'flex-start'); }, function (props) { return (props.isMobile ? 'center' : 'flex-end'); });
var Poster = function () {
    var _a = useContext(VideoContext), setPoster = _a.setPoster, videoData = _a.videoData, _b = _a.dimensions, width = _b.width, height = _b.height;
    var video = videoData.video;
    if (!video) {
        return null;
    }
    var play = function () {
        setPoster(false);
    };
    return (React.createElement(Container$e, { isMobile: IS_MOBILE$3, onClick: play },
        React.createElement("img", { src: getPosterUrl(Object.values(video.previews), width, height) }),
        React.createElement(PlayIcon, { size: 45 })));
};
var templateObject_1$3;

function _templateObject4$1() {
  var data = taggedTemplateLiteral(["\n    height: 100%;\n    left: -9999px;\n    position: absolute;\n    top: -9999px;\n    width: 100%;\n"]);

  _templateObject4$1 = function _templateObject4() {
    return data;
  };

  return data;
}

function _templateObject3$4() {
  var data = taggedTemplateLiteral(["\n    box-shadow: 16px 16px 0 ", ", 16px 32px 0 ", ", 32px 32px 0 ", ", 16px 48px 0 ", ",\n        32px 48px 0 ", ", 48px 48px 0 ", ";\n    height: 16px;\n    pointer-events: none;\n    position: absolute;\n    right: 0;\n    top: -64px;\n    width: 16px;\n    transform: ", ";\n    transition: transform 0.2s ease-out;\n"]);

  _templateObject3$4 = function _templateObject3() {
    return data;
  };

  return data;
}

function _templateObject2$b() {
  var data = taggedTemplateLiteral(["\n    clip-path: ", ";\n    height: 100%;\n    width: 100%;\n"]);

  _templateObject2$b = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject$j() {
  var data = taggedTemplateLiteral(["\n    height: 100%;\n    position: relative;\n    width: 100%;\n"]);

  _templateObject$j = function _templateObject() {
    return data;
  };

  return data;
}
var Container$f = styled.div(_templateObject$j());
var Wrapper$1 = styled.div(_templateObject2$b(), function (props) {
  return props.cutout ? "url('#giphycutout')" : 'none';
});
var Cutout = styled.div(_templateObject3$4(), giphyRed, giphyRed, giphyRed, giphyRed, giphyRed, giphyRed, function (props) {
  return props.cutout ? 'translate3d(-48px, 48px, 0)' : 'translate3d(0, 0, 0)';
});
var CutoutSVG = styled.svg(_templateObject4$1());

var CornerCutout = function CornerCutout(_ref) {
  var children = _ref.children,
      className = _ref.className,
      _ref$isVisible = _ref.isVisible,
      isVisible = _ref$isVisible === void 0 ? false : _ref$isVisible;
  return React.createElement(Container$f, {
    className: className
  }, React.createElement(Wrapper$1, {
    cutout: isVisible
  }, children), React.createElement(Cutout, {
    cutout: isVisible
  }), React.createElement(CutoutSVG, null, React.createElement("defs", null, React.createElement("clipPath", {
    id: "giphycutout"
  }, React.createElement("rect", {
    height: "100%",
    width: "100%",
    x: "-32",
    y: "0"
  }), React.createElement("rect", {
    height: "100%",
    width: "100%",
    x: "0",
    y: "32"
  })))));
};

var _dec$7, _class$8, _temp$8;
var ShareManager = (_dec$7 = withVideoContext(), _dec$7(_class$8 = (_temp$8 =
/*#__PURE__*/
function (_PureComponent) {
  inherits(ShareManager, _PureComponent);

  function ShareManager() {
    var _getPrototypeOf2;

    var _this;

    classCallCheck(this, ShareManager);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = possibleConstructorReturn(this, (_getPrototypeOf2 = getPrototypeOf(ShareManager)).call.apply(_getPrototypeOf2, [this].concat(args)));

    defineProperty(assertThisInitialized(_this), "savedPlayerState", {});

    return _this;
  }

  createClass(ShareManager, [{
    key: "setIsShare",
    value: function setIsShare(isShare) {
      var _this$props = this.props,
          setLoop = _this$props.setLoop,
          setMuted = _this$props.setMuted,
          scrub = _this$props.scrub,
          isMuted = _this$props.isMuted,
          isLoop = _this$props.isLoop,
          mediaState = _this$props.mediaState; // when the overlay is opened, we want to loop the video
      // dimmed in the background with no sound, so it doesn't
      // get annoying. we also want to store the isLoop and isMuted
      // state and replace them back to what they were when the
      // overlay is exited.

      if (isShare) {
        this.savedPlayerState = {
          isMuted: isMuted,
          isLoop: isLoop
        };
        setLoop(true);
        setMuted(true);
      } else {
        var _this$savedPlayerStat = this.savedPlayerState,
            _isMuted = _this$savedPlayerStat.isMuted,
            _isLoop = _this$savedPlayerStat.isLoop;
        setLoop(_isLoop);
        setMuted(_isMuted);
        mediaState === MEDIA_STATE.PLAYING && scrub(0);
      }
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps) {
      var isShare = this.props.isShare;

      if (isShare !== prevProps.isShare) {
        this.setIsShare(isShare);
      }
    }
  }, {
    key: "render",
    value: function render() {
      return null;
    }
  }]);

  return ShareManager;
}(PureComponent), _temp$8)) || _class$8);

var _dec$8, _class$9, _temp$9;
var DocumentVisibilityManager = (_dec$8 = withVideoContext(['pause']), _dec$8(_class$9 = (_temp$9 =
/*#__PURE__*/
function (_PureComponent) {
  inherits(DocumentVisibilityManager, _PureComponent);

  function DocumentVisibilityManager() {
    var _getPrototypeOf2;

    var _this;

    classCallCheck(this, DocumentVisibilityManager);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = possibleConstructorReturn(this, (_getPrototypeOf2 = getPrototypeOf(DocumentVisibilityManager)).call.apply(_getPrototypeOf2, [this].concat(args)));

    defineProperty(assertThisInitialized(_this), "onVisibilityChange", function () {
      if (document.hidden) {
        var pause = _this.props.pause;
        pause();
      }
    });

    return _this;
  }

  createClass(DocumentVisibilityManager, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      if (mobileCheck()) {
        document.addEventListener('visibilitychange', this.onVisibilityChange);
      }
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      window.removeEventListener('visibilitychange', this.onVisibilityChange);
    }
  }, {
    key: "render",
    value: function render() {
      return null;
    }
  }]);

  return DocumentVisibilityManager;
}(PureComponent), _temp$9)) || _class$9);

function _templateObject$k() {
  var data = taggedTemplateLiteral(["\n    background: #000;\n    height: 100%;\n"]);

  _templateObject$k = function _templateObject() {
    return data;
  };

  return data;
}
var Wrapper$2 = styled.div(_templateObject$k());
var Components = withVideoContext(['showPoster', 'isShare', 'isOverlayVisible', 'isFullscreen', 'noCutout'])(function (_ref) {
  var showPoster = _ref.showPoster,
      isFullscreen = _ref.isFullscreen,
      isShare = _ref.isShare,
      isOverlayVisible = _ref.isOverlayVisible,
      noCutout = _ref.noCutout;
  return showPoster ? React.createElement(React.Fragment, null, React.createElement(Poster, null), isShare && React.createElement(Share$1, null)) : React.createElement(CornerCutout, {
    isVisible: (isShare || isOverlayVisible) && !isFullscreen && !noCutout
  }, React.createElement(Wrapper$2, null, React.createElement(Video, null), React.createElement(ShareManager, null), React.createElement(DocumentVisibilityManager, null), isShare ? React.createElement(Share$1, null) : React.createElement(Controls, null)));
});

var noop = function () { };
var EventManager = /** @class */ (function (_super) {
    __extends(EventManager, _super);
    function EventManager() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.quartilesFired = new Set();
        _this.loopNumber = 0;
        _this.shouldFireQuartile = function (quartile, playhead, duration) {
            var _a = _this, quartilesFired = _a.quartilesFired, loopNumber = _a.loopNumber;
            var currentQuartile = loopNumber + quartile;
            if (!quartilesFired.has(currentQuartile) && duration > 0 && playhead > duration * quartile) {
                quartilesFired.add(currentQuartile);
                return true;
            }
            return false;
        };
        return _this;
    }
    EventManager.prototype.componentDidUpdate = function (prevProps) {
        var _this = this;
        // these are props
        var _a = this.props, _b = _a.onEnded, onEnded = _b === void 0 ? noop : _b, _c = _a.onLoop, onLoop = _c === void 0 ? noop : _c, _d = _a.onVolume, onVolume = _d === void 0 ? noop : _d, _e = _a.onMute, onMute = _e === void 0 ? noop : _e, _f = _a.onHDSD, onHDSD = _f === void 0 ? noop : _f, _g = _a.onFullscreen, onFullscreen = _g === void 0 ? noop : _g, _h = _a.onShareAction, onShareAction = _h === void 0 ? noop : _h, _j = _a.onPlay, onPlay = _j === void 0 ? noop : _j, _k = _a.onPause, onPause = _k === void 0 ? noop : _k, _l = _a.onScrub, onScrub = _l === void 0 ? noop : _l, _m = _a.onShare, onShare = _m === void 0 ? noop : _m, _o = _a.onQuartile, onQuartile = _o === void 0 ? noop : _o;
        // these are from context
        var _p = this.props, ended = _p.ended, playhead = _p.playhead, volume = _p.volume, isMuted = _p.isMuted, isHD = _p.isHD, isFullscreen = _p.isFullscreen, shareAction = _p.shareAction, mediaState = _p.mediaState, scrubProgress = _p.scrubProgress, isShare = _p.isShare, getDuration = _p.getDuration, isLoop = _p.isLoop;
        var duration = getDuration();
        if (mediaState !== prevProps.mediaState) {
            if (mediaState === MEDIA_STATE.PLAYING) {
                onPlay();
            }
            else if (mediaState === MEDIA_STATE.PAUSED) {
                onPause();
            }
        }
        if (!isLoop && ended !== prevProps.ended && ended) {
            // this doesn't fire if looping
            onEnded();
        }
        if (Math.floor(playhead) === 0 && Math.floor(prevProps.playhead) > 0) {
            if (isLoop) {
                // we're looping so we need to fire our ended event here
                onEnded();
            }
            onLoop();
            this.loopNumber++;
        }
        [0.25, 0.5, 0.75].some(function (q) {
            if (_this.shouldFireQuartile(q, playhead, duration)) {
                onQuartile(q);
                return true;
            }
        });
        if (volume !== prevProps.volume) {
            onVolume(volume);
        }
        if (isMuted !== prevProps.isMuted) {
            onMute(isMuted, isShare);
        }
        if (isHD !== prevProps.isHD) {
            onHDSD(isHD);
        }
        if (isFullscreen !== prevProps.isFullscreen) {
            onFullscreen(isFullscreen);
        }
        if (shareAction !== prevProps.shareAction) {
            onShareAction(shareAction);
        }
        if (scrubProgress !== prevProps.scrubProgress) {
            onScrub(scrubProgress);
        }
        if (isShare !== prevProps.isShare) {
            onShare(isShare);
        }
    };
    EventManager.prototype.render = function () {
        return null;
    };
    return EventManager;
}(PureComponent));
var EventManager$1 = withVideoContext()(EventManager);

var getAspectRatio = function (_a) {
    var video = _a.video;
    if (!video) {
        return 1;
    }
    var source = video.assets.source;
    return source.width / source.height;
};

var filmfestToGif = function (videoData) {
    videoData.video = __assign({}, videoData.media); // get all the media props (not sure if we'll use any)
    // gif.video props
    videoData.video.assets = {};
    videoData.video.previews = {};
    // add assets
    videoData.media.assets.forEach(function (a) {
        // @ts-ignore
        if (!a.is_source) {
            videoData.video.assets[a.width] = a;
        }
        else {
            videoData.video.assets.source = a;
        }
    });
    // add assets
    videoData.media.previews.forEach(function (a) {
        videoData.video.previews[a.width] = a;
    });
    // result is an IGif (I hope)
    return videoData;
};

var Video$1 = /** @class */ (function (_super) {
    __extends(Video, _super);
    function Video() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    Video.prototype.componentDidMount = function () {
        // force update after mount to pass in the ref playerElement
        this.forceUpdate();
    };
    Video.prototype.render = function () {
        var _this = this;
        var gif = this.props.gif;
        if (!gif) {
            var videoData = this.props.videoData;
            gif = filmfestToGif(videoData);
        }
        if (!gif.video) {
            throw new Error("@giphy/react-giphy-brand Video configration error");
        }
        var _a = this.props, width = _a.width, height = _a.height, _b = _a.className, className = _b === void 0 ? '' : _b, autoPlay = _a.autoPlay, events = _a.events, forceMute = _a.forceMute, toggleShare = _a.toggleShare, noShare = _a.noShare, noCutout = _a.noCutout;
        var dimensions = { width: width, height: height };
        if (!width && height) {
            // set width based on height
            dimensions.width = height * getAspectRatio(gif);
        }
        if (!height && width) {
            // set height based on width
            dimensions.height = width / getAspectRatio(gif);
        }
        return (React.createElement(Container, { className: className, height: dimensions.height, ref: function (c) { return (_this.playerElement = c); }, width: dimensions.width },
            React.createElement(VideoContextManager, { autoPlay: autoPlay, dimensions: dimensions, forceMute: forceMute, noCutout: noCutout, noShare: noShare, playerElement: this.playerElement, toggleShare: toggleShare, videoData: gif },
                React.createElement(EventManager$1, __assign({}, events)),
                React.createElement(Components, null))));
    };
    Video.defaultProps = {
        autoPlay: false,
        events: {},
        toggleShare: false,
    };
    return Video;
}(PureComponent));
var index = withStorageContextManager('react-giphy-brand-video')(Video$1);

function _templateObject2$c() {
  var data = taggedTemplateLiteral(["\n    margin-left: 6px;\n    margin-bottom: 4px;\n    font-size: 15px;\n    line-height: 15px;\n    color: ", ";\n"]);

  _templateObject2$c = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject$l() {
  var data = taggedTemplateLiteral(["\n    align-items: flex-end;\n    justify-content: flex-start;\n    display: flex;\n    height: 100%;\n    left: 0;\n    pointer-events: none;\n    position: absolute;\n    top: 0;\n"]);

  _templateObject$l = function _templateObject() {
    return data;
  };

  return data;
}
var ClockContainer = styled.div(_templateObject$l());
var Icon = styled.div(_templateObject2$c(), giphyYellow);

var Clock = function Clock() {
  return React.createElement(ClockContainer, null, React.createElement(Icon, {
    className: "ss-clock"
  }));
};

function constructMoatData(_a) {
    var tdata = _a.tdata;
    var moatTrackerData = (tdata.web && tdata.web.filter(function (tracker) { return tracker.vendor === 'Moat'; })[0]) || {};
    if (moatTrackerData.verificationParameters) {
        var _b = moatTrackerData.verificationParameters, _c = _b.moatClientLevel1, moatClientLevel1 = _c === void 0 ? '_ADVERTISER_' : _c, _d = _b.moatClientLevel2, moatClientLevel2 = _d === void 0 ? '_CAMPAIGN_' : _d, _e = _b.moatClientLevel3, moatClientLevel3 = _e === void 0 ? '_LINE_ITEM_' : _e, _f = _b.moatClientLevel4, moatClientLevel4 = _f === void 0 ? '_CREATIVE_' : _f, _g = _b.moatClientSlicer1, moatClientSlicer1 = _g === void 0 ? '_SITE_' : _g, _h = _b.moatClientSlicer2, moatClientSlicer2 = _h === void 0 ? '_PLACEMENT_' : _h;
        return {
            moatClientLevel1: moatClientLevel1,
            moatClientLevel2: moatClientLevel2,
            moatClientLevel3: moatClientLevel3,
            moatClientLevel4: moatClientLevel4,
            moatClientSlicer1: moatClientSlicer1,
            moatClientSlicer2: moatClientSlicer2,
        };
    }
}

var documentVisibleCallbacks = [];
var lastVisibilityState = document.visibilityState;
document.addEventListener('visibilitychange', function () {
    var currentState = document.visibilityState;
    if (lastVisibilityState !== currentState) {
        lastVisibilityState = currentState;
        if (currentState === 'visible') {
            documentVisibleCallbacks.forEach(function (cb) { return cb(); });
        }
    }
});
var mediaCss = css$6(templateObject_1$4 || (templateObject_1$4 = __makeTemplateObject(["\n    display: block;\n    left: 0;\n    position: absolute;\n    top: 0;\n"], ["\n    display: block;\n    left: 0;\n    position: absolute;\n    top: 0;\n"])));
var ImageSC = styled.img(templateObject_2$2 || (templateObject_2$2 = __makeTemplateObject(["\n    ", ";\n    object-fit: ", ";\n"], ["\n    ", ";\n    object-fit: ", ";\n"
    // if we want to letter box, background: black and object-fit: contain
])), mediaCss, function (props) { return (props.isSticker ? 'contain' : 'cover'); });
// if we want to letter box, background: black and object-fit: contain
var VideoSC = styled.video(templateObject_3$1 || (templateObject_3$1 = __makeTemplateObject(["\n    ", ";\n    object-fit: cover;\n"], ["\n    ", ";\n    object-fit: cover;\n"])), mediaCss);
var getRendition = function (gif, isAnimating, width, height, rendition, useVideo) {
    return rendition
        ? getSpecificRendition(gif, rendition, !isAnimating, useVideo)
        : getBestRenditionUrl(gif, width, height, { isStill: !isAnimating, useVideo: useVideo });
};
var Media = /** @class */ (function (_super) {
    __extends(Media, _super);
    function Media() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.state = {};
        _this.videoEl = createRef();
        _this.unmounted = false;
        _this.loopCount = 0;
        _this.currentMoatAdNumber = null;
        _this.isAd = _this.props.gif.bottle_data && Object.keys(_this.props.gif.bottle_data).length > 0;
        _this.onDocumentVisible = function () { return _this.playVideo(); };
        _this.onEnded = function () {
            var _a = _this.props, loop = _a.loop, onLoop = _a.onLoop, onEnded = _a.onEnded, isAnimating = _a.isAnimating;
            // instead of the loop property, manual loop so we can fire onEnded
            if (loop && isAnimating)
                _this.playVideo();
            // callback for ended
            if (onEnded)
                onEnded();
            _this.loopCount++;
            // maybe this should be called view count?
            if (onLoop)
                onLoop(_this.loopCount);
        };
        return _this;
    }
    Media.getDerivedStateFromProps = function (_a, prevState) {
        var gif = _a.gif, height = _a.height, width = _a.width, rendition = _a.rendition, _b = _a.isAnimating, isAnimating = _b === void 0 ? true : _b, type = _a.type;
        var src = getRendition(gif, isAnimating || type === 'video', width, height, rendition, type === 'video');
        var alt = getAltText(gif);
        if (src !== prevState.src || alt !== prevState.alt) {
            return { src: src, alt: alt };
        }
        return null;
    };
    Media.prototype.componentDidMount = function () {
        var type = this.props.type;
        if (type === 'video') {
            documentVisibleCallbacks.push(this.onDocumentVisible);
        }
    };
    Media.prototype.componentDidUpdate = function (lastProps) {
        var _a = this.props, type = _a.type, isAnimating = _a.isAnimating, loop = _a.loop;
        if (lastProps.type !== type) {
            pull$1(documentVisibleCallbacks, this.onDocumentVisible);
            if (type === 'video') {
                documentVisibleCallbacks.push(this.onDocumentVisible);
            }
        }
        if (type === 'video') {
            if (lastProps.isAnimating !== isAnimating) {
                if (isAnimating) {
                    this.playVideo();
                }
                else {
                    this.pauseVideo();
                }
            }
            if (lastProps.loop !== loop && loop && isAnimating) {
                this.playVideo();
            }
        }
    };
    Media.prototype.componentWillUnmount = function () {
        pull$1(documentVisibleCallbacks, this.onDocumentVisible);
        this.handleAdVisibility(false, false);
    };
    Media.prototype.playVideo = function () {
        var video = this.videoEl.current;
        if (video) {
            video.play();
        }
    };
    Media.prototype.pauseVideo = function () {
        var video = this.videoEl.current;
        if (video) {
            video.pause();
        }
    };
    Media.prototype.handleAdVisibility = function (isInView, el) {
        if (!this.isAd)
            return;
        var bottleData = this.props.gif.bottle_data;
        if (this.currentMoatAdNumber === null) {
            if (isInView && bottleData) {
                var moatCompatibleData = constructMoatData(bottleData);
                if (moatCompatibleData)
                    this.currentMoatAdNumber = moat.startTracking(el.target, moatCompatibleData);
            }
        }
        else if (!isInView && this.currentMoatAdNumber !== null) {
            moat.stopTracking(this.currentMoatAdNumber);
            // need to set this to null incase we call stoptracking in 'unmount'
            this.currentMoatAdNumber = null;
        }
    };
    Media.prototype.render = function () {
        var _this = this;
        var _a = this.props, height = _a.height, width = _a.width, onLoad = _a.onLoad, type = _a.type, isAnimating = _a.isAnimating;
        var _b = this.state, src = _b.src, alt = _b.alt;
        return (React.createElement(InView, null, function (_a) {
            var inView = _a.inView, ref = _a.ref, entry = _a.entry;
            var PlaceHolder = function () { return (React.createElement("img", { ref: ref, src: "data:image/gif;base64,R0lGODlhAQABAIAAAAAAAP///yH5BAEAAAAALAAAAAABAAEAAAIBRAA7", style: { height: height, width: width } })); };
            return inView || _this.currentMoatAdNumber !== null ? (type === 'video' ? (React.createElement(Fragment, null,
                React.createElement(PlaceHolder, null),
                React.createElement(VideoSC, { autoPlay: isAnimating, height: height, muted: true, onCanPlay: onLoad, onEnded: _this.onEnded, onLoadedData: function (e) {
                        _this.handleAdVisibility(inView, entry);
                        onLoad && onLoad(e);
                    }, playsInline: true, preload: "metadata", ref: _this.videoEl, src: src, width: width }))) : (React.createElement(ImageSC, { alt: alt, height: height, isSticker: type === 'sticker', onLoad: function (e) {
                    _this.handleAdVisibility(inView, entry);
                    onLoad && onLoad(e);
                }, ref: ref, src: src, width: width }))) : (React.createElement(PlaceHolder, null));
        }));
    };
    return Media;
}(React.PureComponent));
var templateObject_1$4, templateObject_2$2, templateObject_3$1;

var AdPill = function (_a) {
    var className = _a.className;
    return (React.createElement("svg", { className: className, height: "20px", version: "1.1", viewBox: "0 0 36 20", width: "36px" },
        React.createElement("g", { fill: "none", fillRule: "evenodd", stroke: "none", strokeWidth: "1" },
            React.createElement("g", { id: "Ad-Pill-(Large)" },
                React.createElement("g", { id: "ad-pill" },
                    React.createElement("path", { d: "M6.409713,-5.17920154e-16 L29.590287,-1.97215226e-31 C31.8190838,-4.09423339e-16 32.6272994,0.232064028 33.4421143,0.667831759 C34.2569291,1.10359949 34.8964005,1.74307093 35.3321682,2.55788574 C35.767936,3.37270056 36,4.18091615 36,6.409713 L36,13.590287 C36,15.8190838 35.767936,16.6272994 35.3321682,17.4421143 C34.8964005,18.2569291 34.2569291,18.8964005 33.4421143,19.3321682 C32.6272994,19.767936 31.8190838,20 29.590287,20 L6.409713,20 C4.18091615,20 3.37270056,19.767936 2.55788574,19.3321682 C1.74307093,18.8964005 1.10359949,18.2569291 0.667831759,17.4421143 C0.232064028,16.6272994 -7.23312098e-17,15.8190838 -3.45280103e-16,13.590287 L-2.46519033e-32,6.409713 C-2.72948893e-16,4.18091615 0.232064028,3.37270056 0.667831759,2.55788574 C1.10359949,1.74307093 1.74307093,1.10359949 2.55788574,0.667831759 C3.37270056,0.232064028 4.18091615,-1.08496815e-16 6.409713,-5.17920154e-16 Z M11.3684211,13.3333333 L12.9145263,13.3333333 L13.5397895,11.8019048 L16.4614737,11.8019048 L17.0753684,13.3333333 L18.7237895,13.3333333 L15.5633684,5.71047619 L14.4833684,5.71047619 L11.3684211,13.3333333 Z M22.9755789,13.3333333 L24.3284211,13.3333333 L24.3284211,5.71047619 L22.8505263,5.71047619 L22.8505263,7.84761905 C22.509472,7.74095185 22.1835805,7.68761905 21.8728421,7.68761905 C21.410524,7.68761905 21.0088438,7.76952299 20.6677895,7.93333333 C20.3267351,8.09714368 20.0425275,8.31428436 19.8151579,8.5847619 C19.5877883,8.85523945 19.4172637,9.16190305 19.3035789,9.5047619 C19.1898942,9.84762076 19.1330526,10.1980934 19.1330526,10.5561905 C19.1330526,10.9371448 19.1861047,11.3028554 19.2922105,11.6533333 C19.3983163,12.0038113 19.5555779,12.3123796 19.764,12.5790476 C19.9724221,12.8457156 20.2301037,13.0590468 20.5370526,13.2190476 C20.8440015,13.3790484 21.1945243,13.4590476 21.5886316,13.4590476 C21.891791,13.4590476 22.1532621,13.4038101 22.3730526,13.2933333 C22.5928432,13.1828566 22.7709467,13.0552388 22.9073684,12.9104762 L22.9755789,13.3333333 Z M14.0058947,10.5104762 L14.9835789,8.00761905 L15.9612632,10.5104762 L14.0058947,10.5104762 Z M22.8505263,9.04761905 L22.8505263,11.767619 C22.7671575,11.8971435 22.6307378,12.0095233 22.4412632,12.1047619 C22.2517885,12.2000005 22.0661062,12.247619 21.8842105,12.247619 C21.656841,12.247619 21.461685,12.2000005 21.2987368,12.1047619 C21.1357887,12.0095233 21.0012637,11.8838103 20.8951579,11.727619 C20.7890521,11.5714278 20.7094739,11.3885725 20.6564211,11.1790476 C20.6033682,10.9695228 20.5768421,10.7504773 20.5768421,10.5219048 C20.5768421,10.3161894 20.6071576,10.1161914 20.6677895,9.92190476 C20.7284214,9.72761808 20.8193678,9.55238173 20.9406316,9.39619048 C21.0618953,9.23999922 21.2153675,9.11619093 21.4010526,9.0247619 C21.5867378,8.93333288 21.8046303,8.88761905 22.0547368,8.88761905 C22.3048434,8.88761905 22.5701039,8.94095185 22.8505263,9.04761905 Z", fill: "#212121", fillRule: "nonzero", opacity: "0.55" }),
                    React.createElement("path", { d: "M11.3684211,13.3333333 L14.4833684,5.71047619 L15.5633684,5.71047619 L18.7237895,13.3333333 L17.0753684,13.3333333 L16.4614737,11.8019048 L13.5397895,11.8019048 L12.9145263,13.3333333 L11.3684211,13.3333333 Z M14.0058947,10.5104762 L15.9612632,10.5104762 L14.9835789,8.00761905 L14.0058947,10.5104762 Z M22.9755789,13.3333333 L22.9073684,12.9104762 C22.7709467,13.0552388 22.5928432,13.1828566 22.3730526,13.2933333 C22.1532621,13.4038101 21.891791,13.4590476 21.5886316,13.4590476 C21.1945243,13.4590476 20.8440015,13.3790484 20.5370526,13.2190476 C20.2301037,13.0590468 19.9724221,12.8457156 19.764,12.5790476 C19.5555779,12.3123796 19.3983163,12.0038113 19.2922105,11.6533333 C19.1861047,11.3028554 19.1330526,10.9371448 19.1330526,10.5561905 C19.1330526,10.1980934 19.1898942,9.84762076 19.3035789,9.5047619 C19.4172637,9.16190305 19.5877883,8.85523945 19.8151579,8.5847619 C20.0425275,8.31428436 20.3267351,8.09714368 20.6677895,7.93333333 C21.0088438,7.76952299 21.410524,7.68761905 21.8728421,7.68761905 C22.1835805,7.68761905 22.509472,7.74095185 22.8505263,7.84761905 L22.8505263,5.71047619 L24.3284211,5.71047619 L24.3284211,13.3333333 L22.9755789,13.3333333 Z M22.8505263,9.04761905 C22.5701039,8.94095185 22.3048434,8.88761905 22.0547368,8.88761905 C21.8046303,8.88761905 21.5867378,8.93333288 21.4010526,9.0247619 C21.2153675,9.11619093 21.0618953,9.23999922 20.9406316,9.39619048 C20.8193678,9.55238173 20.7284214,9.72761808 20.6677895,9.92190476 C20.6071576,10.1161914 20.5768421,10.3161894 20.5768421,10.5219048 C20.5768421,10.7504773 20.6033682,10.9695228 20.6564211,11.1790476 C20.7094739,11.3885725 20.7890521,11.5714278 20.8951579,11.727619 C21.0012637,11.8838103 21.1357887,12.0095233 21.2987368,12.1047619 C21.461685,12.2000005 21.656841,12.247619 21.8842105,12.247619 C22.0661062,12.247619 22.2517885,12.2000005 22.4412632,12.1047619 C22.6307378,12.0095233 22.7671575,11.8971435 22.8505263,11.767619 L22.8505263,9.04761905 Z", fill: "#D8D8D8", opacity: "0.5" }))))));
};

var GifWrapper = styled.div(function (_a) {
    var isSticker = _a.isSticker;
    return css$6(templateObject_2$3 || (templateObject_2$3 = __makeTemplateObject(["\n        display: block;\n        overflow: hidden;\n        position: relative;\n        text-align: left;\n\n        &:hover ", " {\n            opacity: 0;\n        }\n        ", "\n    "], ["\n        display: block;\n        overflow: hidden;\n        position: relative;\n        text-align: left;\n\n        &:hover ", " {\n            opacity: 0;\n        }\n        ",
        "\n    "])), LockContainer, isSticker && css$6(templateObject_1$5 || (templateObject_1$5 = __makeTemplateObject(["\n                background-image: linear-gradient(\n                        45deg,\n                        #222 25%,\n                        transparent 25%,\n                        transparent 75%,\n                        #222 75%,\n                        #222 100%\n                    ),\n                    linear-gradient(45deg, #222 25%, transparent 25%, transparent 75%, #222 75%, #222 100%);\n                background-position: 0 0, 19px 19px;\n                background-size: 38px 38px;\n            "], ["\n                background-image: linear-gradient(\n                        45deg,\n                        #222 25%,\n                        transparent 25%,\n                        transparent 75%,\n                        #222 75%,\n                        #222 100%\n                    ),\n                    linear-gradient(45deg, #222 25%, transparent 25%, transparent 75%, #222 75%, #222 100%);\n                background-position: 0 0, 19px 19px;\n                background-size: 38px 38px;\n            "]))));
});
var GifLink = styled.a(templateObject_3$2 || (templateObject_3$2 = __makeTemplateObject(["\n    display: block;\n    height: 100%;\n    width: 100%;\n"], ["\n    display: block;\n    height: 100%;\n    width: 100%;\n"])));
var AdPill$1 = styled(AdPill)(function (_a) {
    var isVisible = _a.isVisible;
    return css$6(templateObject_4$1 || (templateObject_4$1 = __makeTemplateObject(["\n        position: absolute;\n        bottom: 5px;\n        left: 5px;\n        opacity: ", ";\n        transition: opacity 0.33s ease-in-out;\n    "], ["\n        position: absolute;\n        bottom: 5px;\n        left: 5px;\n        opacity: ", ";\n        transition: opacity 0.33s ease-in-out;\n    "])), isVisible ? 1 : 0);
});
var Tags = styled.div(function (_a) {
    var isVisible = _a.isVisible;
    return css$6(templateObject_5$1 || (templateObject_5$1 = __makeTemplateObject(["\n        position: absolute;\n        bottom: 0;\n        left: 0;\n        box-sizing: border-box;\n        overflow: hidden;\n        transform: translateY(", ");\n        transition: transform 0.2s ease-out;\n        font-size: 12px;\n        height: 25px;\n        line-height: 25px;\n        padding: 0 5px;\n        width: 100%;\n        background: linear-gradient(transparent, rgba(0, 0, 0, 0.5));\n    "], ["\n        position: absolute;\n        bottom: 0;\n        left: 0;\n        box-sizing: border-box;\n        overflow: hidden;\n        transform: translateY(", ");\n        transition: transform 0.2s ease-out;\n        font-size: 12px;\n        height: 25px;\n        line-height: 25px;\n        padding: 0 5px;\n        width: 100%;\n        background: linear-gradient(transparent, rgba(0, 0, 0, 0.5));\n    "])), isVisible ? 0 : '100%');
});
var Tag = styled.a(templateObject_6$1 || (templateObject_6$1 = __makeTemplateObject(["\n    color: ", ";\n    display: inline-block;\n    font-size: inherit;\n    font-weight: bold;\n    margin-right: 5px;\n    text-decoration: none;\n    text-transform: lowercase;\n\n    &:hover {\n        color: ", ";\n    }\n\n    &:before {\n        content: '#';\n    }\n"], ["\n    color: ", ";\n    display: inline-block;\n    font-size: inherit;\n    font-weight: bold;\n    margin-right: 5px;\n    text-decoration: none;\n    text-transform: lowercase;\n\n    &:hover {\n        color: ", ";\n    }\n\n    &:before {\n        content: '#';\n    }\n"])), giphyWhite, giphyWhite);
var LockContainer = styled.div(templateObject_7 || (templateObject_7 = __makeTemplateObject(["\n    align-items: center;\n    background: ", ";\n    display: flex;\n    height: 100%;\n    justify-content: center;\n    left: 0;\n    pointer-events: none;\n    position: absolute;\n    top: 0;\n    transition: opacity 0.2s ease-out;\n    width: 100%;\n"], ["\n    align-items: center;\n    background: ", ";\n    display: flex;\n    height: 100%;\n    justify-content: center;\n    left: 0;\n    pointer-events: none;\n    position: absolute;\n    top: 0;\n    transition: opacity 0.2s ease-out;\n    width: 100%;\n"])), gifOverlayColor);
var templateObject_1$5, templateObject_2$3, templateObject_3$2, templateObject_4$1, templateObject_5$1, templateObject_6$1, templateObject_7;

var PrivateGif = function () { return (React.createElement(LockContainer, null,
    React.createElement("svg", { fill: giphyRed, height: "59", width: "40", xmlns: "http://www.w3.org/2000/svg" },
        React.createElement("g", { fillRule: "evenodd", stroke: "none", strokeWidth: "1" },
            React.createElement("path", { d: "M33.3239595,24.9750802 C33.3331841,20.449858 33.3424088,13.6756824 33.3424088,13.4662657 C33.3424088,6.07294497 27.2725923,0.081805787 19.7821805,0.081805787 C12.2917687,0.081805787 6.22195224,6.07294497 6.22195224,13.4662657 C6.22195224,13.6938925 6.23117689,20.4225428 6.24040153,24.9659751 C2.42139847,28.5169542 0.0414400414,33.5520606 0.0414400414,39.1425765 C0.0414400414,49.9047748 8.87865002,58.6274364 19.7821805,58.6274364 C30.685711,58.6274364 39.522921,49.9047748 39.522921,39.1425765 C39.5136963,33.5702707 37.1337379,28.5351644 33.3239595,24.9750802 L33.3239595,24.9750802 L33.3239595,24.9750802 Z M31.0639214,29.9282408 L26.6637657,34.2713615 C26.0826131,33.4245895 25.3446415,32.6870785 24.5051988,32.0952486 L28.8961298,27.761233 C29.6894493,28.4076933 30.4181963,29.1360993 31.0639214,29.9282408 L31.0639214,29.9282408 L31.0639214,29.9282408 Z M19.7729559,5.55395571 C24.2007855,5.55395571 27.7983971,9.10493487 27.7983971,13.4753707 C27.7983971,14.0672006 27.7983971,17.7365457 27.7891724,21.3421553 C25.3354168,20.2677565 22.6233712,19.6668216 19.7729559,19.6668216 C16.9225405,19.6668216 14.2104949,20.2677565 11.7567393,21.3421553 C11.7567393,17.7274407 11.7475146,14.0580955 11.7475146,13.4753707 C11.7475146,9.10493487 15.3451262,5.55395571 19.7729559,5.55395571 L19.7729559,5.55395571 L19.7729559,5.55395571 Z M10.2900207,27.761233 L14.6809518,32.0952486 C13.8322844,32.6870785 13.1035375,33.4245895 12.5223848,34.2713615 L8.12222913,29.9282408 C8.76795428,29.1360993 9.4874766,28.4076933 10.2900207,27.761233 L10.2900207,27.761233 L10.2900207,27.761233 Z M4.99507445,40.4992326 C4.93972658,39.9893484 4.91205264,39.4885693 4.91205264,38.9695801 C4.91205264,38.4505908 4.93972658,37.9407066 4.99507445,37.4399275 L11.2124852,37.4399275 C11.1202388,37.9407066 11.0741155,38.4505908 11.0741155,38.9695801 C11.0741155,39.4976744 11.1202388,40.0075586 11.2124852,40.4992326 L4.99507445,40.4992326 L4.99507445,40.4992326 L4.99507445,40.4992326 Z M10.4283904,50.287188 C9.62584627,49.6498327 8.88787467,48.9396369 8.23292487,48.1474954 L12.6238559,43.8134798 C13.2234579,44.6511467 13.9706541,45.3704476 14.8285461,45.9440673 L10.4283904,50.287188 L10.4283904,50.287188 L10.4283904,50.287188 Z M21.3134716,53.3647032 C20.7507682,53.4284388 20.1696156,53.4648591 19.588463,53.4648591 C19.1272307,53.4648591 18.6752231,53.4375438 18.2232155,53.4011235 L18.2232155,47.2734082 C18.6752231,47.3371438 19.1272307,47.373564 19.588463,47.3826691 C20.1788402,47.3826691 20.7599929,47.3189336 21.3134716,47.2096727 L21.3134716,53.3647032 L21.3134716,53.3647032 L21.3134716,53.3647032 Z M21.3134716,30.7385925 C20.7599929,30.6202265 20.1788402,30.556491 19.588463,30.5655961 C19.1180061,30.5655961 18.6659984,30.6020164 18.2232155,30.674857 L18.2232155,24.5471416 C18.6752231,24.5016163 19.1272307,24.4834061 19.588463,24.4834061 C20.1696156,24.4834061 20.7507682,24.5198264 21.3134716,24.5835619 L21.3134716,30.7385925 L21.3134716,30.7385925 L21.3134716,30.7385925 Z M28.7485355,50.287188 L24.3483798,45.9440673 C25.2062718,45.3704476 25.9534681,44.6511467 26.55307,43.8134798 L30.944001,48.1474954 C30.2890512,48.9305318 29.5510796,49.6498327 28.7485355,50.287188 L28.7485355,50.287188 L28.7485355,50.287188 Z M27.9644407,40.4901275 C28.0566871,39.9984535 28.112035,39.4885693 28.1028104,38.960475 C28.1028104,38.4323806 28.0566871,37.9224965 27.9644407,37.4308224 L34.1818515,37.4308224 C34.2371993,37.9407066 34.2648733,38.4414857 34.2648733,38.960475 C34.2648733,39.4794642 34.2371993,39.9893484 34.1818515,40.4901275 L27.9644407,40.4901275 L27.9644407,40.4901275 L27.9644407,40.4901275 Z" }))))); };

var RemovedGif = function () { return (React.createElement(LockContainer, null,
    React.createElement("svg", { height: "44", width: "40", xmlns: "http://www.w3.org/2000/svg" },
        React.createElement("path", { d: "M39.084 0a.88.88 0 0 1 .65.269.896.896 0 0 1 .266.655v3.652a.896.896 0 0 1-.266.655.88.88 0 0 1-.65.269H.916a.88.88 0 0 1-.65-.269A.896.896 0 0 1 0 4.576V.924C0 .666.089.448.266.269A.88.88 0 0 1 .916 0h38.168zM3.642 9.174h32.716l-2.726 34.01a.902.902 0 0 1-.31.58.889.889 0 0 1-.606.236H7.284a.889.889 0 0 1-.607-.236.902.902 0 0 1-.309-.58L3.642 9.174z", fill: giphyRed, fillRule: "evenodd" })))); };

var GRID_COLORS = [giphyBlue, giphyGreen, giphyPurple, giphyRed, giphyYellow];
var getColor = function () { return GRID_COLORS[Math.round(Math.random() * (GRID_COLORS.length - 1))]; };
var noop$1 = function () { };
var hasCheckedWebP = false;
var Gif = /** @class */ (function (_super) {
    __extends(Gif, _super);
    function Gif(props) {
        var _this = _super.call(this, props) || this;
        _this.state = {
            isHovered: false,
            isSeen: false,
            isAnimating: false,
            backgroundColor: '',
        };
        _this.unmounted = false;
        _this.onImageLoad = function (e) {
            var _a = _this.props, gif = _a.gif, onSeen = _a.onSeen, onVisible = _a.onVisible;
            var isSeen = _this.state.isSeen;
            // onSeen is called only once per GIF and indicates that
            // the image was loaded. onVisible will be called every time
            // the image loads regardless of if its been loaded before
            // or not.
            if (!isSeen) {
                onSeen(gif);
                _this.setState({ isSeen: true });
            }
            onVisible(gif, e.target);
        };
        _this.onClick = function (e) {
            var _a = _this.props, gif = _a.gif, onClick = _a.onClick;
            onClick(e, gif);
        };
        _this.onRightClick = function (e) {
            var _a = _this.props, gif = _a.gif, onRightClick = _a.onRightClick;
            onRightClick(e, gif);
        };
        _this.checkForWebP();
        return _this;
    }
    Gif.prototype.checkForWebP = function () {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (!!hasCheckedWebP) return [3 /*break*/, 2];
                        // this will never fire if we fetch gifs/stories
                        // does fire when in brand repo
                        return [4 /*yield*/, checkIfWebP];
                    case 1:
                        // this will never fire if we fetch gifs/stories
                        // does fire when in brand repo
                        _a.sent();
                        hasCheckedWebP = true;
                        if (!this.unmounted) {
                            // rerender, include the media component
                            this.forceUpdate();
                        }
                        _a.label = 2;
                    case 2: return [2 /*return*/];
                }
            });
        });
    };
    Gif.getDerivedStateFromProps = function (_a, prevState) {
        var autoPlay = _a.autoPlay, gif = _a.gif, backgroundColor = _a.backgroundColor;
        var res = {};
        if (autoPlay !== prevState.isAnimating) {
            res.isAnimating = autoPlay;
        }
        var newBackgroundColor = backgroundColor || (gif.is_sticker ? giphyBlack : prevState.backgroundColor || getColor());
        if (newBackgroundColor !== prevState.backgroundColor) {
            res.backgroundColor = newBackgroundColor;
        }
        return isEmpty$1(res) ? null : res;
    };
    Gif.prototype.componentWillUnmount = function () {
        this.unmounted = true;
        clearTimeout(this.hoverDelay);
    };
    Gif.prototype.onMouseOver = function () {
        var _this = this;
        var _a = this.props, gif = _a.gif, onHover = _a.onHover;
        clearTimeout(this.hoverDelay);
        this.setState({ isHovered: true });
        this.hoverDelay = setTimeout(function () {
            onHover && onHover(gif);
            _this.setState({ isAnimating: true });
        }, 200);
    };
    Gif.prototype.onMouseOut = function () {
        clearTimeout(this.hoverDelay);
        this.setState({ isHovered: false, isAnimating: this.props.autoPlay });
    };
    Gif.prototype.render = function () {
        var _this = this;
        var _a = this.props, gif = _a.gif, bottle_data = _a.gif.bottle_data, rendition = _a.rendition, width = _a.width, height = _a.height, url = _a.url, showTags = _a.showTags, children = _a.children, onTagClick = _a.onTagClick, hideLock = _a.hideLock, useVideo = _a.useVideo, onLoop = _a.onLoop, loop = _a.loop, onEnded = _a.onEnded, hideAdIndicator = _a.hideAdIndicator;
        var _b = this.state, backgroundColor = _b.backgroundColor, isHovered = _b.isHovered, isAnimating = _b.isAnimating, isSeen = _b.isSeen;
        var tags = gif.tags, isSticker = gif.is_sticker, isPrivate = gif.is_hidden, isRemoved = gif.is_removed, isScheduled = gif.is_scheduled;
        var gifHeight = height || getGifHeight(gif, width);
        var renderAdPill = !isEmpty$1(bottle_data) && !hideAdIndicator;
        // we should use context here,
        // but that would require updating each child component that has depended
        // on these props
        // however, if the child is a div, these props below will throw a warning,
        // so we should switch
        var childProps = {
            gif: gif,
            backgroundColor: backgroundColor,
            width: width,
            height: gifHeight,
            isAnimating: isAnimating,
        };
        return (React.createElement(GifWrapper, { isSticker: isSticker, onMouseOut: function () { return _this.onMouseOut(); }, onMouseOver: function () { return _this.onMouseOver(); }, style: {
                width: width,
                height: gifHeight,
                backgroundColor: backgroundColor,
            } },
            React.createElement(GifLink, { href: url || gif.url, onClick: this.onClick, onContextMenu: this.onRightClick },
                hasCheckedWebP && (React.createElement(Media, { gif: gif, height: gifHeight, isAnimating: isAnimating, loop: loop, onEnded: onEnded, onLoad: this.onImageLoad, onLoop: onLoop, rendition: rendition, type: isSticker ? 'sticker' : useVideo ? 'video' : 'gif', width: width })),
                !hideLock && isPrivate ? React.createElement(PrivateGif, null) : null,
                isScheduled && React.createElement(Clock, null),
                isRemoved ? React.createElement(RemovedGif, null) : null),
            Children.map(children, function (child) { return (child ? cloneElement(child, childProps) : null); }),
            renderAdPill && React.createElement(AdPill$1, { isVisible: !isHovered && isSeen }),
            showTags && tags && (React.createElement(Tags, { isVisible: isHovered }, tags.map(function (tag) { return (React.createElement(Tag, { href: "/explore/" + tag.replace(/ /g, '-'), key: tag, onClick: function (e) { return onTagClick(e, tag); } }, tag)); })))));
    };
    Gif.defaultProps = {
        autoPlay: true,
        showTags: true,
        width: 200,
        onHover: noop$1,
        onSeen: noop$1,
        onVisible: noop$1,
        onClick: noop$1,
        onRightClick: noop$1,
        onTagClick: noop$1,
        useVideo: false,
        loop: true,
        hideAdIndicator: false,
    };
    return Gif;
}(PureComponent));

var Verified = function Verified(_ref) {
  var className = _ref.className,
      _ref$size = _ref.size,
      size = _ref$size === void 0 ? 14 : _ref$size;
  return React.createElement("svg", {
    className: className,
    height: size,
    title: "Verified",
    version: "1.1",
    viewBox: "-1 0 18 18",
    width: size
  }, React.createElement("g", {
    fill: "none",
    fillRule: "evenodd",
    stroke: "none",
    strokeWidth: "1"
  }, React.createElement("g", {
    fill: "#15CDFF",
    transform: "translate(-324.000000, -132.000000)"
  }, React.createElement("g", {
    id: "Group-3",
    transform: "translate(323.000000, 132.000000)"
  }, React.createElement("polygon", {
    points: "8.95093746 16.1755971 6.18494567 16.8455287 4.34519872 14.6949378 1.70947694 13.628319 1.49869564 10.8185214 2.85993451e-13 8.42276436 1.49869564 6.02700728 1.70947694 3.21720971 4.34519872 2.1505909 6.18494567 4.92383911e-14 8.95093746 0.669931593 11.7169293 4.82947016e-14 13.5566762 2.1505909 16.192398 3.21720971 16.4031793 6.02700728 17.9018749 8.42276436 16.4031793 10.8185214 16.192398 13.628319 13.5566762 14.6949378 11.7169293 16.8455287"
  }), React.createElement("path", {
    d: "M9.32727273,9.44126709 L9.32727273,3.03016561 L6.55027155,3.03016561 L6.55027155,10.8150746 L6.55027155,12.188882 L12.1042739,12.188882 L12.1042739,9.44126709 L9.32727273,9.44126709 Z",
    fill: "#121212",
    transform: "translate(9.327273, 7.609524) scale(-1, 1) rotate(-45.000000) translate(-9.327273, -7.609524) "
  })))));
};

function _templateObject$m() {
  var data = taggedTemplateLiteral(["\n    background-position: center;\n    background-repeat: no-repeat;\n    background-size: cover;\n    float: left;\n    height: 36px;\n    margin-right: 10px;\n    width: 36px;\n    background-image: url(", ");\n"]);

  _templateObject$m = function _templateObject() {
    return data;
  };

  return data;
}

var getSmallAvatar = function getSmallAvatar(avatar) {
  if (!avatar) return '';
  var ext = avatar.split('.').pop().toLowerCase();
  return avatar.replace(".".concat(ext), "/80h.".concat(ext));
};

var Avatar = styled.div(_templateObject$m(), function (props) {
  return getSmallAvatar(props.avatar);
});

function _templateObject7() {
  var data = taggedTemplateLiteral(["\n    ", "\n"]);

  _templateObject7 = function _templateObject7() {
    return data;
  };

  return data;
}

function _templateObject6() {
  var data = taggedTemplateLiteral(["\n    margin-left: 4px;\n"]);

  _templateObject6 = function _templateObject6() {
    return data;
  };

  return data;
}

function _templateObject5() {
  var data = taggedTemplateLiteral(["\n    align-items: center;\n    display: flex;\n    height: 100%;\n"]);

  _templateObject5 = function _templateObject5() {
    return data;
  };

  return data;
}

function _templateObject4$2() {
  var data = taggedTemplateLiteral(["\n    color: #fff;\n    font-size: 16px;\n    font-weight: 900;\n"]);

  _templateObject4$2 = function _templateObject4() {
    return data;
  };

  return data;
}

function _templateObject3$5() {
  var data = taggedTemplateLiteral(["\n    color: rgba(255, 255, 255, 0.8);\n    display: block;\n    flex-shrink: 0;\n    font-size: 14px;\n    font-weight: bold;\n    line-height: 18px;\n    overflow: hidden;\n    text-overflow: ellipsis;\n    white-space: nowrap;\n"]);

  _templateObject3$5 = function _templateObject3() {
    return data;
  };

  return data;
}

function _templateObject2$d() {
  var data = taggedTemplateLiteral(["\n    display: flex;\n    flex-direction: column;\n    height: 100%;\n"]);

  _templateObject2$d = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject$n() {
  var data = taggedTemplateLiteral(["\n    box-sizing: content-box;\n    cursor: pointer;\n    display: inline-block;\n    padding: 0;\n    max-width: 100%;\n    text-decoration: none;\n    transform: translate3d(0, 0, 0);\n"]);

  _templateObject$n = function _templateObject() {
    return data;
  };

  return data;
}
var Link = styled.a(_templateObject$n());
var Info = styled.div(_templateObject2$d());
var Username = styled.span(_templateObject3$5());
var DisplayName = styled(Username)(_templateObject4$2());
var UsernameWrapper = styled.div(_templateObject5());
var StyledVerified = styled(Verified)(_templateObject6());
var StyledAvatar = styled(Avatar)(_templateObject7(), function (props) {
  return props.compact && css$6(["width:25px;height:25px;margin-right:8px;"]);
});

var Attribution = function Attribution(_ref) {
  var user = _ref.user,
      _ref$compact = _ref.compact,
      compact = _ref$compact === void 0 ? false : _ref$compact,
      _ref$noAvatar = _ref.noAvatar,
      noAvatar = _ref$noAvatar === void 0 ? false : _ref$noAvatar,
      _ref$target = _ref.target,
      target = _ref$target === void 0 ? '_blank' : _ref$target;
  var avatar = user.avatar,
      avatar_url = user.avatar_url;
  var userAvatar = avatar_url || avatar;
  var displayName = user.display_name || user.username;
  var username = user.username;
  var height = noAvatar ? 'auto' : compact ? 25 : 36;
  return !user ? null : React.createElement(Link, {
    href: user.profile_url,
    rel: "noopener noreferrer",
    style: {
      height: height
    },
    target: target
  }, !noAvatar && userAvatar && React.createElement(StyledAvatar, {
    avatar: userAvatar,
    compact: compact
  }), React.createElement(Info, null, !compact && !noAvatar && React.createElement(DisplayName, null, displayName), React.createElement(UsernameWrapper, null, React.createElement(Username, null, compact || noAvatar ? displayName : "@".concat(username)), user.is_verified ? React.createElement(StyledVerified, {
    size: 14
  }) : null)));
};

function _templateObject2$e() {
  var data = taggedTemplateLiteral(["\n    font-family: ", ";\n    font-size: 20px;\n    font-weight: normal;\n    line-height: 1.5;\n    overflow: hidden;\n    margin: 0;\n    text-overflow: ellipsis;\n    white-space: nowrap;\n    cursor: pointer;\n    -webkit-font-smoothing: antialiased;\n\n    ", ";\n"]);

  _templateObject2$e = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject$o() {
  var data = taggedTemplateLiteral(["\n    box-sizing: border-box;\n    padding-top: 5px;\n    width: ", "px;\n"]);

  _templateObject$o = function _templateObject() {
    return data;
  };

  return data;
}
var IS_MOBILE$4 = mobileCheck();
var Container$g = styled.div(_templateObject$o(), function (_ref) {
  var width = _ref.width;
  return width;
});
var VideoTitle = styled.h3(_templateObject2$e(), titleFont, function (props) {
  return props.isSmall && css$6(["font-size:14px;"]);
});

var VideoPreviewLabel = function VideoPreviewLabel(_ref2) {
  var title = _ref2.title,
      _ref2$user = _ref2.user,
      user = _ref2$user === void 0 ? {} : _ref2$user,
      _ref2$showAttribution = _ref2.showAttribution,
      showAttribution = _ref2$showAttribution === void 0 ? true : _ref2$showAttribution,
      _ref2$target = _ref2.target,
      target = _ref2$target === void 0 ? '_self' : _ref2$target,
      _ref2$width = _ref2.width,
      width = _ref2$width === void 0 ? 0 : _ref2$width,
      onClick = _ref2.onClick,
      href = _ref2.href,
      _ref2$className = _ref2.className,
      className = _ref2$className === void 0 ? '' : _ref2$className,
      _ref2$noAvatar = _ref2.noAvatar,
      noAvatar = _ref2$noAvatar === void 0 ? IS_MOBILE$4 : _ref2$noAvatar;

  var defaultOnClick = function defaultOnClick() {
    return location.href = href;
  };

  var isSmall = width <= 300;
  return React.createElement(Container$g, {
    className: className,
    width: width
  }, React.createElement(VideoTitle, {
    isSmall: isSmall,
    onClick: onClick || defaultOnClick,
    title: title
  }, title), showAttribution && React.createElement(Attribution, {
    compact: true,
    noAvatar: noAvatar,
    target: target,
    user: user
  }));
};

var ASPECT_RATIO = 16 / 9;
var IS_MOBILE$5 = mobileCheck();
var Container$h = styled.div(templateObject_1$6 || (templateObject_1$6 = __makeTemplateObject(["\n    position: relative;\n"], ["\n    position: relative;\n"])));
var Preview = styled.a(templateObject_2$4 || (templateObject_2$4 = __makeTemplateObject(["\n    display: block;\n    position: relative;\n\n    img {\n        display: block;\n        height: 100%;\n        object-fit: cover;\n        width: 100%;\n    }\n"], ["\n    display: block;\n    position: relative;\n\n    img {\n        display: block;\n        height: 100%;\n        object-fit: cover;\n        width: 100%;\n    }\n"])));
var Play = styled.div(templateObject_5$2 || (templateObject_5$2 = __makeTemplateObject(["\n    position: absolute;\n    ", "\n"], ["\n    position: absolute;\n    ",
    "\n"])), function (props) {
    return props.centered
        ? css$6(templateObject_3$3 || (templateObject_3$3 = __makeTemplateObject(["\n                  align-items: center;\n                  display: flex;\n                  height: 100%;\n                  left: 0;\n                  justify-content: center;\n                  top: 0;\n                  width: 100%;\n              "], ["\n                  align-items: center;\n                  display: flex;\n                  height: 100%;\n                  left: 0;\n                  justify-content: center;\n                  top: 0;\n                  width: 100%;\n              "]))) : css$6(templateObject_4$2 || (templateObject_4$2 = __makeTemplateObject(["\n                  bottom: 12px;\n                  left: 12px;\n              "], ["\n                  bottom: 12px;\n                  left: 12px;\n              "])));
});
var VideoPreview = function (_a) {
    var children = _a.children, _b = _a.className, className = _b === void 0 ? '' : _b, _c = _a.video, video = _c === void 0 ? {} : _c, _d = _a.height, height = _d === void 0 ? 0 : _d, _e = _a.width, width = _e === void 0 ? 0 : _e, _f = _a.showAttribution, showAttribution = _f === void 0 ? true : _f, _g = _a.playButtonSize, playButtonSize = _g === void 0 ? 45 : _g, _h = _a.onHover, onHover = _h === void 0 ? function () { } : _h, _j = _a.onClick, onClick = _j === void 0 ? function () { } : _j;
    var previews = video.media.previews, url = video.url, title = video.title, user = video.user;
    var videoHeight = height || width / ASPECT_RATIO;
    var backgroundColor = useState(getColor())[0];
    var _k = useInView(), ref = _k[0], inView = _k[1];
    return (React.createElement(Container$h, { className: className, style: { width: width } },
        React.createElement("div", { ref: ref, style: { height: videoHeight, width: width } }, inView && (React.createElement(Preview, { href: url, onClick: onClick, onMouseOver: onHover, style: { height: videoHeight, backgroundColor: backgroundColor } },
            React.createElement("img", { src: getPosterUrl(previews, width, videoHeight) }),
            React.createElement(Play, { centered: IS_MOBILE$5 },
                React.createElement(PlayIcon, { size: playButtonSize })),
            children))),
        React.createElement(VideoPreviewLabel, { href: url, onClick: onClick, showAttribution: showAttribution, title: title, user: user, width: width })));
};
var templateObject_1$6, templateObject_2$4, templateObject_3$3, templateObject_4$2, templateObject_5$2;

function _arrayWithoutHoles(arr) {
  if (Array.isArray(arr)) {
    for (var i = 0, arr2 = new Array(arr.length); i < arr.length; i++) {
      arr2[i] = arr[i];
    }

    return arr2;
  }
}

var arrayWithoutHoles = _arrayWithoutHoles;

function _iterableToArray(iter) {
  if (Symbol.iterator in Object(iter) || Object.prototype.toString.call(iter) === "[object Arguments]") return Array.from(iter);
}

var iterableToArray = _iterableToArray;

function _nonIterableSpread() {
  throw new TypeError("Invalid attempt to spread non-iterable instance");
}

var nonIterableSpread = _nonIterableSpread;

function _toConsumableArray(arr) {
  return arrayWithoutHoles(arr) || iterableToArray(arr) || nonIterableSpread();
}

var toConsumableArray = _toConsumableArray;

function _templateObject6$1() {
  var data = taggedTemplateLiteral(["\n    font-size: ", ";\n    font-weight: ", ";\n"]);

  _templateObject6$1 = function _templateObject6() {
    return data;
  };

  return data;
}

function _templateObject5$1() {
  var data = taggedTemplateLiteral(["\n    background: ", ";\n    color: ", ";\n    font-size: 12px;\n    height: 30px;\n    line-height: 32px;\n    position: absolute;\n    right: 0;\n    text-align: center;\n    text-indent: 2px;\n    top: 0;\n    width: 30px;\n"]);

  _templateObject5$1 = function _templateObject5() {
    return data;
  };

  return data;
}

function _templateObject4$3() {
  var data = taggedTemplateLiteral(["\n    margin: ", ";\n    position: absolute;\n    ", "\n    top: ", ";\n    bottom: ", ";\n"]);

  _templateObject4$3 = function _templateObject4() {
    return data;
  };

  return data;
}

function _templateObject3$6() {
  var data = taggedTemplateLiteral(["\n    color: ", ";\n    background: ", ";\n    text-align: ", ";\n    padding: ", ";\n"]);

  _templateObject3$6 = function _templateObject3() {
    return data;
  };

  return data;
}

function _templateObject2$f() {
  var data = taggedTemplateLiteral(["\n    box-sizing: border-box;\n    cursor: pointer;\n    font-size: 14px;\n    font-weight: normal;\n    overflow: hidden;\n    padding: 0 10px;\n    text-align: left;\n    text-overflow: ellipsis;\n    user-select: none;\n    background: ", ";\n    color: ", ";\n    white-space: nowrap;\n"]);

  _templateObject2$f = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject$p() {
  var data = taggedTemplateLiteral(["\n    width: ", ";\n    box-sizing: border-box;\n    font-weight: normal;\n    height: 30px;\n    line-height: 30px;\n    min-width: 165px;\n    min-width: ", ";\n    padding-right: 30px;\n    position: relative;\n"]);

  _templateObject$p = function _templateObject() {
    return data;
  };

  return data;
}
var Container$i = styled.div(_templateObject$p(), function (props) {
  return props.width;
}, function (props) {
  return props.theme.container.minWidth;
});
var Button$4 = styled.div(_templateObject2$f(), giphyDarkGrey, giphyLightestGrey);
var DropdownDisplay = styled(Button$4)(_templateObject3$6(), function (props) {
  return props.theme.dropdownDisplay.color;
}, function (props) {
  return props.theme.dropdownDisplay.background;
}, function (props) {
  return props.theme.dropdownDisplay.textAlign;
}, function (props) {
  return props.theme.dropdownDisplay.padding;
});
var DropdownContainer$1 = styled.div(_templateObject4$3(), function (props) {
  return props.extendUp ? '0px 0px 12px 0px' : '12px 0px 0px 0px';
}, function (props) {
  return !props.center ? 'right: 0;' : null;
}, function (props) {
  return props.extendUp ? null : '100%';
}, function (props) {
  return props.extendUp ? '100%' : null;
});
var Arrow = styled.div(_templateObject5$1(), function (props) {
  return props.theme.arrow.background;
}, function (props) {
  return props.theme.arrow.color;
});
var DropdownLabel = styled.span(_templateObject6$1(), function (props) {
  return props.labelSize ? props.labelSize : '14px';
}, function (props) {
  return props.labelWeight ? props.labelWeight : null;
});
var MOUSE_LEAVE_TIMEOUT = 2000;

var SelectDropdown =
/*#__PURE__*/
function (_PureComponent) {
  inherits(SelectDropdown, _PureComponent);

  function SelectDropdown() {
    var _getPrototypeOf2;

    var _this;

    classCallCheck(this, SelectDropdown);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = possibleConstructorReturn(this, (_getPrototypeOf2 = getPrototypeOf(SelectDropdown)).call.apply(_getPrototypeOf2, [this].concat(args)));

    defineProperty(assertThisInitialized(_this), "state", {
      isOpen: false
    });

    defineProperty(assertThisInitialized(_this), "toggleOpen", function () {
      var isOpen = _this.state.isOpen;

      _this.setState({
        isOpen: !isOpen
      });
    });

    defineProperty(assertThisInitialized(_this), "onDocumentClick", function (_ref) {
      var target = _ref.target;

      // close the drop down if clicked outside
      if (!_this.container.contains(target)) {
        _this.setState({
          isOpen: false
        });
      }
    });

    defineProperty(assertThisInitialized(_this), "onMouseLeave", function () {
      // close the drop down after a time out of MOUSE_LEAVE_TIMEOUT
      _this.onLeaveTimeout = setTimeout(function () {
        return _this.setState({
          isOpen: false
        });
      }, MOUSE_LEAVE_TIMEOUT);
    });

    defineProperty(assertThisInitialized(_this), "onMouseOver", function () {
      return clearTimeout(_this.onLeaveTimeout);
    });

    return _this;
  }

  createClass(SelectDropdown, [{
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps, prevState) {
      var isOpen = this.state.isOpen;

      if (isOpen !== prevState.isOpen) {
        var onOpenChange = this.props.onOpenChange;
        onOpenChange(isOpen);

        if (isOpen) {
          document.addEventListener('click', this.onDocumentClick, false);
        } else {
          document.removeEventListener('click', this.onDocumentClick);
        }
      }
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      clearTimeout(this.onLeaveTimeout);
      document.removeEventListener('click', this.onDocumentClick);
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;

      var _this$props = this.props,
          children = _this$props.children,
          label = _this$props.label,
          padding = _this$props.padding,
          labelSize = _this$props.labelSize,
          labelWeight = _this$props.labelWeight,
          extendUp = _this$props.extendUp,
          theme = _this$props.theme,
          placeholder = _this$props.placeholder,
          width = _this$props.width,
          isDark = _this$props.isDark,
          LabelComponent = _this$props.LabelComponent,
          className = _this$props.className,
          center = _this$props.center,
          nipX = _this$props.nipX;
      var isOpen = this.state.isOpen;
      var activeTheme = themes[theme];
      var Label = LabelComponent || DropdownLabel;
      return React.createElement(ThemeProvider, {
        theme: activeTheme
      }, React.createElement(Container$i, {
        className: className,
        onMouseLeave: this.onMouseLeave,
        onMouseOver: this.onMouseOver,
        ref: function ref(c) {
          return _this2.container = c;
        },
        width: width
      }, React.createElement(DropdownDisplay, {
        isDark: isDark,
        onClick: this.toggleOpen,
        padding: padding
      }, React.createElement(Label, {
        labelSize: labelSize,
        labelWeight: labelWeight
      }, label || placeholder), React.createElement(Arrow, {
        className: extendUp ? isOpen ? 'ss-dropdown' : 'ss-directup' : isOpen ? 'ss-directup' : 'ss-dropdown '
      })), isOpen && React.createElement(DropdownContainer$1, {
        center: center,
        extendUp: extendUp
      }, React.createElement(Dropdown, {
        isExtendUp: extendUp,
        nipX: nipX,
        theme: theme
      }, children))));
    }
  }]);

  return SelectDropdown;
}(PureComponent);

defineProperty(SelectDropdown, "propTypes", {
  label: PropTypes.string,
  placeholder: PropTypes.string,
  width: PropTypes.number,
  extendUp: PropTypes.bool,
  labelSize: PropTypes.string,
  theme: PropTypes.string,
  onOpenChange: PropTypes.func,
  center: PropTypes.bool,
  nipX: PropTypes.string
});

defineProperty(SelectDropdown, "defaultProps", {
  label: '',
  placeholder: '',
  extendUp: false,
  theme: 'light',
  onOpenChange: function onOpenChange() {},
  center: false,
  nipX: 'calc(100% - 15px)'
});

function styleInject(css, ref) {
  if ( ref === void 0 ) ref = {};
  var insertAt = ref.insertAt;

  if (!css || typeof document === 'undefined') { return; }

  var head = document.head || document.getElementsByTagName('head')[0];
  var style = document.createElement('style');
  style.type = 'text/css';

  if (insertAt === 'top') {
    if (head.firstChild) {
      head.insertBefore(style, head.firstChild);
    } else {
      head.appendChild(style);
    }
  } else {
    head.appendChild(style);
  }

  if (style.styleSheet) {
    style.styleSheet.cssText = css;
  } else {
    style.appendChild(document.createTextNode(css));
  }
}

var css = "/* greys *//* primary *//* secondary *//* functional */\n.item_item__1RT85 {\n    cursor: pointer;\n    line-height: 23px;\n    margin-bottom: 10px;\n    position: relative;\n}\n.item_itemActive__GUdRB {\n    color: #4a4a4a;\n    font-weight: bold;\n}\n.item_itemActive__GUdRB[data-giphyisdark=\"true\"] {\n        color: #ffffff;\n    }\n\n.item_icon__1Q0Wq {\n    color: #6157ff;\n    display: inline-block;\n    height: 23px;\n    line-height: 23px;\n    margin: 1px 0 0 8px;\n    overflow: hidden;\n    pointer-events: none;\n    vertical-align: middle;\n    position: absolute;\n}\n\n.item_icon__1Q0Wq[data-giphyisdark=\"true\"] {\n        color: #00ccff;\n    }\n\n.item_addIcon__1v8eo {\n    font-size: 12px;\n}\n\n.item_removeIcon__m7C71 {\n    font-size: 13px;\n}\n\n.item_checkIcon__1ZnXv {\n    font-size: 13px;\n}\n";
var css$1 = {"giphyWhite":"#ffffff","giphyCharcoal":"#4a4a4a","giphyBlue":"#00ccff","primaryCTA":"#6157ff","item":"item_item__1RT85","itemActive":"item_itemActive__GUdRB item_item__1RT85","icon":"item_icon__1Q0Wq","addIcon":"item_addIcon__1v8eo item_icon__1Q0Wq ss-icon ss-plus","removeIcon":"item_removeIcon__m7C71 item_icon__1Q0Wq ss-icon ss-delete","checkIcon":"item_checkIcon__1ZnXv item_icon__1Q0Wq ss-icon ss-check"};
styleInject(css);

var SelectListItem =
/*#__PURE__*/
function (_PureComponent) {
  inherits(SelectListItem, _PureComponent);

  function SelectListItem() {
    var _getPrototypeOf2;

    var _this;

    classCallCheck(this, SelectListItem);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = possibleConstructorReturn(this, (_getPrototypeOf2 = getPrototypeOf(SelectListItem)).call.apply(_getPrototypeOf2, [this].concat(args)));

    defineProperty(assertThisInitialized(_this), "state", {
      isHovered: false
    });

    return _this;
  }

  createClass(SelectListItem, [{
    key: "onMouseOver",
    value: function onMouseOver() {
      this.setState({
        isHovered: true
      });
    }
  }, {
    key: "onMouseOut",
    value: function onMouseOut() {
      this.setState({
        isHovered: false
      });
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;

      var _this$props = this.props,
          label = _this$props.label,
          isActive = _this$props.isActive,
          isDark = _this$props.isDark,
          _onClick = _this$props.onClick;
      var isHovered = this.state.isHovered;
      var iconClass = isHovered ? isActive ? css$1.removeIcon : css$1.addIcon : isActive ? css$1.checkIcon : css$1.icon;
      return React.createElement("div", {
        className: isActive ? css$1.itemActive : css$1.item,
        "data-giphyisdark": isDark,
        onClick: function onClick() {
          return _onClick && _onClick(label);
        },
        onMouseOut: function onMouseOut() {
          return _this2.onMouseOut();
        },
        onMouseOver: function onMouseOver() {
          return _this2.onMouseOver();
        }
      }, label, React.createElement("i", {
        className: iconClass,
        "data-giphyisdark": isDark
      }));
    }
  }]);

  return SelectListItem;
}(PureComponent);

defineProperty(SelectListItem, "propTypes", {
  label: PropTypes.string.isRequired,
  isActive: PropTypes.bool,
  isDark: PropTypes.bool,
  onClick: PropTypes.func
});

var css$2 = "/* greys *//* primary *//* secondary *//* functional */\n\n.select_container__2XpvP {\n    box-sizing: border-box;\n    font-weight: normal;\n    height: 30px;\n    line-height: 30px;\n    min-width: 150px;\n    padding-right: 30px;\n    position: relative;\n}\n\n.select_button__2Y8sf {\n    background: #ffffff;\n    box-sizing: border-box;\n    color: #2e2e2e;\n    cursor: pointer;\n    font-size: 14px;\n    font-weight: normal;\n    overflow: hidden;\n    padding: 0 10px;\n    text-align: left;\n    text-overflow: ellipsis;\n    -webkit-user-select: none;\n       -moz-user-select: none;\n        -ms-user-select: none;\n            user-select: none;\n    white-space: nowrap;\n}\n.select_buttonDark__3Zxeg {\n    background: #2e2e2e;\n    color: #d8d8d8;\n}\n.select_buttonDark__3Zxeg .select_arrow__230eT {\n        background: #212121;\n        color: #00ccff;\n    }\n\n.select_listName__lGws9 {\n    color: #a6a6a6;\n    font-size: 14px;\n    font-weight: bold;\n    line-height: 30px;\n    margin: 0;\n    text-transform: capitalize;\n}\n\n.select_arrow__230eT {\n    background: #6157ff;\n    color: #ffffff;\n    font-size: 12px;\n    height: 30px;\n    line-height: 32px;\n    position: absolute;\n    right: 0;\n    text-align: center;\n    text-indent: 2px;\n    top: 0;\n    width: 30px;\n}\n.select_arrowClosed__MyZ41 {\n}\n.select_arrowOpen__KtfTw {\n}\n\n.select_dropdown__yYmlx {\n    margin-top: 12px;\n    position: absolute;\n    right: 0;\n    top: 100%;\n    white-space: nowrap;\n}\n\n.select_overlay__2OO8n {\n    height: 100%;\n    left: 0;\n    position: fixed;\n    top: 0;\n    width: 100%;\n    z-index: 2147483645;\n}\n";
var css$3 = {"giphyWhite":"#ffffff","giphyLightestGrey":"#d8d8d8","giphyLightGrey":"#a6a6a6","giphyDarkGrey":"#2e2e2e","giphyDarkestGrey":"#212121","giphyBlue":"#00ccff","primaryCTA":"#6157ff","container":"select_container__2XpvP","button":"select_button__2Y8sf","buttonDark":"select_buttonDark__3Zxeg select_button__2Y8sf","arrow":"select_arrow__230eT","listName":"select_listName__lGws9","arrowClosed":"select_arrowClosed__MyZ41 select_arrow__230eT ss-icon ss-directup","arrowOpen":"select_arrowOpen__KtfTw select_arrow__230eT ss-icon ss-dropdown","dropdown":"select_dropdown__yYmlx","overlay":"select_overlay__2OO8n"};
styleInject(css$2);

var arrayOf = PropTypes.arrayOf,
    bool = PropTypes.bool,
    func = PropTypes.func,
    number = PropTypes.number,
    string = PropTypes.string;

var SelectList =
/*#__PURE__*/
function (_PureComponent) {
  inherits(SelectList, _PureComponent);

  function SelectList() {
    var _getPrototypeOf2;

    var _this;

    classCallCheck(this, SelectList);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = possibleConstructorReturn(this, (_getPrototypeOf2 = getPrototypeOf(SelectList)).call.apply(_getPrototypeOf2, [this].concat(args)));

    defineProperty(assertThisInitialized(_this), "state", {
      activeItems: _this.props.active
    });

    return _this;
  }

  createClass(SelectList, [{
    key: "onItemClick",
    value: function onItemClick(item) {
      var _this$props = this.props,
          allowMultiple = _this$props.allowMultiple,
          onChange = _this$props.onChange;
      var activeItems = this.state.activeItems;
      var index = activeItems.indexOf(item);

      var items = toConsumableArray(activeItems);

      if (allowMultiple) {
        index > -1 ? items.splice(index, 1) : items.push(item);
      } else {
        items = index > -1 ? [] : [item];
      }

      this.setState({
        activeItems: items
      });
      onChange(allowMultiple ? items : items[0] || null);
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;

      var _this$props2 = this.props,
          placeholder = _this$props2.placeholder,
          options = _this$props2.options,
          label = _this$props2.label,
          title = _this$props2.title,
          width = _this$props2.width,
          theme = _this$props2.theme,
          extendUp = _this$props2.extendUp;
      var activeItems = this.state.activeItems;
      return React.createElement(SelectDropdown, {
        extendUp: extendUp,
        label: label || activeItems.join(', '),
        placeholder: placeholder,
        theme: theme,
        width: width
      }, React.createElement("div", null, title && React.createElement("div", {
        className: css$3.listName
      }, title), options.map(function (option, i) {
        return React.createElement(SelectListItem, {
          isActive: activeItems.indexOf(option) > -1,
          isDark: theme === 'dark' || theme === 'transparentDark',
          key: i,
          label: option,
          onClick: function onClick() {
            return _this2.onItemClick(option);
          }
        });
      })));
    }
  }]);

  return SelectList;
}(PureComponent);

defineProperty(SelectList, "propTypes", {
  options: arrayOf(string).isRequired,
  label: string,
  placeholder: string,
  title: string,
  width: number,
  allowMultiple: bool,
  // The default list of active items
  active: arrayOf(string),
  isDark: bool,
  onChange: func.isRequired,
  extendUp: bool
});

defineProperty(SelectList, "defaultProps", {
  active: [],
  placeholder: 'Options',
  allowMultiple: true,
  extendUp: false
});

var css$4 = "/* greys *//* secondary */\n\n.search-bar_search__25AZf {\n    box-sizing: border-box;\n    height: 50px;\n    padding-right: 50px;\n    position: relative;\n    width: 100%;\n}\n\n.search-bar_searchInput__2LiVb {\n    background: #ffffff;\n    border: 0;\n    border-radius: 0;\n    box-sizing: border-box;\n    color: #121212;\n    display: block;\n    font-family: 'interface', sans-serif;\n    font-size: 18px;\n    font-weight: normal;\n    height: 100%;\n    line-height: 50px;\n    margin: 0;\n    padding: 0 15px;\n    outline: none;\n    width: 100%;\n    -webkit-appearance: none;\n}\n\n.search-bar_button__fb9cW {\n    background: #a6a6a6;\n    color: #ffffff;\n    cursor: pointer;\n    font-size: 24px;\n    height: 50px;\n    line-height: 54px;\n    position: absolute;\n    right: 0;\n    text-align: center;\n    top: 0;\n    width: 50px;\n}\n\n.search-bar_button__fb9cW:active {\n        opacity: 0.9;\n    }\n.search-bar_buttonActive__1tSoq {\n    background: linear-gradient(45deg, #6157ff 0%, #e646b6 100%);\n}\n.search-bar_buttonActive__1tSoq:before {\n        -webkit-animation: search-bar_buttonFade__36Ra6 3s linear 0s infinite alternate;\n                animation: search-bar_buttonFade__36Ra6 3s linear 0s infinite alternate;\n        background: linear-gradient(45deg, #e646b6 0%, #6157ff 100%);\n        content: \"\";\n        height: 100%;\n        left: 0;\n        position: absolute;\n        top: 0;\n        width: 100%;\n    }\n\n.search-bar_buttonIcon__2U4qg {\n    position: relative;\n}\n\n@-webkit-keyframes search-bar_buttonFade__36Ra6 {\n    0% { opacity: 0; }\n    100% { opacity: 1; }\n}\n\n@keyframes search-bar_buttonFade__36Ra6 {\n    0% { opacity: 0; }\n    100% { opacity: 1; }\n}";
var css$5 = {"giphyWhite":"#ffffff","giphyBlack":"#121212","giphyLightGrey":"#a6a6a6","giphyPink":"#e646b6","giphyIndigo":"#6157ff","search":"search-bar_search__25AZf","searchInput":"search-bar_searchInput__2LiVb","button":"search-bar_button__fb9cW","buttonActive":"search-bar_buttonActive__1tSoq search-bar_button__fb9cW","buttonFade":"search-bar_buttonFade__36Ra6","buttonIcon":"search-bar_buttonIcon__2U4qg ss-search"};
styleInject(css$4);

var SearchBar =
/*#__PURE__*/
function (_PureComponent) {
  inherits(SearchBar, _PureComponent);

  function SearchBar(props) {
    var _this;

    classCallCheck(this, SearchBar);

    _this = possibleConstructorReturn(this, getPrototypeOf(SearchBar).call(this, props));
    _this.state = {
      value: props.defaultValue
    };
    return _this;
  }

  createClass(SearchBar, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      this.props.autoFocus && this.searchInput.focus();
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps, prevState) {
      var onInput = this.props.onInput;
      var value = this.state.value;

      if (onInput && value !== prevState.value) {
        onInput(value);
      }
    }
  }, {
    key: "onKeyDown",
    value: function onKeyDown(e) {
      // enter key
      if (e.which === 13) {
        e.preventDefault();
        this.onClick(); // esc key
      } else if (e.which === 27) {
        e.preventDefault();
        this.setState({
          value: ''
        });
      }
    }
  }, {
    key: "onInput",
    value: function onInput(text) {
      this.setState({
        value: text
      });
    }
  }, {
    key: "onClick",
    value: function onClick() {
      var _this$props = this.props,
          allowEmpty = _this$props.allowEmpty,
          onSearch = _this$props.onSearch;
      var value = this.state.value;

      if (allowEmpty || value) {
        onSearch(value);
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;

      var _this$props2 = this.props,
          placeholder = _this$props2.placeholder,
          allowEmpty = _this$props2.allowEmpty;
      var value = this.state.value;
      return React.createElement("div", {
        className: css$5.search
      }, React.createElement("input", {
        className: css$5.searchInput,
        onChange: function onChange(e) {
          return _this2.onInput(e.target.value);
        },
        onKeyDown: function onKeyDown(e) {
          return _this2.onKeyDown(e);
        },
        placeholder: placeholder,
        ref: function ref(c) {
          return _this2.searchInput = c;
        },
        type: "text",
        value: value
      }), React.createElement("div", {
        className: allowEmpty || value.length > 0 ? css$5.buttonActive : css$5.button,
        onClick: function onClick() {
          return _this2.onClick();
        }
      }, React.createElement("i", {
        className: css$5.buttonIcon
      })));
    }
  }]);

  return SearchBar;
}(PureComponent);

defineProperty(SearchBar, "propTypes", {
  placeholder: PropTypes.string,
  defaultValue: PropTypes.string,
  autoFocus: PropTypes.bool,
  allowEmpty: PropTypes.bool,
  onInput: PropTypes.func,
  onSearch: PropTypes.func.isRequired
});

defineProperty(SearchBar, "defaultProps", {
  placeholder: 'Search all the GIFs and Stickers',
  defaultValue: '',
  autoFocus: true,
  allowEmpty: false
});

function _templateObject6$2() {
  var data = taggedTemplateLiteral(["\n    color: rgba(255, 255, 255, 0.5);\n    cursor: pointer;\n    font-size: 16px;\n    font-weight: bold;\n    margin: 2px 0 0 auto;\n"]);

  _templateObject6$2 = function _templateObject6() {
    return data;
  };

  return data;
}

function _templateObject5$2() {
  var data = taggedTemplateLiteral(["\n    color: #ffffff;\n    opacity: ", ";\n    font-size: 12px;\n    font-weight: bold;\n    justify-content: space-around;\n    margin: 0 8px 0 0;\n    cursor: pointer;\n"]);

  _templateObject5$2 = function _templateObject5() {
    return data;
  };

  return data;
}

function _templateObject4$4() {
  var data = taggedTemplateLiteral(["\n    display: flex;\n    align-items: flex-end;\n    margin: 6px 0 0 3px;\n"]);

  _templateObject4$4 = function _templateObject4() {
    return data;
  };

  return data;
}

function _templateObject3$7() {
  var data = taggedTemplateLiteral(["\n    border: none;\n    background-color: transparent;\n    color: white;\n    font-size: 22px;\n    font-family: 'interface', sans-serif;\n    font-weight: bold;\n    line-height: 22px;\n    margin: 0;\n    padding: 0;\n    width: 60px;\n\n    &:focus {\n        border: none;\n        outline: none;\n    }\n    &::-webkit-clear-button {\n        -webkit-appearance: none;\n        margin: 0;\n    }\n    &::-webkit-datetime-edit-ampm-field {\n        display: none;\n    }\n    &::-webkit-inner-spin-button {\n        -webkit-appearance: none;\n        display: none;\n    }\n"]);

  _templateObject3$7 = function _templateObject3() {
    return data;
  };

  return data;
}

function _templateObject2$g() {
  var data = taggedTemplateLiteral(["\n    color: ", ";\n    margin: 6px 7px 0 0;\n    font-size: 12px;\n"]);

  _templateObject2$g = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject$q() {
  var data = taggedTemplateLiteral(["\n    align-items: center;\n    box-sizing: border-box;\n    display: flex;\n    height: 30px;\n    margin-top: 10px;\n    padding: 0 13px;\n    width: 100%;\n"]);

  _templateObject$q = function _templateObject() {
    return data;
  };

  return data;
}
var Wrapper$3 = styled.div(_templateObject$q());
var ClockImage = styled.span(_templateObject2$g(), function (props) {
  return props.theme.color;
});
var InputField = styled.input(_templateObject3$7());
var ToggleContainer = styled.div(_templateObject4$4());
var MidnightToggle = styled.p(_templateObject5$2(), function (props) {
  return props.active ? 1 : 0.5;
});
var NowButton = styled.div(_templateObject6$2());

var TimeSelector =
/*#__PURE__*/
function (_PureComponent) {
  inherits(TimeSelector, _PureComponent);

  function TimeSelector() {
    var _getPrototypeOf2;

    var _this;

    classCallCheck(this, TimeSelector);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = possibleConstructorReturn(this, (_getPrototypeOf2 = getPrototypeOf(TimeSelector)).call.apply(_getPrototypeOf2, [this].concat(args)));

    defineProperty(assertThisInitialized(_this), "state", {
      time: '00:00',
      isPm: false
    });

    defineProperty(assertThisInitialized(_this), "onChange", function () {
      _this.updateTime();
    });

    defineProperty(assertThisInitialized(_this), "onAmClick", function () {
      _this.setState({
        isPm: false
      }, function () {
        _this.updateTime();
      });
    });

    defineProperty(assertThisInitialized(_this), "onPmClick", function () {
      _this.setState({
        isPm: true
      }, function () {
        _this.updateTime();
      });
    });

    defineProperty(assertThisInitialized(_this), "onNowClick", function () {
      var onChange = _this.props.onChange;
      var now = new Date();
      onChange({
        hours: now.getHours(),
        minutes: now.getMinutes(),
        isNowClick: true
      });
    });

    return _this;
  }

  createClass(TimeSelector, [{
    key: "updateTime",
    value: function updateTime() {
      if (!this.timeInput) return;
      var onChange = this.props.onChange;
      var isPm = this.state.isPm;
      var time = this.timeInput.value;
      var bits = time.split(':');
      var hours = bits[0] % 12;
      var minutes = bits[1];
      onChange({
        hours: hours + (isPm ? 12 : 0),
        minutes: minutes
      });
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;

      var iconColor = this.props.iconColor;
      var _this$state = this.state,
          time = _this$state.time,
          isPm = _this$state.isPm;
      return React.createElement(Wrapper$3, null, React.createElement(ClockImage, {
        className: 'ss-clock',
        iconColor: iconColor
      }), React.createElement(InputField, {
        onChange: this.onChange,
        ref: function ref(c) {
          return _this2.timeInput = c;
        },
        type: "time",
        value: time
      }), React.createElement(ToggleContainer, null, React.createElement(MidnightToggle, {
        active: !isPm,
        onClick: this.onAmClick
      }, "AM"), React.createElement(MidnightToggle, {
        active: isPm,
        onClick: this.onPmClick
      }, "PM")), React.createElement(NowButton, {
        onClick: this.onNowClick
      }, "Now"));
    }
  }], [{
    key: "getDerivedStateFromProps",
    value: function getDerivedStateFromProps(_ref, _ref2) {
      var date = _ref.date;
      var lastDate = _ref2.lastDate;

      if (date !== lastDate) {
        return {
          time: date ? format(date, 'hh:mm') : '00:00',
          isPm: date ? date.getHours() > 11 : false,
          lastDate: date
        };
      }

      return null;
    }
  }]);

  return TimeSelector;
}(PureComponent);

defineProperty(TimeSelector, "propTypes", {
  date: PropTypes.instanceOf(Date),
  iconColor: PropTypes.string,
  onChange: PropTypes.func.isRequired
});

defineProperty(TimeSelector, "defaultProps", {
  allowMultiple: true,
  iconColor: giphyBlue
});

function _templateObject$r() {
  var data = taggedTemplateLiteral(["\n    margin: ", ";\n    color: ", ";\n    display: block;\n    overflow: hidden;\n    padding-bottom: 5px;\n    position: relative;\n    width: 280px;\n\n    button {\n        background: transparent;\n        border: 0;\n        color: inherit;\n        cursor: pointer;\n        font: inherit;\n        margin: 0;\n        outline: none;\n        padding: 0;\n        text-align: center;\n        -webkit-appearance: none;\n    }\n\n    div[class='pika-title'] {\n        align-items: center;\n        box-sizing: border-box;\n        display: flex;\n        margin-bottom: 10px;\n        padding: 0 10px;\n        width: 100%;\n\n        button[class*='pika-'] {\n            background: rgba(255, 255, 255, 0.1);\n            display: inline-block;\n            flex-grow: 0;\n            flex-shrink: 0;\n            font-size: 11px;\n            height: 20px;\n            line-height: 22px;\n            width: 30px;\n\n            i {\n                pointer-events: none;\n            }\n        }\n\n        button[class*='is-disabled'] {\n            opacity: 0.5;\n            pointer-events: none;\n        }\n\n        button[class*='pika-prev'] {\n            margin-left: auto;\n            margin-right: 2px;\n        }\n    }\n\n    div[class='pika-label'] {\n        color: ", ";\n        display: inline-block;\n        font-family: ", ";\n        font-size: 26px;\n        margin-right: 5px;\n        position: relative;\n\n        select {\n            cursor: pointer;\n            height: 100%;\n            left: 0;\n            opacity: 0;\n            position: absolute;\n            top: 0;\n            width: 100%;\n        }\n    }\n\n    table[class='pika-table'] {\n        color: ", ";\n        font-size: 14px;\n        font-weight: bold;\n        line-height: 30px;\n        text-align: center;\n        width: 100%;\n\n        abbr {\n            color: ", ";\n            text-decoration: none;\n        }\n\n        button {\n            display: block;\n            height: 30px;\n            position: relative;\n            width: 100%;\n            z-index: 2;\n        }\n\n        td[class*='is-disabled'] {\n            color: ", ";\n            pointer-events: none;\n        }\n\n        td[class*='is-today'] {\n            color: ", ";\n        }\n\n        td[class*='is-inrange'] {\n            color: ", ";\n            position: relative;\n\n            &:before {\n                background: ", ";\n                box-sizing: content-box;\n                content: '';\n                height: 100%;\n                left: -7px;\n                padding: 0 7px;\n                position: absolute;\n                top: 0;\n                width: 100%;\n            }\n        }\n\n        td[class*='is-selected'],\n        td[class*='is-startrange'],\n        td[class*='is-endrange'] {\n            color: ", ";\n            position: relative;\n\n            &:before {\n                animation: ", " 0.1s ease-out;\n                background: ", ";\n                border-radius: 50%;\n                box-shadow: 0 0 10px rgba(0, 0, 0, 0.2);\n                content: '';\n                height: 40px;\n                left: 50%;\n                margin: -21px 0 0 -20px;\n                pointer-events: none;\n                position: absolute;\n                top: 50%;\n                width: 40px;\n                z-index: 1;\n            }\n        }\n    }\n"]);

  _templateObject$r = function _templateObject() {
    return data;
  };

  return data;
}
var bloop$1 = keyframes(["0%{transform:scale(0);}100%{transform:scale(1);}"]);
var Wrapper$4 = styled.div(_templateObject$r(), function (props) {
  return props.theme.margin ? props.theme.margin : '0 auto';
}, giphyWhite, function (props) {
  return props.theme.color;
}, titleFont, giphyLightGrey, giphyWhite, giphyLightCharcoal, giphyWhite, giphyWhite, function (props) {
  return props.theme.altColor;
}, giphyWhite, bloop$1, function (props) {
  return props.theme.color;
});

var DatePicker =
/*#__PURE__*/
function (_PureComponent) {
  inherits(DatePicker, _PureComponent);

  function DatePicker() {
    var _getPrototypeOf2;

    var _this;

    classCallCheck(this, DatePicker);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = possibleConstructorReturn(this, (_getPrototypeOf2 = getPrototypeOf(DatePicker)).call.apply(_getPrototypeOf2, [this].concat(args)));

    defineProperty(assertThisInitialized(_this), "state", {
      startDate: null,
      endDate: null
    });

    defineProperty(assertThisInitialized(_this), "picker", null);

    defineProperty(assertThisInitialized(_this), "time", {
      hours: 0,
      minutes: 0
    });

    defineProperty(assertThisInitialized(_this), "isShift", false);

    defineProperty(assertThisInitialized(_this), "onKeyDown", _this.keyDown.bind(assertThisInitialized(_this)));

    defineProperty(assertThisInitialized(_this), "onKeyUp", _this.keyUp.bind(assertThisInitialized(_this)));

    defineProperty(assertThisInitialized(_this), "updateTime", function (_ref) {
      var _ref$hours = _ref.hours,
          hours = _ref$hours === void 0 ? 0 : _ref$hours,
          _ref$minutes = _ref.minutes,
          minutes = _ref$minutes === void 0 ? 0 : _ref$minutes,
          _ref$isNowClick = _ref.isNowClick,
          isNowClick = _ref$isNowClick === void 0 ? false : _ref$isNowClick;
      var _this$state = _this.state,
          startDate = _this$state.startDate,
          endDate = _this$state.endDate;
      var targetDate = endDate || startDate;
      var date = new Date(targetDate ? targetDate.getTime() : Date.now());
      isNowClick && _this.picker.setDate(date);
      _this.time = {
        hours: hours,
        minutes: minutes
      };

      _this.onDatePick(date);
    });

    return _this;
  }

  createClass(DatePicker, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      var _this2 = this;

      var _this$props = this.props,
          minDate = _this$props.minDate,
          maxDate = _this$props.maxDate,
          defaultValue = _this$props.defaultValue,
          defaultRange = _this$props.defaultRange,
          allowMultiple = _this$props.allowMultiple;

      if (defaultValue) {
        this.time = {
          hours: defaultValue.getHours(),
          minutes: defaultValue.getMinutes()
        };
        this.setState({
          startDate: defaultValue
        });
      }

      this.picker = new Pikaday({
        minDate: minDate,
        maxDate: maxDate,
        defaultDate: defaultValue,
        setDefaultDate: !!defaultValue,
        showDaysInNextAndPreviousMonths: false,
        enableSelectionDaysInNextAndPreviousMonths: true,
        keyboardInput: false,
        i18n: {
          previousMonth: '<i class="ss-navigateleft"></i>',
          nextMonth: '<i class="ss-navigateright"></i>',
          months: ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'],
          weekdays: ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'],
          weekdaysShort: ['S', 'M', 'T', 'W', 'T', 'F', 'S']
        },
        onSelect: function onSelect(date) {
          return _this2.onDatePick(date);
        }
      });

      if (allowMultiple) {
        window.addEventListener('keydown', this.onKeyDown, false);
        window.addEventListener('keyup', this.onKeyUp, false);

        if (defaultRange && defaultRange.length > 1) {
          this.picker.setStartRange(defaultRange[0]);
          this.picker.setEndRange(defaultRange[1]);
          this.picker.gotoDate(defaultRange[1]);
        }
      }

      this.el.appendChild(this.picker.el);
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      this.picker && this.picker.destroy();

      if (this.props.allowMultiple) {
        window.removeEventListener('keydown', this.onKeyDown, false);
        window.removeEventListener('keyup', this.onKeyUp, false);
      }
    }
  }, {
    key: "onDatePick",
    value: function onDatePick(date) {
      var _this$props2 = this.props,
          allowMultiple = _this$props2.allowMultiple,
          onUpdate = _this$props2.onUpdate;
      var _this$state2 = this.state,
          startDate = _this$state2.startDate,
          endDate = _this$state2.endDate;
      var _this$time = this.time,
          hours = _this$time.hours,
          minutes = _this$time.minutes;
      var newEndDate = endDate;
      var newStartDate = startDate;

      if (startDate && this.isShift) {
        var isEarlier = date < startDate;
        newEndDate = date;
        this.picker.setStartRange(isEarlier ? date : startDate);
        this.picker.setEndRange(isEarlier ? startDate : date);
        this.picker.gotoDate(date);
      } else {
        this.picker.setStartRange(null);
        this.picker.setEndRange(null);
        this.picker.gotoDate(date);
        newStartDate = date;
        newEndDate = null;
      } // update time


      var targetDate = newEndDate || newStartDate;
      targetDate.setHours(hours);
      targetDate.setMinutes(minutes);
      targetDate.setSeconds(0);
      this.setState({
        startDate: newStartDate,
        endDate: newEndDate
      });
      onUpdate && onUpdate(newStartDate, allowMultiple ? newEndDate : null);
    }
  }, {
    key: "keyDown",
    value: function keyDown(_ref2) {
      var which = _ref2.which;
      this.isShift = which === 16;
    }
  }, {
    key: "keyUp",
    value: function keyUp() {
      this.isShift = false;
    }
  }, {
    key: "render",
    value: function render() {
      var _this3 = this;

      var _this$props3 = this.props,
          color = _this$props3.color,
          altColor = _this$props3.altColor,
          margin = _this$props3.margin,
          hasTimeSelect = _this$props3.hasTimeSelect;
      var _this$state3 = this.state,
          startDate = _this$state3.startDate,
          endDate = _this$state3.endDate;
      return React.createElement(ThemeProvider, {
        theme: {
          color: color,
          margin: margin,
          altColor: altColor
        }
      }, React.createElement(Wrapper$4, null, React.createElement("div", {
        ref: function ref(c) {
          return _this3.el = c;
        }
      }), hasTimeSelect && React.createElement(TimeSelector, {
        date: endDate || startDate,
        onChange: this.updateTime
      })));
    }
  }]);

  return DatePicker;
}(PureComponent);

defineProperty(DatePicker, "propTypes", {
  color: PropTypes.string,
  altColor: PropTypes.string,
  minDate: PropTypes.object,
  maxDate: PropTypes.object,
  defaultValue: PropTypes.object,
  defaultRange: PropTypes.array,
  allowMultiple: PropTypes.bool,
  hasTimeSelect: PropTypes.bool,
  onUpdate: PropTypes.func
});

defineProperty(DatePicker, "defaultProps", {
  color: giphyBlue,
  altColor: giphyIndigo,
  allowMultiple: true
});

/** `Object#toString` result references. */
var mapTag$5 = '[object Map]',
    setTag$5 = '[object Set]';

/** Used for built-in method references. */
var objectProto$e = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty$b = objectProto$e.hasOwnProperty;

/**
 * Checks if `value` is an empty object, collection, map, or set.
 *
 * Objects are considered empty if they have no own enumerable string keyed
 * properties.
 *
 * Array-like values such as `arguments` objects, arrays, buffers, strings, or
 * jQuery-like collections are considered empty if they have a `length` of `0`.
 * Similarly, maps and sets are considered empty if they have a `size` of `0`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is empty, else `false`.
 * @example
 *
 * _.isEmpty(null);
 * // => true
 *
 * _.isEmpty(true);
 * // => true
 *
 * _.isEmpty(1);
 * // => true
 *
 * _.isEmpty([1, 2, 3]);
 * // => false
 *
 * _.isEmpty({ 'a': 1 });
 * // => false
 */
function isEmpty(value) {
  if (value == null) {
    return true;
  }
  if (isArrayLike_1(value) &&
      (isArray_1(value) || typeof value == 'string' || typeof value.splice == 'function' ||
        isBuffer_1(value) || isTypedArray_1(value) || isArguments_1(value))) {
    return !value.length;
  }
  var tag = _getTag(value);
  if (tag == mapTag$5 || tag == setTag$5) {
    return !value.size;
  }
  if (_isPrototype(value)) {
    return !_baseKeys(value).length;
  }
  for (var key in value) {
    if (hasOwnProperty$b.call(value, key)) {
      return false;
    }
  }
  return true;
}

var isEmpty_1 = isEmpty;

function _templateObject2$h() {
  var data = taggedTemplateLiteral(["\n    background-color: ", ";\n    border-radius: 6px;\n    display: inline-block;\n    padding: 2px 10px;\n    margin: 4px 0 -1px 0;\n"]);

  _templateObject2$h = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject$s() {
  var data = taggedTemplateLiteral(["\n    color: ", ";\n    line-height: initial;\n    user-select: none;\n    ", ";\n"]);

  _templateObject$s = function _templateObject() {
    return data;
  };

  return data;
}

var getCreationDate = function getCreationDate(publishDateTime) {
  var now = new Date();
  var publishDate = new Date(publishDateTime);
  var timeDiff = Math.abs(now - publishDate); // less than an hour show Just now

  if (timeDiff < 60 * 60 * 1000) {
    return 'Just now';
  } // if the date is longer than a month ago, just show the date


  if (differenceInMonths(publishDate, now) < -1) {
    return format(publishDate, 'MMM D, YYYY');
  }

  return distanceInWordsToNow(publishDateTime, {
    addSuffix: true
  }) // ex: about 1 hour ago
  .replace(/about /gi, '') // remove 'about'
  .replace(/ minutes?/gi, 'm') // 1m
  .replace(/ hours?/gi, 'h') // 1h
  .replace(/ days?/gi, 'd') // 1d
  .replace(/ months?/gi, 'mo'); // 1mo
};

var regularCard = css$6(["margin-top:7px;margin-bottom:1px;"]); // large card is for desktop

var largeCard = css$6(["margin-top:6px;font-size:16px;margin-bottom:4px;"]); // slim card is long and narrow

var slimCard = css$6(["margin-top:5px;margin-bottom:-1px;"]);
var Text = styled(SubheaderSmall)(_templateObject$s(), hexToRgba(giphyWhite, 75), function (_ref) {
  var _ref$theme = _ref.theme,
      isLargeCard = _ref$theme.isLargeCard,
      isSlimCard = _ref$theme.isSlimCard;
  return isLargeCard ? largeCard : isSlimCard ? slimCard : regularCard;
});
var Ad = styled(Text)(_templateObject2$h(), hexToRgba(giphyDarkestGrey, 75));

var Footer$2 = function Footer(_ref2) {
  var user = _ref2.user,
      isAd = _ref2.isAd,
      publishDateTime = _ref2.publishDateTime;
  return isAd ? React.createElement(Ad, null, "Ad") : React.createElement(Text, null, getCreationDate(publishDateTime), user ? " by @".concat(user.username) : '');
};

var ProgressBar =
/*#__PURE__*/
function (_PureComponent) {
  inherits(ProgressBar, _PureComponent);

  function ProgressBar() {
    classCallCheck(this, ProgressBar);

    return possibleConstructorReturn(this, getPrototypeOf(ProgressBar).apply(this, arguments));
  }

  createClass(ProgressBar, [{
    key: "render",
    value: function render() {
      return null;
    }
  }]);

  return ProgressBar;
}(PureComponent);

function _templateObject3$8() {
  var data = taggedTemplateLiteral(["\n    bottom: 100%;\n    left: -10px;\n    line-height: 1.3;\n    margin-bottom: 5px;\n    position: absolute;\n"]);

  _templateObject3$8 = function _templateObject3() {
    return data;
  };

  return data;
}

function _templateObject2$i() {
  var data = taggedTemplateLiteral(["\n    background: ", ";\n    box-shadow: 0 0 7px rgba(0, 0, 0, 0.5);\n    color: ", ";\n    font-size: 22px;\n    height: 50px;\n    left: 10px;\n    line-height: 54px;\n    position: absolute;\n    text-align: center;\n    top: 10px;\n    width: 50px;\n    ", ";\n"]);

  _templateObject2$i = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject$t() {
  var data = taggedTemplateLiteral(["\n    height: 100%;\n    left: 0;\n    position: absolute;\n    top: 0;\n    width: 100%;\n\n    &:before {\n        background: ", ";\n        content: '';\n        height: 100%;\n        left: 0;\n        opacity: ", ";\n        position: absolute;\n        top: 0;\n        width: 100%;\n    }\n"]);

  _templateObject$t = function _templateObject() {
    return data;
  };

  return data;
}
var IconWrapper$1 = styled.div(_templateObject$t(), giphyBlack, function (props) {
  return props.noBackground ? 0 : 0.5;
});
var Icon$1 = styled.div(_templateObject2$i(), giphyBlack, function (props) {
  return props.color;
}, function (_ref) {
  var iconTheme = _ref.theme.iconTheme;
  return iconTheme;
});
var Tooltip$1 = styled.div(_templateObject3$8());

var StoryPreviewIcon =
/*#__PURE__*/
function (_PureComponent) {
  inherits(StoryPreviewIcon, _PureComponent);

  function StoryPreviewIcon() {
    var _getPrototypeOf2;

    var _this;

    classCallCheck(this, StoryPreviewIcon);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = possibleConstructorReturn(this, (_getPrototypeOf2 = getPrototypeOf(StoryPreviewIcon)).call.apply(_getPrototypeOf2, [this].concat(args)));

    defineProperty(assertThisInitialized(_this), "state", {
      showDropdown: false
    });

    defineProperty(assertThisInitialized(_this), "onMouseOver", function () {
      _this.setState({
        showDropdown: true
      });
    });

    defineProperty(assertThisInitialized(_this), "onMouseOut", function () {
      _this.setState({
        showDropdown: false
      });
    });

    return _this;
  }

  createClass(StoryPreviewIcon, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
          hasWatched = _this$props.hasWatched,
          hideIcons = _this$props.hideIcons,
          icon = _this$props.icon,
          color = _this$props.color,
          message = _this$props.message;
      var showDropdown = this.state.showDropdown;
      return icon || hasWatched ? React.createElement(IconWrapper$1, {
        hasWatched: hasWatched,
        noBackground: hideIcons && !hasWatched
      }, !hideIcons && icon && React.createElement(Icon$1, {
        className: icon,
        color: color,
        onMouseOut: this.onMouseOut,
        onMouseOver: this.onMouseOver
      }), showDropdown && React.createElement(Tooltip$1, null, React.createElement(Dropdown, {
        isExtendUp: true,
        nipX: "45px"
      }, message))) : null;
    }
  }]);

  return StoryPreviewIcon;
}(PureComponent);

defineProperty(StoryPreviewIcon, "propTypes", {
  icon: PropTypes.string,
  color: PropTypes.string,
  message: PropTypes.string,
  hasWatched: PropTypes.bool,
  hideIcons: PropTypes.bool
});

var getIconData = function getIconData(_ref) {
  var publish_datetime = _ref.publish_datetime,
      is_private = _ref.is_private,
      publishDateTime = _ref.publishDateTime,
      isPrivate = _ref.isPrivate,
      hideIcons = _ref.hideIcons;

  if (hideIcons) {
    return {};
  } // fallback for raw story data from api vs camelCased nice story data


  publishDateTime = publishDateTime || publish_datetime;
  isPrivate = isPrivate || is_private;
  var now = new Date();
  var published = new Date(publishDateTime);
  var isUnpublished = now - published < 0;

  if (isUnpublished) {
    return {
      color: giphyYellow,
      icon: 'ss-clock',
      message: "This story ".concat(isPrivate ? 'is private and ' : '', "will be published on ").concat(format(published, 'MMMM D'), ".")
    };
  }

  if (isPrivate) {
    return {
      color: giphyRed,
      icon: 'ss-lock',
      message: 'This story is private, only you can see it.'
    };
  }

  return {};
};

function _templateObject14() {
  var data = taggedTemplateLiteral(["\n    height: 6px;\n    margin: 0 12px;\n    opacity: 0.4;\n"]);

  _templateObject14 = function _templateObject14() {
    return data;
  };

  return data;
}

function _templateObject13() {
  var data = taggedTemplateLiteral(["\n    box-shadow: 0 1px 1px 0 rgba(0, 0, 0, 0.35);\n    height: 6px;\n    margin: 0 6px;\n    opacity: 0.6;\n"]);

  _templateObject13 = function _templateObject13() {
    return data;
  };

  return data;
}

function _templateObject12() {
  var data = taggedTemplateLiteral(["\n    box-shadow: 0 1px 1px 0 rgba(0, 0, 0, 0.35);\n    height: 3px;\n    opacity: 0.8;\n"]);

  _templateObject12 = function _templateObject12() {
    return data;
  };

  return data;
}

function _templateObject11() {
  var data = taggedTemplateLiteral(["\n    background: ", ";\n"]);

  _templateObject11 = function _templateObject11() {
    return data;
  };

  return data;
}

function _templateObject10() {
  var data = taggedTemplateLiteral(["\n    flex: 1;\n"]);

  _templateObject10 = function _templateObject10() {
    return data;
  };

  return data;
}

function _templateObject9() {
  var data = taggedTemplateLiteral(["\n    overflow: hidden;\n    ", ";\n    ", " {\n        ", ";\n        transition: transform 150ms linear;\n        transform: scale(", ");\n    }\n"]);

  _templateObject9 = function _templateObject9() {
    return data;
  };

  return data;
}

function _templateObject8() {
  var data = taggedTemplateLiteral(["\n    width: 100%;\n    height: 100%;\n    transition: transform 150ms linear;\n    transform: scale(", ");\n"]);

  _templateObject8 = function _templateObject8() {
    return data;
  };

  return data;
}

function _templateObject7$1() {
  var data = taggedTemplateLiteral(["\n    position: absolute;\n    top: 0;\n    left: 0;\n    width: 100%;\n    height: 100%;\n    overflow: hidden;\n\n    ", ";\n"]);

  _templateObject7$1 = function _templateObject7() {
    return data;
  };

  return data;
}

function _templateObject6$3() {
  var data = taggedTemplateLiteral(["\n    overflow: hidden;\n    position: relative;\n    display: flex;\n    flex-direction: column;\n    padding: ", ";\n    flex: 1;\n    align-items: flex-start;\n    justify-content: flex-end;\n    z-index: 0;\n"]);

  _templateObject6$3 = function _templateObject6() {
    return data;
  };

  return data;
}

function _templateObject5$3() {
  var data = taggedTemplateLiteral(["\n    display: flex;\n    flex-direction: column;\n    position: relative;\n    height: 100%;\n    background-color: ", ";\n"]);

  _templateObject5$3 = function _templateObject5() {
    return data;
  };

  return data;
}

function _templateObject4$5() {
  var data = taggedTemplateLiteral(["\n    position: relative;\n    width: 100%;\n    &:after {\n        ", ";\n        background: linear-gradient(rgba(0, 0, 0, 0), ", " 100%);\n        opacity: ", ";\n    }\n    &:before {\n        background: linear-gradient(rgba(0, 0, 0, 0), ", ");\n        ", ";\n        opacity: ", ";\n    }\n"]);

  _templateObject4$5 = function _templateObject4() {
    return data;
  };

  return data;
}

function _templateObject3$9() {
  var data = taggedTemplateLiteral(["\n    ", ";\n    width: 75%;\n"]);

  _templateObject3$9 = function _templateObject3() {
    return data;
  };

  return data;
}

function _templateObject2$j() {
  var data = taggedTemplateLiteral(["\n    ", ";\n    font-size: 16px;\n"]);

  _templateObject2$j = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject$u() {
  var data = taggedTemplateLiteral(["\n    cursor: pointer;\n    display: flex;\n    flex-direction: column;\n    position: relative;\n    opacity: ", ";\n    text-shadow: 0 2px ", " rgba(0, 0, 0, 0.25);\n"]);

  _templateObject$u = function _templateObject() {
    return data;
  };

  return data;
}
var padding = "10px";
var LARGE_CARD_HEIGHT = 280;
var SLIM_CARD_HEIGHT = 112;
var iconSize = css$6(["width:36px;height:36px;"]);
var iconSizeLarge = css$6(["width:50px;height:50px;"]);
var regularIconTheme = css$6(["", ";font-size:17px;line-height:40px;"], iconSize);
var largeIconTheme = css$6(["", ";font-size:22px;line-height:54px;"], iconSizeLarge);
var Container$j = styled.div(_templateObject$u(), function (props) {
  return props.hasWatched ? 0.5 : 1;
}, padding);
var titleCss = css$6(["color:", ";line-height:1.2;user-select:none;"], giphyWhite);
var SmallTitle = styled(TitleSmall)(_templateObject2$j(), titleCss);
var RegTitle = styled(TitleSmall)(_templateObject3$9(), titleCss);
var gradCss = css$6(["content:'';z-index:-1;top:-40px;left:0;bottom:0;right:0;margin:-", ";position:absolute;transition:opacity 150ms linear;"], padding);
var GradientContainer = styled.div(_templateObject4$5(), gradCss, function (props) {
  return props.theme.color;
}, function (props) {
  return props.theme.isMouseOver ? 1 : 0;
}, hexToRgba(giphyBlack, 60), gradCss, function (props) {
  return props.theme.isMouseOver ? 0 : 1;
});
var ContainerInner = styled.div(_templateObject5$3(), function (props) {
  return props.theme.color;
});
var Content$1 = styled.div(_templateObject6$3(), padding);
var GifContainer = styled.div(_templateObject7$1(), function (props) {
  return props.isSticker && css$6(["background-color:", ";background-image:linear-gradient(45deg,#222 25%,transparent 25%,transparent 75%,#222 75%,#222 100%),linear-gradient(45deg,#222 25%,transparent 25%,transparent 75%,#222 75%,#222 100%);background-position:0 0,19px 19px;background-size:38px 38px;img{object-fit:contain;}"], giphyBlack);
});
var GifInnerContainer = styled.div(_templateObject8(), function (props) {
  return props.theme.isMouseOver ? 1.15 : 1;
});
var AvatarScaler = styled.div(_templateObject9(), function (_ref) {
  var isLargeCard = _ref.theme.isLargeCard;
  return isLargeCard ? iconSizeLarge : iconSize;
}, Avatar, function (_ref2) {
  var iconTheme = _ref2.theme.iconTheme;
  return iconTheme;
}, function (props) {
  return props.theme.isMouseOver ? 1.2 : 1.0;
});
var AvatarFlex = styled.div(_templateObject10());
var Cascade = styled.div(_templateObject11(), function (props) {
  return props.theme.color;
});
var Cascade1 = styled(Cascade)(_templateObject12());
var Cascade2 = styled(Cascade)(_templateObject13());
var Cascade3 = styled(Cascade)(_templateObject14());

var StoryPreview =
/*#__PURE__*/
function (_PureComponent) {
  inherits(StoryPreview, _PureComponent);

  function StoryPreview() {
    var _getPrototypeOf2;

    var _this;

    classCallCheck(this, StoryPreview);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = possibleConstructorReturn(this, (_getPrototypeOf2 = getPrototypeOf(StoryPreview)).call.apply(_getPrototypeOf2, [this].concat(args)));

    defineProperty(assertThisInitialized(_this), "state", {});

    defineProperty(assertThisInitialized(_this), "onMouseOver", function () {
      return _this.setState({
        isMouseOver: true
      });
    });

    defineProperty(assertThisInitialized(_this), "onMouseOut", function () {
      return _this.setState({
        isMouseOver: false
      });
    });

    return _this;
  }

  createClass(StoryPreview, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
          isAnimating = _this$props.autoPlay,
          hasWatched = _this$props.hasWatched,
          _this$props$onClick = _this$props.onClick,
          _onClick = _this$props$onClick === void 0 ? function () {} : _this$props$onClick,
          width = _this$props.width,
          height = _this$props.height,
          hideIcons = _this$props.hideIcons,
          rendition = _this$props.rendition,
          timestampText = _this$props.timestampText,
          showUsername = _this$props.showUsername,
          children = _this$props.children,
          _this$props$numberOfL = _this$props.numberOfLines,
          numberOfLines = _this$props$numberOfL === void 0 ? false : _this$props$numberOfL,
          _this$props$story = _this$props.story,
          story_id = _this$props$story.story_id,
          title = _this$props$story.title,
          coverGif = _this$props$story.cover_gif,
          _this$props$story$tag = _this$props$story.tags,
          tags = _this$props$story$tag === void 0 ? [] : _this$props$story$tag,
          _this$props$story$use = _this$props$story.user,
          user = _this$props$story$use === void 0 ? {} : _this$props$story$use,
          publishDateTime = _this$props$story.publish_datetime,
          isPrivate = _this$props$story.is_private,
          color = _this$props$story.color;

      var gif = coverGif.gif;
      var isAd = tags.indexOf('ad') !== -1;
      var isMouseOver = this.state.isMouseOver;
      var isLargeCard = height >= LARGE_CARD_HEIGHT;
      var isSlimCard = height <= SLIM_CARD_HEIGHT;
      var iconTheme = isLargeCard ? largeIconTheme : regularIconTheme;
      var Title = isLargeCard ? RegTitle : SmallTitle;
      var iconData = getIconData({
        publishDateTime: publishDateTime,
        isPrivate: isPrivate,
        hasWatched: hasWatched,
        hideIcons: hideIcons
      });

      if (!gif) {
        console.warn("No gif for ".concat(story_id));
        return null;
      }

      return React.createElement(ThemeProvider, {
        theme: {
          color: color,
          isMouseOver: isMouseOver,
          iconTheme: iconTheme,
          isLargeCard: isLargeCard,
          isSlimCard: isSlimCard
        }
      }, React.createElement(Container$j, {
        onClick: function onClick() {
          return _onClick(story_id);
        },
        onMouseOut: this.onMouseOut,
        onMouseOver: this.onMouseOver,
        style: {
          width: width,
          height: height
        }
      }, React.createElement(ContainerInner, null, React.createElement(GifContainer, {
        isSticker: gif.is_sticker
      }, React.createElement(GifInnerContainer, null, React.createElement(Media, {
        gif: gif,
        rendition: rendition,
        width: width,
        height: height,
        isAnimating: isAnimating
      }))), React.createElement(Content$1, null, React.createElement(ProgressBar, null), !isSlimCard && isEmpty_1(iconData) && user.is_public && React.createElement(AvatarFlex, null, React.createElement(AvatarScaler, null, React.createElement(Avatar, {
        avatar: user.avatar || user.avatar_url
      }))), React.createElement(GradientContainer, null, React.createElement(Title, null, React.createElement(Truncate, {
        lines: isSlimCard ? 3 : numberOfLines,
        trimWhitespace: true
      }, title)), children || React.createElement(Footer$2, {
        gif: gif,
        timestampText: timestampText,
        isAd: isAd,
        publishDateTime: publishDateTime,
        user: showUsername && user.username ? user : null
      }))), !isSlimCard && React.createElement(StoryPreviewIcon, iconData)), React.createElement(Cascade1, null), React.createElement(Cascade2, null), React.createElement(Cascade3, null)));
    }
  }]);

  return StoryPreview;
}(PureComponent);

defineProperty(StoryPreview, "propTypes", {
  autoPlay: PropTypes.bool,
  hasWatched: PropTypes.bool,
  rendition: PropTypes.string,
  hideIcons: PropTypes.bool,
  timestampText: PropTypes.string,
  showUsername: PropTypes.bool,
  onClick: PropTypes.func,
  width: PropTypes.number,
  height: PropTypes.number,
  story: PropTypes.object
});

var Editable = styled.textarea(templateObject_1$7 || (templateObject_1$7 = __makeTemplateObject(["\n    background: transparent;\n    border: 0;\n    outline: none;\n    cursor: text;\n    position: relative;\n    font: inherit;\n    color: inherit;\n    opacity: ", ";\n    line-height: inherit;\n    padding: 0;\n    margin: 0;\n    height: 100%;\n    width: 100%;\n    resize: none;\n    -webkit-appearance: none;\n"], ["\n    background: transparent;\n    border: 0;\n    outline: none;\n    cursor: text;\n    position: relative;\n    font: inherit;\n    color: inherit;\n    opacity: ", ";\n    line-height: inherit;\n    padding: 0;\n    margin: 0;\n    height: 100%;\n    width: 100%;\n    resize: none;\n    -webkit-appearance: none;\n"])), function (props) { return (props.isHidden ? 0 : 1); });
var templateObject_1$7;

var RULES = [
    { regex: /<[^>]+>/g, replacement: '' },
    { regex: /\[([^[]+)\]\(([^)]+)\)/g, replacement: "<a href='$2' target='_blank' rel='noopener noreferrer'>$1</a>" },
    { regex: /(\*\*|__)(.*?)\1/g, replacement: '<strong>$2</strong>' },
    { regex: /(\*|_)(.*?)\1/g, replacement: '<em>$2</em>' },
];
var div = document.createElement('div');
function markdownToHtml (text) {
    var html = text;
    RULES.forEach(function (_a) {
        var regex = _a.regex, replacement = _a.replacement;
        html = html.replace(regex, replacement);
    });
    div.innerHTML = html.trim();
    return {
        html: html.trim(),
        length: div.innerText.trim().length,
    };
}

var MIN_HEIGHT = 20;
var ContainerDiv = styled.div(templateObject_1$8 || (templateObject_1$8 = __makeTemplateObject(["\n    box-sizing: content-box;\n    font-size: inherit;\n    line-height: inherit;\n    position: relative;\n"], ["\n    box-sizing: content-box;\n    font-size: inherit;\n    line-height: inherit;\n    position: relative;\n"])));
var Markdown = styled.div(templateObject_2$5 || (templateObject_2$5 = __makeTemplateObject(["\n    height: 100%;\n    left: 0;\n    line-height: inherit;\n    opacity: ", ";\n    margin: 0;\n    padding: 0;\n    pointer-events: ", ";\n    position: absolute;\n    top: 0;\n    width: 100%;\n"], ["\n    height: 100%;\n    left: 0;\n    line-height: inherit;\n    opacity: ", ";\n    margin: 0;\n    padding: 0;\n    pointer-events: ", ";\n    position: absolute;\n    top: 0;\n    width: 100%;\n"])), function (props) { return (props.isHidden ? 0 : 1); }, function (props) { return (props.isHidden ? 'none' : 'auto'); });
var EditableTextfield = /** @class */ (function (_super) {
    __extends(EditableTextfield, _super);
    function EditableTextfield() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.state = {
            focused: false,
            rawText: '',
            textHeight: MIN_HEIGHT,
        };
        _this.onInput = function (e) {
            e.preventDefault();
            _this.setState({ rawText: e.target.value }, function () {
                _this.updateSize();
                _this.updateCharacterCount();
                _this.props.onChange && _this.props.onChange(_this.state.rawText, _this.props.fieldType);
            });
        };
        _this.onFocus = function () {
            _this.rawField.focus();
            _this.setState({ focused: true });
            _this.props.onFocus && _this.props.onFocus();
        };
        _this.onBlur = function () {
            _this.setState({
                focused: false,
            });
            _this.props.onBlur && _this.props.onBlur();
        };
        return _this;
    }
    EditableTextfield.prototype.componentDidMount = function () {
        this.updateText();
    };
    EditableTextfield.prototype.componentDidUpdate = function (prevProps, prevState) {
        var _this = this;
        var text = this.props.text;
        var focused = this.state.focused;
        if (prevState.focused !== focused) {
            this.updateText();
        }
        if (text !== prevProps.text) {
            this.setState({
                rawText: text,
            }, function () {
                _this.updateSize();
            });
        }
    };
    EditableTextfield.prototype.updateSize = function () {
        this.rawField.style.height = '0px';
        this.setState({
            textHeight: this.rawField.scrollHeight,
        });
        this.rawField.style.height = '';
    };
    EditableTextfield.prototype.updateText = function () {
        var supportMarkdown = this.props.supportMarkdown;
        var rawText = this.state.rawText;
        supportMarkdown
            ? (this.markdownField.innerHTML = markdownToHtml(rawText).html)
            : (this.markdownField.innerText = rawText);
        this.updateSize();
        this.updateCharacterCount();
    };
    EditableTextfield.prototype.updateCharacterCount = function () {
        var _a = this.props, maxCharacters = _a.maxCharacters, supportMarkdown = _a.supportMarkdown, onCharacterCount = _a.onCharacterCount;
        var rawText = this.state.rawText;
        if (onCharacterCount) {
            var length_1 = (supportMarkdown ? markdownToHtml(rawText) : rawText).length;
            onCharacterCount(length_1, (maxCharacters && length_1) > maxCharacters);
        }
    };
    EditableTextfield.prototype.render = function () {
        var _this = this;
        var _a = this.props, placeholder = _a.placeholder, text = _a.text;
        var _b = this.state, focused = _b.focused, rawText = _b.rawText, textHeight = _b.textHeight;
        var showMarkdown = !isEmpty$1(rawText) && !focused;
        return (React.createElement(ContainerDiv, { focused: focused, rawText: rawText, style: { height: Math.max(MIN_HEIGHT, textHeight) } },
            React.createElement(Editable, { isHidden: showMarkdown, onBlur: this.onBlur, onChange: this.onInput, onFocus: this.onFocus, placeholder: placeholder, ref: function (c) { return (_this.rawField = c); }, defaultValue: rawText || text }),
            React.createElement(Markdown, { isHidden: !showMarkdown, onClick: this.onFocus, ref: function (c) { return (_this.markdownField = c); } })));
    };
    EditableTextfield.defaultProps = {
        placeholder: '',
        text: '',
        supportMarkdown: false,
    };
    return EditableTextfield;
}(PureComponent));
var templateObject_1$8, templateObject_2$5;

function _templateObject5$4() {
  var data = taggedTemplateLiteral(["\n    padding: 25px;\n"]);

  _templateObject5$4 = function _templateObject5() {
    return data;
  };

  return data;
}

function _templateObject4$6() {
  var data = taggedTemplateLiteral(["\n    height: 100%;\n    left: 0;\n    position: fixed;\n    top: 0;\n    width: 100%;\n    z-index: 2147483645;\n"]);

  _templateObject4$6 = function _templateObject4() {
    return data;
  };

  return data;
}

function _templateObject3$a() {
  var data = taggedTemplateLiteral(["\n    position: absolute;\n    bottom: ", ";\n    right: -31px;\n"]);

  _templateObject3$a = function _templateObject3() {
    return data;
  };

  return data;
}

function _templateObject2$k() {
  var data = taggedTemplateLiteral(["\n    cursor: ", ";\n    display: inline-block;\n    font-size: 16px;\n    padding-top: 10px;\n    transform: rotate(-90deg);\n"]);

  _templateObject2$k = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject$v() {
  var data = taggedTemplateLiteral(["\n    box-sizing: border-box;\n    font-weight: normal;\n    padding-right: 10px;\n    position: relative;\n    width: 20px;\n    height: 20px;\n"]);

  _templateObject$v = function _templateObject() {
    return data;
  };

  return data;
}
var Container$k = styled.div(_templateObject$v());
var Ellipsis = styled.span(_templateObject2$k(), function (props) {
  return props.isHover ? 'default' : 'pointer';
});
var DropdownContainer$2 = styled.div(_templateObject3$a(), function (props) {
  return props.extendUp ? '-3px' : '-163px';
});
var DropdownOverlay = styled.div(_templateObject4$6());
var DropdownHoverArea = styled.div(_templateObject5$4());

var EditableTextfield$1 =
/*#__PURE__*/
function (_PureComponent) {
  inherits(EditableTextfield, _PureComponent);

  function EditableTextfield(props) {
    var _this;

    classCallCheck(this, EditableTextfield);

    _this = possibleConstructorReturn(this, getPrototypeOf(EditableTextfield).call(this, props));
    _this.state = {
      isOpen: false,
      extendUp: false
    };
    return _this;
  }

  createClass(EditableTextfield, [{
    key: "popUpOrDown",
    value: function popUpOrDown(e) {
      return e.pageY > window.innerHeight / 2;
    }
  }, {
    key: "handleHover",
    value: function handleHover(e) {
      if (this.popUpOrDown(e)) {
        this.setState({
          isOpen: true,
          extendUp: true
        });
      } else {
        this.setState({
          isOpen: true,
          extendUp: false
        });
      }
    }
  }, {
    key: "handleClick",
    value: function handleClick(e) {
      var isOpen = this.state.isOpen;

      if (this.popUpOrDown(e)) {
        this.setState({
          isOpen: !isOpen,
          extendUp: true
        });
      } else {
        this.setState({
          isOpen: !isOpen,
          extendUp: false
        });
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;

      var _this$props = this.props,
          children = _this$props.children,
          isDark = _this$props.isDark,
          isHover = _this$props.isHover,
          extendDirectionUp = _this$props.extendDirectionUp;
      var _this$state = this.state,
          isOpen = _this$state.isOpen,
          extendUp = _this$state.extendUp;
      var extendDirection = typeof extendDirectionUp !== 'undefined' ? extendDirectionUp : extendUp;
      return isHover ? React.createElement(Container$k, {
        onMouseEnter: function onMouseEnter(e) {
          return _this2.handleHover(e);
        },
        onMouseLeave: function onMouseLeave() {
          return _this2.setState({
            isOpen: false
          });
        }
      }, React.createElement(Ellipsis, {
        className: 'ss-ellipsis'
      }), isOpen && React.createElement(DropdownContainer$2, {
        extendUp: extendDirection
      }, React.createElement(DropdownHoverArea, null, React.createElement(Dropdown, {
        isDark: isDark,
        isExtendUp: extendDirection,
        nipX: 'calc(100% - 15px)'
      }, children)))) : React.createElement(Container$k, null, React.createElement(Ellipsis, {
        className: 'ss-ellipsis',
        onClick: function onClick(e) {
          return _this2.handleClick(e);
        }
      }), isOpen && React.createElement(DropdownContainer$2, {
        extendUp: extendDirection
      }, React.createElement(DropdownOverlay, {
        onClick: function onClick() {
          return _this2.setState({
            isOpen: false
          });
        }
      }), React.createElement(Dropdown, {
        isDark: isDark,
        isExtendUp: extendDirection,
        nipX: 'calc(100% - 15px)'
      }, children)));
    }
  }]);

  return EditableTextfield;
}(PureComponent);

defineProperty(EditableTextfield$1, "propTypes", {
  isHorizontal: PropTypes.bool,
  isDark: PropTypes.bool,
  isHover: PropTypes.bool,
  forceExpandDirection: PropTypes.bool
});

defineProperty(EditableTextfield$1, "defaultProps", {
  isHorizontal: false,
  isDark: false,
  isHover: true
});

function _templateObject2$l() {
  var data = taggedTemplateLiteral(["\n    bottom: 100%;\n    margin-bottom: 2px;\n    position: absolute;\n    right: 0;\n"]);

  _templateObject2$l = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject$w() {
  var data = taggedTemplateLiteral(["\n    cursor: pointer;\n    display: inline-block;\n    flex-shrink: 0;\n    font-size: 16px;\n    padding: 10px;\n    position: relative;\n    vertical-align: middle;\n"]);

  _templateObject$w = function _templateObject() {
    return data;
  };

  return data;
}
var Icon$2 = styled.div(_templateObject$w());
var DropdownWrapper = styled.div(_templateObject2$l());

var IconTooltip =
/*#__PURE__*/
function (_PureComponent) {
  inherits(IconTooltip, _PureComponent);

  function IconTooltip() {
    var _getPrototypeOf2;

    var _this;

    classCallCheck(this, IconTooltip);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = possibleConstructorReturn(this, (_getPrototypeOf2 = getPrototypeOf(IconTooltip)).call.apply(_getPrototypeOf2, [this].concat(args)));

    defineProperty(assertThisInitialized(_this), "state", {
      isHover: false
    });

    defineProperty(assertThisInitialized(_this), "hideTooltip", function () {
      return _this.setState({
        isHover: false
      });
    });

    defineProperty(assertThisInitialized(_this), "showTooltip", function () {
      IconTooltip.hideToolTips(); // let hide callback propogate

      setTimeout(function () {
        return _this.setState({
          isHover: true
        });
      }, 0);
    });

    defineProperty(assertThisInitialized(_this), "toggleTooltip", function () {
      var isHover = !_this.state.isHover;

      if (isHover) {
        _this.showTooltip();
      } else {
        _this.hideTooltip();
      }
    });

    return _this;
  }

  createClass(IconTooltip, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      var show = this.props.show;

      if (show) {
        this.showTooltip();
      }

      onHideCallbacks.push(this.hideTooltip);
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      pull_1(onHideCallbacks, this.hideTooltip);
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props = this.props,
          children = _this$props.children,
          icon = _this$props.icon,
          _this$props$className = _this$props.className,
          className = _this$props$className === void 0 ? "" : _this$props$className,
          color = _this$props.color;
      var isHover = this.state.isHover;
      return React.createElement(Icon$2, {
        className: icon + ' ' + className,
        onMouseOut: this.hideTooltip,
        onMouseOver: this.showTooltip,
        onTouchStart: this.toggleTooltip,
        style: {
          color: color
        }
      }, isHover && React.createElement(DropdownWrapper, null, React.createElement(Dropdown, {
        isExtendUp: true,
        nipX: "calc(100% - 18px)"
      }, children)));
    }
  }]);

  return IconTooltip;
}(PureComponent);

defineProperty(IconTooltip, "propTypes", {
  icon: PropTypes.string,
  color: PropTypes.string
});

defineProperty(IconTooltip, "hideToolTips", function () {
  return onHideCallbacks.forEach(function (cb) {
    return cb();
  });
});

defineProperty(IconTooltip, "defaultProps", {
  icon: 'ss-info',
  color: 'rgba(255, 255, 255, 0.7)'
});

function _templateObject5$5() {
  var data = taggedTemplateLiteral(["\n    height: 100%;\n    width: 100%;\n    padding: 5px;\n    padding-left: 12px;\n    box-sizing: border-box;\n    border-radius: 0;\n    border: ", ";\n    &:-webkit-autofill {\n        animation: ", " 0.1s linear;\n    }\n    &:not(:-webkit-autofill) {\n        animation: ", " 0.1s linear;\n    }\n"]);

  _templateObject5$5 = function _templateObject5() {
    return data;
  };

  return data;
}

function _templateObject4$7() {
  var data = taggedTemplateLiteral(["\n    font-size: 12px;\n    position: absolute;\n    top: 0;\n    right: 6px;\n"]);

  _templateObject4$7 = function _templateObject4() {
    return data;
  };

  return data;
}

function _templateObject3$b() {
  var data = taggedTemplateLiteral(["\n    font-size: 12px;\n    line-height: 14px;\n    font-weight: 400;\n    color: ", ";\n    background-color: transparent;\n    text-align: center;\n    z-index: 1;\n    position: absolute;\n    height: 95%;\n    width: 75px;\n    top: 3px;\n    right: 6px;\n    pointer-events: none;\n"]);

  _templateObject3$b = function _templateObject3() {
    return data;
  };

  return data;
}

function _templateObject2$m() {
  var data = taggedTemplateLiteral(["\n    margin: 0;\n    position: absolute;\n    top: 50%;\n    left: 50%;\n    margin-right: -50%;\n    transform: translate(-50%, -50%);\n"]);

  _templateObject2$m = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject$x() {
  var data = taggedTemplateLiteral(["\n    height: 40px;\n    width: 100%;\n    margin: 12px 0;\n    position: relative;\n    display: flex;\n"]);

  _templateObject$x = function _templateObject() {
    return data;
  };

  return data;
}
var autofill = keyframes(["0%{opacity:.999;}100%{opacity:1;}"]);
var autofillCancel = keyframes(["0%{opacity:.999;}100%{opacity:1;}"]);
var object = PropTypes.object,
    string$1 = PropTypes.string,
    bool$1 = PropTypes.bool;
var Wrapper$5 = styled.div(_templateObject$x());
var ErrorMessage = styled.div(_templateObject2$m());
var ErrorContainer = styled.div(_templateObject3$b(), errorColor);
var ErrorToolTipContainer = styled.div(_templateObject4$7());
var InputStyled = styled.input(_templateObject5$5(), function (props) {
  return props.isError ? "3px solid ".concat(errorColor) : 0;
}, autofill, autofillCancel);
/**
 * Wraps an input and shows error messages
 */

var Input =
/*#__PURE__*/
function (_PureComponent) {
  inherits(Input, _PureComponent);

  function Input() {
    var _getPrototypeOf2;

    var _this;

    classCallCheck(this, Input);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = possibleConstructorReturn(this, (_getPrototypeOf2 = getPrototypeOf(Input)).call.apply(_getPrototypeOf2, [this].concat(args)));

    defineProperty(assertThisInitialized(_this), "checkValue", function (_ref) {
      var animationName = _ref.animationName;
      var _this$props = _this.props,
          onAutoFill = _this$props.onAutoFill,
          onAutoFillCancel = _this$props.onAutoFillCancel;

      if (animationName === autofill && onAutoFill) {
        onAutoFill();
      } else if (animationName === autofillCancel && onAutoFillCancel) {
        onAutoFillCancel();
      }
    });

    return _this;
  }

  createClass(Input, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      var _this$props2 = this.props,
          autoFocus = _this$props2.autoFocus,
          initialValue = _this$props2.initialValue;

      if (autoFocus) {
        this.input.focus();
      }

      if (initialValue) {
        this.input.value = initialValue;
      }

      this.input.addEventListener('animationstart', this.checkValue, false);
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      this.input.removeEventListener('animationstart', this.checkValue, false);
    }
  }, {
    key: "blur",
    value: function blur() {
      this.input.blur();
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;

      var _this$props3 = this.props,
          errorMessage = _this$props3.errorMessage,
          errorTooltip = _this$props3.errorTooltip,
          inputProps = _this$props3.inputProps,
          className = _this$props3.className;
      return React.createElement(Wrapper$5, {
        className: className
      }, React.createElement(InputStyled, _extends_1({}, inputProps, {
        isError: !!errorMessage,
        ref: function ref(c) {
          return _this2.input = c;
        }
      })), errorTooltip && errorMessage ? React.createElement(ErrorToolTipContainer, null, React.createElement(IconTooltip, {
        color: errorColor,
        icon: "ss-alert",
        show: true
      }, errorMessage)) : React.createElement(ErrorContainer, null, React.createElement(ErrorMessage, null, errorMessage)));
    }
  }]);

  return Input;
}(PureComponent);

defineProperty(Input, "propTypes", {
  initialValue: string$1,
  // passed to input element
  inputProps: object.isRequired,
  // when defined, highlights the input and shows the message
  // in the top right corner
  errorMessage: string$1,
  // will auto focus
  autoFocus: bool$1
});

function _templateObject3$c() {
  var data = taggedTemplateLiteral(["\n    bottom: 100%;\n    left: -10px;\n    line-height: 1.3;\n    margin-bottom: 5px;\n    position: absolute;\n"]);

  _templateObject3$c = function _templateObject3() {
    return data;
  };

  return data;
}

function _templateObject2$n() {
  var data = taggedTemplateLiteral(["\n    background: rgba(33, 33, 33, 0.8);\n    color: ", ";\n    height: 100%;\n    font-size: 16px;\n    left: 0;\n    line-height: ", "px;\n    position: absolute;\n    text-align: center;\n    top: 0;\n    width: 100%;\n"]);

  _templateObject2$n = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject$y() {
  var data = taggedTemplateLiteral(["\n    flex-shrink: 0;\n    height: ", "px;\n    margin-right: 15px;\n    position: relative;\n    width: ", "px;\n"]);

  _templateObject$y = function _templateObject() {
    return data;
  };

  return data;
}
var CoverGif = styled.div(_templateObject$y(), function (props) {
  return props.size;
}, function (props) {
  return props.size;
});
var GifIcon = styled.div(_templateObject2$n(), function (props) {
  return props.color;
}, function (props) {
  return props.size + 2;
});
var Tooltip$2 = styled.div(_templateObject3$c());

var StoryItemGif =
/*#__PURE__*/
function (_PureComponent) {
  inherits(StoryItemGif, _PureComponent);

  function StoryItemGif() {
    var _getPrototypeOf2;

    var _this;

    classCallCheck(this, StoryItemGif);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = possibleConstructorReturn(this, (_getPrototypeOf2 = getPrototypeOf(StoryItemGif)).call.apply(_getPrototypeOf2, [this].concat(args)));

    defineProperty(assertThisInitialized(_this), "state", {
      showDropdown: false
    });

    defineProperty(assertThisInitialized(_this), "onMouseOver", function () {
      _this.setState({
        showDropdown: true
      });
    });

    defineProperty(assertThisInitialized(_this), "onMouseOut", function () {
      _this.setState({
        showDropdown: false
      });
    });

    return _this;
  }

  createClass(StoryItemGif, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
          size = _this$props.size,
          story = _this$props.story,
          onLoad = _this$props.onLoad,
          onUnload = _this$props.onUnload;
      var showDropdown = this.state.showDropdown;
      var cover_gif = story.cover_gif,
          publishDateTime = story.publish_datetime,
          isPrivate = story.is_private;

      var _getIconData = getIconData({
        publishDateTime: publishDateTime,
        isPrivate: isPrivate
      }),
          color = _getIconData.color,
          message = _getIconData.message,
          icon = _getIconData.icon;

      return React.createElement(CoverGif, {
        size: size
      }, React.createElement(Media, {
        gif: cover_gif.gif,
        height: size,
        onLoad: onLoad,
        onUnload: onUnload,
        width: size
      }), icon && React.createElement(GifIcon, {
        className: icon,
        color: color,
        onMouseOut: this.onMouseOut,
        onMouseOver: this.onMouseOver,
        size: size
      }), message && showDropdown && React.createElement(Tooltip$2, null, React.createElement(Dropdown, {
        isExtendUp: true,
        nipX: "35px"
      }, message)));
    }
  }]);

  return StoryItemGif;
}(PureComponent);

defineProperty(StoryItemGif, "propTypes", {
  story: PropTypes.object.isRequired,
  size: PropTypes.number.isRequired,
  onLoad: PropTypes.func,
  onUnload: PropTypes.func
});

var checkIfToday = function checkIfToday(date) {
  var today = new Date();
  return today.getDate() === date.getDate() && today.getMonth() === date.getMonth() && today.getFullYear() === date.getFullYear();
};
var checkIfYesterday = function checkIfYesterday(date) {
  var yesterday = new Date();
  yesterday.setDate(yesterday.getDate() - 1);
  return yesterday.getDate() === date.getDate() && yesterday.getMonth() === date.getMonth() && yesterday.getFullYear() === date.getFullYear();
};

function _templateObject2$o() {
  var data = taggedTemplateLiteral(["\n    flex-shrink: 0;\n    margin-right: auto;\n"]);

  _templateObject2$o = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject$z() {
  var data = taggedTemplateLiteral(["\n    color: ", ";\n    display: block;\n    font-weight: bold;\n    margin-right: 7px;\n    overflow: hidden;\n    text-decoration: none;\n    text-overflow: ellipsis;\n    white-space: nowrap;\n\n    &:hover {\n        color: ", ";\n    }\n"]);

  _templateObject$z = function _templateObject() {
    return data;
  };

  return data;
}

var getCreationDate$1 = function getCreationDate(publishDateTime) {
  var now = new Date();
  var publishDate = new Date(publishDateTime);
  var timeDiff = now.getTime() - publishDate.getTime();
  var isToday = checkIfToday(publishDate);
  var isYesterday = checkIfYesterday(publishDate);
  var isFuture = timeDiff < 0;

  if (isFuture) {
    return format(publishDate, 'dddd, MMMM D, h A');
  }

  if (Math.abs(timeDiff) < 60 * 60 * 1000) {
    return 'Just now';
  }

  if (isToday) {
    return distanceInWordsToNow(publishDate, {
      addSuffix: true
    }).replace('about', '');
  }

  if (isYesterday) {
    return "Yesterday, ".concat(format(publishDate, 'h A'));
  }

  return format(publishDate, 'dddd, MMMM D, h A');
};

var TitleText = styled.a(_templateObject$z(), giphyWhite, giphyWhite);
var DateText = styled.span(_templateObject2$o());

var StoryItemTitle = function StoryItemTitle(_ref) {
  var _ref$story = _ref.story,
      story = _ref$story === void 0 ? {} : _ref$story;
  var title = story.title,
      publishDateTime = story.publish_datetime,
      slug = story.slug;
  return React.createElement(React.Fragment, null, React.createElement(TitleText, {
    href: "/stories/".concat(slug),
    rel: "noopener noreferrer",
    target: "_blank"
  }, title), React.createElement(DateText, null, getCreationDate$1(publishDateTime)));
};

function _templateObject3$d() {
  var data = taggedTemplateLiteral(["\n    background: no-repeat url(", ") center center;\n    background-size: cover;\n    border-radius: 50%;\n    height: 30px;\n    width: 30px;\n"]);

  _templateObject3$d = function _templateObject3() {
    return data;
  };

  return data;
}

function _templateObject2$p() {
  var data = taggedTemplateLiteral(["\n    margin-right: 10px;\n\n    &:before {\n        content: '@';\n    }\n"]);

  _templateObject2$p = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject$A() {
  var data = taggedTemplateLiteral(["\n    align-items: center;\n    color: ", ";\n    display: flex;\n    flex-shrink: 0;\n    height: 100%;\n    padding: 0 ", " 0 15px;\n    text-decoration: none;\n\n    &:hover {\n        color: ", ";\n    }\n"]);

  _templateObject$A = function _templateObject() {
    return data;
  };

  return data;
}

var getSmallAvatar$1 = function getSmallAvatar(avatar) {
  if (!avatar) return '';
  var ext = avatar.split('.').pop().toLowerCase();
  return avatar.replace(".".concat(ext), "/80h.".concat(ext));
};

var Container$l = styled.a(_templateObject$A(), giphyLightGrey, function (props) {
  return props.hasMenu ? 0 : "15px";
}, giphyLightGrey);
var Username$1 = styled.span(_templateObject2$p());
var Avatar$1 = styled.div(_templateObject3$d(), function (props) {
  return getSmallAvatar$1(props.url);
});

var StoryItemAttribution = function StoryItemAttribution(_ref) {
  var _ref$story = _ref.story,
      story = _ref$story === void 0 ? {} : _ref$story,
      _ref$hasMenu = _ref.hasMenu,
      hasMenu = _ref$hasMenu === void 0 ? true : _ref$hasMenu;
  var user = story.user;
  return user ? React.createElement(Container$l, {
    hasMenu: hasMenu,
    href: user.profile_url,
    rel: "noopener noreferrer",
    target: "_blank"
  }, React.createElement(Username$1, null, user.username), React.createElement(Avatar$1, {
    url: user.avatar || user.avatar_url
  })) : null;
};

function _templateObject3$e() {
  var data = taggedTemplateLiteral(["\n    cursor: pointer;\n    ", "\n"]);

  _templateObject3$e = function _templateObject3() {
    return data;
  };

  return data;
}

function _templateObject2$q() {
  var data = taggedTemplateLiteral(["\n    ", "\n"]);

  _templateObject2$q = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject$B() {
  var data = taggedTemplateLiteral(["\n    color: ", ";\n    height: 100%;\n    line-height: 42px;\n    padding: 0 10px;\n"]);

  _templateObject$B = function _templateObject() {
    return data;
  };

  return data;
}
var Container$m = styled.div(_templateObject$B(), giphyWhite);
var linkStyles = "\ncolor: ".concat(giphyLightCharcoal, ";\ndisplay: block;\nline-height: 30px;\ntext-decoration: none;\n\n&:hover {\n    color: ").concat(giphyLightCharcoal, ";\n}\n");
var Link$1 = styled.a(_templateObject2$q(), linkStyles);
var LinkDiv = styled.div(_templateObject3$e(), linkStyles);

var StoryItemMenu = function StoryItemMenu(_ref) {
  var _ref$story = _ref.story,
      story = _ref$story === void 0 ? {} : _ref$story,
      onEditStory = _ref.onEditStory,
      onRemoveStory = _ref.onRemoveStory,
      onPrivacyClick = _ref.onPrivacyClick;
  var slug = story.slug,
      story_id = story.story_id,
      isPrivate = story.is_private;

  var onClickLinkDiv = function onClickLinkDiv() {
    return onPrivacyClick(story);
  };

  return React.createElement(Container$m, null, React.createElement(EditableTextfield$1, {
    extendDirectionUp: true,
    isDark: true
  }, React.createElement(React.Fragment, null, React.createElement(Link$1, {
    href: "/stories/".concat(slug),
    rel: "noopener noreferrer",
    target: "_blank"
  }, "Open story"), React.createElement(Link$1, {
    href: "/create/story/finalize/".concat(story_id),
    onClick: function onClick() {
      return onEditStory(story);
    },
    target: "_blank"
  }, "Edit story"), React.createElement(LinkDiv, {
    onClick: onClickLinkDiv
  }, isPrivate ? 'Make Story Public' : 'Make Story Private'), React.createElement(Link$1, {
    href: "#",
    onClick: function onClick() {
      return onRemoveStory(story);
    }
  }, "Remove story"))));
};

function _templateObject3$f() {
  var data = taggedTemplateLiteral(["\n    background: no-repeat url('https://media.giphy.com/media/l41K1gfrUz1HDohvG/giphy.gif') left top;\n    background-size: contain;\n    height: 70px;\n    left: -15px;\n    position: absolute;\n    top: -18px;\n    width: 70px;\n"]);

  _templateObject3$f = function _templateObject3() {
    return data;
  };

  return data;
}

function _templateObject2$r() {
  var data = taggedTemplateLiteral(["\n    background: linear-gradient(to right, ", ", ", ");\n    height: 100%;\n    left: 0;\n    pointer-events: none;\n    position: absolute;\n    top: 0;\n    width: 100%;\n"]);

  _templateObject2$r = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject$C() {
  var data = taggedTemplateLiteral(["\n    animation: ", " 0.3s ease-out 1 reverse, ", " 0.5s ease-out ", "ms 1 normal backwards;\n    opacity: 0;\n    pointer-events: none;\n"]);

  _templateObject$C = function _templateObject() {
    return data;
  };

  return data;
}
var DELAY = 5000;
var fadeOut = keyframes(["0%{opacity:1;}100%{opacity:0;}"]);
var NewBase = styled.div(_templateObject$C(), fadeOut, fadeOut, DELAY);
var Background = styled(NewBase)(_templateObject2$r(), function (props) {
  return props.secondaryColor;
}, function (props) {
  return props.primaryColor;
});
var Peeker = styled(NewBase)(_templateObject3$f());

function _templateObject2$s() {
  var data = taggedTemplateLiteral(["\n    display: flex;\n    height: 100%;\n    position: relative;\n    width: 100%;\n"]);

  _templateObject2$s = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject$D() {
  var data = taggedTemplateLiteral(["\n    align-items: center;\n    background: ", ";\n    border-right: 5px solid ", ";\n    box-sizing: border-box;\n    color: ", ";\n    font-size: 16px;\n    height: ", "px;\n    line-height: ", "px;\n    margin-bottom: 6px;\n    position: relative;\n    width: 100%;\n"]);

  _templateObject$D = function _templateObject() {
    return data;
  };

  return data;
}
var ITEM_SIZE = 50;
var Container$n = styled.div(_templateObject$D(), giphyDarkestGrey, function (props) {
  return props.color;
}, giphyLightGrey, ITEM_SIZE, ITEM_SIZE);
var Wrapper$6 = styled.div(_templateObject2$s());

var StoryListItem =
/*#__PURE__*/
function (_PureComponent) {
  inherits(StoryListItem, _PureComponent);

  function StoryListItem() {
    var _getPrototypeOf2;

    var _this;

    classCallCheck(this, StoryListItem);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = possibleConstructorReturn(this, (_getPrototypeOf2 = getPrototypeOf(StoryListItem)).call.apply(_getPrototypeOf2, [this].concat(args)));

    defineProperty(assertThisInitialized(_this), "state", {
      showNewStuff: false,
      isCoverGifLoaded: false
    });

    defineProperty(assertThisInitialized(_this), "onCoverGifLoad", function () {
      _this.setState({
        isCoverGifLoaded: true
      });
    });

    defineProperty(assertThisInitialized(_this), "onCoverGifUnload", function () {
      _this.setState({
        isCoverGifLoaded: false
      });
    });

    return _this;
  }

  createClass(StoryListItem, [{
    key: "componentDidUpdate",
    value: function componentDidUpdate(_ref, _ref2) {
      var prevIsNew = _ref.isNew;
      var prevIsCoverGifLoaded = _ref2.isCoverGifLoaded;
      var isNew = this.props.isNew;
      var _this$state = this.state,
          isCoverGifLoaded = _this$state.isCoverGifLoaded,
          showNewStuff = _this$state.showNewStuff;

      if (isNew !== prevIsNew || isCoverGifLoaded !== prevIsCoverGifLoaded) {
        this.setState({
          showNewStuff: showNewStuff || isNew && isCoverGifLoaded
        });
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props = this.props,
          story = _this$props.story,
          showMenu = _this$props.showMenu,
          isNew = _this$props.isNew,
          onEditStory = _this$props.onEditStory,
          onRemoveStory = _this$props.onRemoveStory,
          onPrivacyClick = _this$props.onPrivacyClick;
      var showNewStuff = this.state.showNewStuff;
      var color = story.color,
          secondaryColor = story.secondary_color;
      return React.createElement(Container$n, {
        color: color,
        isNew: isNew
      }, showNewStuff && React.createElement(Background, {
        primaryColor: color,
        secondaryColor: secondaryColor
      }), React.createElement(Wrapper$6, null, React.createElement(StoryItemGif, {
        onLoad: this.onCoverGifLoad,
        onUnload: this.onCoverGifUnload,
        size: ITEM_SIZE,
        story: story
      }), React.createElement(StoryItemTitle, {
        story: story
      }), React.createElement(StoryItemAttribution, {
        hasMenu: showMenu,
        story: story
      }), showMenu && React.createElement(StoryItemMenu, {
        onEditStory: onEditStory,
        onPrivacyClick: onPrivacyClick,
        onRemoveStory: onRemoveStory,
        story: story
      })), showNewStuff && React.createElement(Peeker, null));
    }
  }]);

  return StoryListItem;
}(PureComponent);

defineProperty(StoryListItem, "propTypes", {
  story: PropTypes.object.isRequired,
  showMenu: PropTypes.bool,
  isNew: PropTypes.bool,
  onEditStory: PropTypes.func,
  onRemoveStory: PropTypes.func,
  onPrivacyClick: PropTypes.func
});

defineProperty(StoryListItem, "defaultProps", {
  isNew: false,
  showMenu: false
});

function _templateObject2$t() {
  var data = taggedTemplateLiteral(["\n    background: ", ";\n    display: inline-block;\n    position: relative;\n    vertical-align: top;\n    page-break-inside: avoid;\n    break-inside: avoid;\n"]);

  _templateObject2$t = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject$E() {
  var data = taggedTemplateLiteral(["\n    cursor: pointer;\n    display: inline-block;\n    line-height: ", "px;\n    position: relative;\n    text-align: center;\n    vertical-align: top;\n    width: ", "px;\n    height: ", "px;\n    transition: color 0.2s ease-in-out 0.2s;\n    color: ", ";\n    i {\n        font-size: 8px;\n        top: -1px;\n        position: relative;\n    }\n"]);

  _templateObject$E = function _templateObject() {
    return data;
  };

  return data;
}
var ToggleBackground = styled.div(function (_ref) {
  var _ref$theme = _ref.theme,
      isOn = _ref$theme.isOn,
      height = _ref$theme.height,
      width = _ref$theme.width,
      _ref$theme$onColor = _ref$theme.onColor,
      onColor = _ref$theme$onColor === void 0 ? giphyGreen : _ref$theme$onColor,
      _ref$theme$offColor = _ref$theme.offColor,
      offColor = _ref$theme$offColor === void 0 ? giphyRed : _ref$theme$offColor;
  return css$6(["position:absolute;top:0;transition:all 0.5s cubic-bezier(0.68,-0.55,0.265,1.55);background-color:", ";height:", "px;width:", "px;left:", "px;"], isOn ? onColor : offColor, height, width / 2, isOn ? 0 : width / 2);
});
var Icon$3 = styled.div(_templateObject$E(), function (props) {
  return props.theme.height;
}, function (props) {
  return props.theme.width / 2;
}, function (props) {
  return props.theme.height;
}, function (props) {
  return props.isOn ? giphyDarkGrey : giphyWhite;
});
var Container$o = styled.div(_templateObject2$t(), giphyDarkGrey);
var bool$2 = PropTypes.bool,
    func$1 = PropTypes.func,
    element = PropTypes.element,
    string$2 = PropTypes.string,
    number$1 = PropTypes.number;

var Toggle =
/*#__PURE__*/
function (_PureComponent) {
  inherits(Toggle, _PureComponent);

  function Toggle() {
    var _getPrototypeOf2;

    var _this;

    classCallCheck(this, Toggle);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = possibleConstructorReturn(this, (_getPrototypeOf2 = getPrototypeOf(Toggle)).call.apply(_getPrototypeOf2, [this].concat(args)));

    defineProperty(assertThisInitialized(_this), "toggle", function () {
      var _this$props = _this.props,
          toggle = _this$props.toggle,
          isOn = _this$props.isOn;
      toggle(isOn);
    });

    return _this;
  }

  createClass(Toggle, [{
    key: "render",
    value: function render() {
      var _this$props2 = this.props,
          isOn = _this$props2.isOn,
          onElement = _this$props2.onElement,
          offElement = _this$props2.offElement,
          onColor = _this$props2.onColor,
          offColor = _this$props2.offColor,
          _this$props2$height = _this$props2.height,
          height = _this$props2$height === void 0 ? 25 : _this$props2$height,
          _this$props2$width = _this$props2.width,
          width = _this$props2$width === void 0 ? 50 : _this$props2$width,
          className = _this$props2.className;
      return React.createElement(ThemeProvider, {
        theme: {
          width: width,
          height: height,
          isOn: isOn,
          onColor: onColor,
          offColor: offColor
        }
      }, React.createElement(Container$o, {
        className: className,
        onClick: this.toggle
      }, React.createElement(ToggleBackground, null), React.createElement(Icon$3, {
        isOn: isOn
      }, onElement), React.createElement(Icon$3, {
        isOn: !isOn
      }, offElement)));
    }
  }]);

  return Toggle;
}(PureComponent);

defineProperty(Toggle, "propTypes", {
  toggle: func$1.isRequired,
  isOn: bool$2.isRequired,
  backgroundColor: string$2,
  onColor: string$2,
  offColor: string$2,
  onElement: element,
  offElement: element,
  height: number$1,
  width: number$1,
  className: string$2
});

var isMobile$1 = mobileCheck();

var getColor$1 = function getColor(index) {
  if (index === 0) {
    return giphyDarkCharcoal;
  }

  if (index % 2 === 0) {
    return giphyDarkestGrey;
  }

  if (index % 1 === 0) {
    return giphyDarkGrey;
  }

  return giphyDarkCharcoal;
};

var SelectableButton = styled(Button$2)(function (_ref) {
  var index = _ref.index,
      selected = _ref.selected,
      isOtherHovered = _ref.isOtherHovered;
  return css$6(["position:relative;background:", ";color:", ";", ";&:before{content:'';position:absolute;top:0;left:0;right:0;bottom:0;background:black;opacity:", ";pointer-events:none;}"], selected ? giphyGreen : getColor$1(index), selected ? giphyBlack : giphyWhite, !isMobile$1 && css$6(["&:hover{background:", ";color:", ";}"], giphyGreen, giphyBlack), isOtherHovered && selected ? 0.1 : 0);
});

var ButtonGroupButton = function ButtonGroupButton(_ref2) {
  var className = _ref2.className,
      index = _ref2.index,
      selected = _ref2.selected,
      label = _ref2.label,
      onClick = _ref2.onClick,
      isOtherHovered = _ref2.isOtherHovered,
      onMouseOver = _ref2.onMouseOver,
      children = _ref2.children;
  return React.createElement(SelectableButton, _extends_1({
    type: "button"
  }, {
    className: className,
    index: index,
    selected: selected,
    onClick: onClick,
    onTouchEnd: onClick,
    isOtherHovered: isOtherHovered,
    onMouseOver: onMouseOver
  }), label || children);
};

function ownKeys$2(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread$2(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys$2(source, true).forEach(function (key) { defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys$2(source).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _templateObject$F() {
  var data = taggedTemplateLiteral(["\n    display: flex;\n"]);

  _templateObject$F = function _templateObject() {
    return data;
  };

  return data;
}
var Container$p = styled.div(_templateObject$F());

var ButtonGroup =
/*#__PURE__*/
function (_PureComponent) {
  inherits(ButtonGroup, _PureComponent);

  function ButtonGroup(props) {
    var _this;

    classCallCheck(this, ButtonGroup);

    _this = possibleConstructorReturn(this, getPrototypeOf(ButtonGroup).call(this, props));
    var _this$props$defaultSe = _this.props.defaultSelectedIndex,
        defaultSelectedIndex = _this$props$defaultSe === void 0 ? -1 : _this$props$defaultSe;
    _this.state = {
      selectedIndex: defaultSelectedIndex,
      hoveredIndex: -1
    };
    return _this;
  }

  createClass(ButtonGroup, [{
    key: "render",
    value: function render() {
      var _this2 = this;

      var _this$props = this.props,
          children = _this$props.children,
          className = _this$props.className,
          buttonProps = _this$props.buttonProps;
      var _this$state = this.state,
          selectedIndex = _this$state.selectedIndex,
          hoveredIndex = _this$state.hoveredIndex;
      return React.createElement(Container$p, {
        className: className,
        onMouseLeave: function onMouseLeave() {
          return _this2.setState({
            hoveredIndex: -1
          });
        }
      }, Children.toArray(children).map(function (child, index) {
        return cloneElement(child, _objectSpread$2({
          onClick: function onClick() {
            var _child$props$onClick = child.props.onClick,
                onClick = _child$props$onClick === void 0 ? function () {} : _child$props$onClick;

            _this2.setState({
              selectedIndex: index
            });

            onClick(index);
          },
          onMouseOver: function onMouseOver() {
            return _this2.setState({
              hoveredIndex: index
            });
          },
          selected: index === selectedIndex,
          isOtherHovered: hoveredIndex !== -1 && hoveredIndex !== index,
          index: index
        }, buttonProps));
      }));
    }
  }]);

  return ButtonGroup;
}(PureComponent);

defineProperty(ButtonGroup, "Button", ButtonGroupButton);

defineProperty(ButtonGroup, "propTypes", {
  buttonProps: PropTypes.object,
  defaultSelectedIndex: PropTypes.number
});

var InputButton = function InputButton(_ref) {
  var name = _ref.name,
      index = _ref.index,
      selected = _ref.selected,
      val = _ref.val,
      label = _ref.label,
      onClick = _ref.onClick,
      isOtherHovered = _ref.isOtherHovered,
      onMouseOver = _ref.onMouseOver,
      className = _ref.className;
  return React.createElement(React.Fragment, null, React.createElement(ButtonGroup.Button, _extends_1({
    type: "button"
  }, {
    index: index,
    selected: selected,
    onClick: onClick,
    onTouchEnd: onClick,
    isOtherHovered: isOtherHovered,
    onMouseOver: onMouseOver,
    className: className
  }), label || val), selected && React.createElement("input", {
    hidden: true,
    name: name,
    readOnly: true,
    value: val
  }));
};

InputButton.propTypes = {
  name: PropTypes.string,
  index: PropTypes.number,
  selected: PropTypes.bool,
  isOtherHovered: PropTypes.bool,
  onClick: PropTypes.func,
  onMouseOver: PropTypes.func
};

// polyfill
var colors = colorsForExp;

export { AnimatedButton, Attribution, Button$2 as Button, ButtonGroup, CopyButton, CornerCutout, DatePicker, Dropdown, EditableTextfield as EditableTextField, EditableTextfield$1 as EllipsisDropdown, Gif, IconTooltip, Input, InputButton, SearchBar, SectionHeader, SelectDropdown, SelectList, Button$3 as StateButton, StoryListItem, StoryPreview, Subheader, SubheaderSmall, Title, TitleLarge, TitleSmall, Toggle, Tooltip, Verified as VerifiedBadge, index as Video, VideoPreview, VideoPreviewLabel, colors, getIconData as getStoryIcon, largeTitleSize, smallSubheaderSize, smallTitleSize, LINKS as socialLinks, subheaderSize, titleFont, titleSize };
